export default [{
    "ph": 5,
    "nm": 350,
    "abs": 0.24685714285714286
  },
  {
    "ph": 5.1,
    "nm": 350,
    "abs": 0.24428571428571427
  },
  {
    "ph": 5.2,
    "nm": 350,
    "abs": 0.24165714285714285
  },
  {
    "ph": 5.3,
    "nm": 350,
    "abs": 0.2390857142857143
  },
  {
    "ph": 5.4,
    "nm": 350,
    "abs": 0.23645714285714287
  },
  {
    "ph": 5.5,
    "nm": 350,
    "abs": 0.23388571428571428
  },
  {
    "ph": 5.6,
    "nm": 350,
    "abs": 0.23125714285714286
  },
  {
    "ph": 5.7,
    "nm": 350,
    "abs": 0.2286857142857143
  },
  {
    "ph": 5.8,
    "nm": 350,
    "abs": 0.22605714285714287
  },
  {
    "ph": 5.9,
    "nm": 350,
    "abs": 0.2234857142857143
  },
  {
    "ph": 6,
    "nm": 350,
    "abs": 0.22085714285714286
  },
  {
    "ph": 6.1,
    "nm": 350,
    "abs": 0.21828571428571428
  },
  {
    "ph": 6.2,
    "nm": 350,
    "abs": 0.21565714285714285
  },
  {
    "ph": 6.3,
    "nm": 350,
    "abs": 0.2130857142857143
  },
  {
    "ph": 6.4,
    "nm": 350,
    "abs": 0.21045714285714287
  },
  {
    "ph": 6.5,
    "nm": 350,
    "abs": 0.20788571428571428
  },
  {
    "ph": 6.6,
    "nm": 350,
    "abs": 0.20582857142857144
  },
  {
    "ph": 6.7,
    "nm": 350,
    "abs": 0.2037142857142857
  },
  {
    "ph": 6.8,
    "nm": 350,
    "abs": 0.20165714285714284
  },
  {
    "ph": 6.9,
    "nm": 350,
    "abs": 0.19954285714285716
  },
  {
    "ph": 7,
    "nm": 350,
    "abs": 0.1974857142857143
  },
  {
    "ph": 7.1,
    "nm": 350,
    "abs": 0.19537142857142856
  },
  {
    "ph": 7.2,
    "nm": 350,
    "abs": 0.19331428571428572
  },
  {
    "ph": 7.3,
    "nm": 350,
    "abs": 0.1912
  },
  {
    "ph": 7.4,
    "nm": 350,
    "abs": 0.18914285714285714
  },
  {
    "ph": 7.5,
    "nm": 350,
    "abs": 0.1870857142857143
  },
  {
    "ph": 7.6,
    "nm": 350,
    "abs": 0.18497142857142856
  },
  {
    "ph": 7.7,
    "nm": 350,
    "abs": 0.18291428571428572
  },
  {
    "ph": 7.8,
    "nm": 350,
    "abs": 0.18080000000000002
  },
  {
    "ph": 7.9,
    "nm": 350,
    "abs": 0.17874285714285715
  },
  {
    "ph": 8,
    "nm": 350,
    "abs": 0.1766285714285714
  },
  {
    "ph": 5,
    "nm": 355,
    "abs": 0.2524571428571429
  },
  {
    "ph": 5.1,
    "nm": 355,
    "abs": 0.2506857142857143
  },
  {
    "ph": 5.2,
    "nm": 355,
    "abs": 0.24897142857142857
  },
  {
    "ph": 5.3,
    "nm": 355,
    "abs": 0.24725714285714284
  },
  {
    "ph": 5.4,
    "nm": 355,
    "abs": 0.24548571428571428
  },
  {
    "ph": 5.5,
    "nm": 355,
    "abs": 0.24377142857142856
  },
  {
    "ph": 5.6,
    "nm": 355,
    "abs": 0.242
  },
  {
    "ph": 5.7,
    "nm": 355,
    "abs": 0.24028571428571427
  },
  {
    "ph": 5.8,
    "nm": 355,
    "abs": 0.23857142857142857
  },
  {
    "ph": 5.9,
    "nm": 355,
    "abs": 0.23679999999999998
  },
  {
    "ph": 6,
    "nm": 355,
    "abs": 0.2350857142857143
  },
  {
    "ph": 6.1,
    "nm": 355,
    "abs": 0.23337142857142856
  },
  {
    "ph": 6.2,
    "nm": 355,
    "abs": 0.2316
  },
  {
    "ph": 6.3,
    "nm": 355,
    "abs": 0.22988571428571428
  },
  {
    "ph": 6.4,
    "nm": 355,
    "abs": 0.22811428571428571
  },
  {
    "ph": 6.5,
    "nm": 355,
    "abs": 0.2264
  },
  {
    "ph": 6.6,
    "nm": 355,
    "abs": 0.2246857142857143
  },
  {
    "ph": 6.7,
    "nm": 355,
    "abs": 0.2229142857142857
  },
  {
    "ph": 6.8,
    "nm": 355,
    "abs": 0.2212
  },
  {
    "ph": 6.9,
    "nm": 355,
    "abs": 0.21948571428571428
  },
  {
    "ph": 7,
    "nm": 355,
    "abs": 0.21771428571428572
  },
  {
    "ph": 7.1,
    "nm": 355,
    "abs": 0.216
  },
  {
    "ph": 7.2,
    "nm": 355,
    "abs": 0.2141714285714286
  },
  {
    "ph": 7.3,
    "nm": 355,
    "abs": 0.2110857142857143
  },
  {
    "ph": 7.4,
    "nm": 355,
    "abs": 0.208
  },
  {
    "ph": 7.5,
    "nm": 355,
    "abs": 0.2049142857142857
  },
  {
    "ph": 7.6,
    "nm": 355,
    "abs": 0.20177142857142857
  },
  {
    "ph": 7.7,
    "nm": 355,
    "abs": 0.1986857142857143
  },
  {
    "ph": 7.8,
    "nm": 355,
    "abs": 0.1956
  },
  {
    "ph": 7.9,
    "nm": 355,
    "abs": 0.1925142857142857
  },
  {
    "ph": 8,
    "nm": 355,
    "abs": 0.18942857142857145
  },
  {
    "ph": 5,
    "nm": 360,
    "abs": 0.25497142857142857
  },
  {
    "ph": 5.1,
    "nm": 360,
    "abs": 0.2550857142857143
  },
  {
    "ph": 5.2,
    "nm": 360,
    "abs": 0.2552
  },
  {
    "ph": 5.3,
    "nm": 360,
    "abs": 0.2553142857142857
  },
  {
    "ph": 5.4,
    "nm": 360,
    "abs": 0.25542857142857145
  },
  {
    "ph": 5.5,
    "nm": 360,
    "abs": 0.2555428571428571
  },
  {
    "ph": 5.6,
    "nm": 360,
    "abs": 0.25565714285714286
  },
  {
    "ph": 5.7,
    "nm": 360,
    "abs": 0.2557714285714286
  },
  {
    "ph": 5.8,
    "nm": 360,
    "abs": 0.25588571428571427
  },
  {
    "ph": 5.9,
    "nm": 360,
    "abs": 0.256
  },
  {
    "ph": 6,
    "nm": 360,
    "abs": 0.25605714285714287
  },
  {
    "ph": 6.1,
    "nm": 360,
    "abs": 0.254
  },
  {
    "ph": 6.2,
    "nm": 360,
    "abs": 0.25148571428571426
  },
  {
    "ph": 6.3,
    "nm": 360,
    "abs": 0.24902857142857143
  },
  {
    "ph": 6.4,
    "nm": 360,
    "abs": 0.24657142857142858
  },
  {
    "ph": 6.5,
    "nm": 360,
    "abs": 0.24411428571428573
  },
  {
    "ph": 6.6,
    "nm": 360,
    "abs": 0.2416
  },
  {
    "ph": 6.7,
    "nm": 360,
    "abs": 0.23914285714285713
  },
  {
    "ph": 6.8,
    "nm": 360,
    "abs": 0.2366857142857143
  },
  {
    "ph": 6.9,
    "nm": 360,
    "abs": 0.23417142857142856
  },
  {
    "ph": 7,
    "nm": 360,
    "abs": 0.23171428571428573
  },
  {
    "ph": 7.1,
    "nm": 360,
    "abs": 0.22925714285714285
  },
  {
    "ph": 7.2,
    "nm": 360,
    "abs": 0.22679999999999997
  },
  {
    "ph": 7.3,
    "nm": 360,
    "abs": 0.22428571428571428
  },
  {
    "ph": 7.4,
    "nm": 360,
    "abs": 0.22182857142857143
  },
  {
    "ph": 7.5,
    "nm": 360,
    "abs": 0.21937142857142858
  },
  {
    "ph": 7.6,
    "nm": 360,
    "abs": 0.2169142857142857
  },
  {
    "ph": 7.7,
    "nm": 360,
    "abs": 0.21439999999999998
  },
  {
    "ph": 7.8,
    "nm": 360,
    "abs": 0.21194285714285716
  },
  {
    "ph": 7.9,
    "nm": 360,
    "abs": 0.20948571428571428
  },
  {
    "ph": 8,
    "nm": 360,
    "abs": 0.20702857142857142
  },
  {
    "ph": 5,
    "nm": 365,
    "abs": 0.2591428571428572
  },
  {
    "ph": 5.1,
    "nm": 365,
    "abs": 0.26057142857142856
  },
  {
    "ph": 5.2,
    "nm": 365,
    "abs": 0.262
  },
  {
    "ph": 5.3,
    "nm": 365,
    "abs": 0.26342857142857146
  },
  {
    "ph": 5.4,
    "nm": 365,
    "abs": 0.26485714285714285
  },
  {
    "ph": 5.5,
    "nm": 365,
    "abs": 0.2662857142857143
  },
  {
    "ph": 5.6,
    "nm": 365,
    "abs": 0.26771428571428574
  },
  {
    "ph": 5.7,
    "nm": 365,
    "abs": 0.26914285714285713
  },
  {
    "ph": 5.8,
    "nm": 365,
    "abs": 0.2705714285714286
  },
  {
    "ph": 5.9,
    "nm": 365,
    "abs": 0.27199999999999996
  },
  {
    "ph": 6,
    "nm": 365,
    "abs": 0.2734285714285714
  },
  {
    "ph": 6.1,
    "nm": 365,
    "abs": 0.27302857142857145
  },
  {
    "ph": 6.2,
    "nm": 365,
    "abs": 0.27034285714285716
  },
  {
    "ph": 6.3,
    "nm": 365,
    "abs": 0.26771428571428574
  },
  {
    "ph": 6.4,
    "nm": 365,
    "abs": 0.26502857142857145
  },
  {
    "ph": 6.5,
    "nm": 365,
    "abs": 0.26234285714285716
  },
  {
    "ph": 6.6,
    "nm": 365,
    "abs": 0.25965714285714286
  },
  {
    "ph": 6.7,
    "nm": 365,
    "abs": 0.2569714285714286
  },
  {
    "ph": 6.8,
    "nm": 365,
    "abs": 0.2542857142857143
  },
  {
    "ph": 6.9,
    "nm": 365,
    "abs": 0.2516
  },
  {
    "ph": 7,
    "nm": 365,
    "abs": 0.2489142857142857
  },
  {
    "ph": 7.1,
    "nm": 365,
    "abs": 0.24622857142857144
  },
  {
    "ph": 7.2,
    "nm": 365,
    "abs": 0.2436
  },
  {
    "ph": 7.3,
    "nm": 365,
    "abs": 0.2409142857142857
  },
  {
    "ph": 7.4,
    "nm": 365,
    "abs": 0.23822857142857143
  },
  {
    "ph": 7.5,
    "nm": 365,
    "abs": 0.23554285714285714
  },
  {
    "ph": 7.6,
    "nm": 365,
    "abs": 0.23285714285714285
  },
  {
    "ph": 7.7,
    "nm": 365,
    "abs": 0.23017142857142855
  },
  {
    "ph": 7.8,
    "nm": 365,
    "abs": 0.2274857142857143
  },
  {
    "ph": 7.9,
    "nm": 365,
    "abs": 0.22480000000000003
  },
  {
    "ph": 8,
    "nm": 365,
    "abs": 0.2221142857142857
  },
  {
    "ph": 5,
    "nm": 370,
    "abs": 0.264
  },
  {
    "ph": 5.1,
    "nm": 370,
    "abs": 0.2667428571428571
  },
  {
    "ph": 5.2,
    "nm": 370,
    "abs": 0.2694857142857143
  },
  {
    "ph": 5.3,
    "nm": 370,
    "abs": 0.27222857142857143
  },
  {
    "ph": 5.4,
    "nm": 370,
    "abs": 0.2749714285714286
  },
  {
    "ph": 5.5,
    "nm": 370,
    "abs": 0.2777142857142857
  },
  {
    "ph": 5.6,
    "nm": 370,
    "abs": 0.28045714285714285
  },
  {
    "ph": 5.7,
    "nm": 370,
    "abs": 0.2832
  },
  {
    "ph": 5.8,
    "nm": 370,
    "abs": 0.2859428571428571
  },
  {
    "ph": 5.9,
    "nm": 370,
    "abs": 0.28868571428571427
  },
  {
    "ph": 6,
    "nm": 370,
    "abs": 0.2914285714285714
  },
  {
    "ph": 6.1,
    "nm": 370,
    "abs": 0.2921142857142857
  },
  {
    "ph": 6.2,
    "nm": 370,
    "abs": 0.2892571428571428
  },
  {
    "ph": 6.3,
    "nm": 370,
    "abs": 0.2863428571428571
  },
  {
    "ph": 6.4,
    "nm": 370,
    "abs": 0.2834285714285714
  },
  {
    "ph": 6.5,
    "nm": 370,
    "abs": 0.2805714285714286
  },
  {
    "ph": 6.6,
    "nm": 370,
    "abs": 0.2776571428571429
  },
  {
    "ph": 6.7,
    "nm": 370,
    "abs": 0.2748
  },
  {
    "ph": 6.8,
    "nm": 370,
    "abs": 0.2718857142857143
  },
  {
    "ph": 6.9,
    "nm": 370,
    "abs": 0.26902857142857145
  },
  {
    "ph": 7,
    "nm": 370,
    "abs": 0.2661142857142857
  },
  {
    "ph": 7.1,
    "nm": 370,
    "abs": 0.26325714285714286
  },
  {
    "ph": 7.2,
    "nm": 370,
    "abs": 0.26034285714285715
  },
  {
    "ph": 7.3,
    "nm": 370,
    "abs": 0.25748571428571426
  },
  {
    "ph": 7.4,
    "nm": 370,
    "abs": 0.25457142857142856
  },
  {
    "ph": 7.5,
    "nm": 370,
    "abs": 0.2517142857142857
  },
  {
    "ph": 7.6,
    "nm": 370,
    "abs": 0.2488
  },
  {
    "ph": 7.7,
    "nm": 370,
    "abs": 0.24594285714285716
  },
  {
    "ph": 7.8,
    "nm": 370,
    "abs": 0.24302857142857143
  },
  {
    "ph": 7.9,
    "nm": 370,
    "abs": 0.24017142857142856
  },
  {
    "ph": 8,
    "nm": 370,
    "abs": 0.23725714285714286
  },
  {
    "ph": 5,
    "nm": 375,
    "abs": 0.2910285714285714
  },
  {
    "ph": 5.1,
    "nm": 375,
    "abs": 0.29302857142857147
  },
  {
    "ph": 5.2,
    "nm": 375,
    "abs": 0.2950857142857143
  },
  {
    "ph": 5.3,
    "nm": 375,
    "abs": 0.2970857142857143
  },
  {
    "ph": 5.4,
    "nm": 375,
    "abs": 0.2991428571428571
  },
  {
    "ph": 5.5,
    "nm": 375,
    "abs": 0.30114285714285716
  },
  {
    "ph": 5.6,
    "nm": 375,
    "abs": 0.30319999999999997
  },
  {
    "ph": 5.7,
    "nm": 375,
    "abs": 0.3052
  },
  {
    "ph": 5.8,
    "nm": 375,
    "abs": 0.30725714285714284
  },
  {
    "ph": 5.9,
    "nm": 375,
    "abs": 0.30925714285714284
  },
  {
    "ph": 6,
    "nm": 375,
    "abs": 0.3113142857142857
  },
  {
    "ph": 6.1,
    "nm": 375,
    "abs": 0.3112
  },
  {
    "ph": 6.2,
    "nm": 375,
    "abs": 0.30811428571428573
  },
  {
    "ph": 6.3,
    "nm": 375,
    "abs": 0.30497142857142856
  },
  {
    "ph": 6.4,
    "nm": 375,
    "abs": 0.30188571428571426
  },
  {
    "ph": 6.5,
    "nm": 375,
    "abs": 0.2988
  },
  {
    "ph": 6.6,
    "nm": 375,
    "abs": 0.2957142857142857
  },
  {
    "ph": 6.7,
    "nm": 375,
    "abs": 0.2926285714285714
  },
  {
    "ph": 6.8,
    "nm": 375,
    "abs": 0.28954285714285716
  },
  {
    "ph": 6.9,
    "nm": 375,
    "abs": 0.28645714285714285
  },
  {
    "ph": 7,
    "nm": 375,
    "abs": 0.28337142857142855
  },
  {
    "ph": 7.1,
    "nm": 375,
    "abs": 0.28022857142857144
  },
  {
    "ph": 7.2,
    "nm": 375,
    "abs": 0.27714285714285714
  },
  {
    "ph": 7.3,
    "nm": 375,
    "abs": 0.2740571428571429
  },
  {
    "ph": 7.4,
    "nm": 375,
    "abs": 0.2709714285714286
  },
  {
    "ph": 7.5,
    "nm": 375,
    "abs": 0.2678857142857143
  },
  {
    "ph": 7.6,
    "nm": 375,
    "abs": 0.2648
  },
  {
    "ph": 7.7,
    "nm": 375,
    "abs": 0.26171428571428573
  },
  {
    "ph": 7.8,
    "nm": 375,
    "abs": 0.25862857142857143
  },
  {
    "ph": 7.9,
    "nm": 375,
    "abs": 0.25548571428571426
  },
  {
    "ph": 8,
    "nm": 375,
    "abs": 0.2524
  },
  {
    "ph": 5,
    "nm": 380,
    "abs": 0.3193142857142857
  },
  {
    "ph": 5.1,
    "nm": 380,
    "abs": 0.32045714285714283
  },
  {
    "ph": 5.2,
    "nm": 380,
    "abs": 0.3216571428571428
  },
  {
    "ph": 5.3,
    "nm": 380,
    "abs": 0.3228
  },
  {
    "ph": 5.4,
    "nm": 380,
    "abs": 0.32394285714285714
  },
  {
    "ph": 5.5,
    "nm": 380,
    "abs": 0.3251428571428571
  },
  {
    "ph": 5.6,
    "nm": 380,
    "abs": 0.32628571428571423
  },
  {
    "ph": 5.7,
    "nm": 380,
    "abs": 0.3274285714285714
  },
  {
    "ph": 5.8,
    "nm": 380,
    "abs": 0.32857142857142857
  },
  {
    "ph": 5.9,
    "nm": 380,
    "abs": 0.32977142857142855
  },
  {
    "ph": 6,
    "nm": 380,
    "abs": 0.33091428571428566
  },
  {
    "ph": 6.1,
    "nm": 380,
    "abs": 0.3302285714285714
  },
  {
    "ph": 6.2,
    "nm": 380,
    "abs": 0.3269714285714286
  },
  {
    "ph": 6.3,
    "nm": 380,
    "abs": 0.32365714285714287
  },
  {
    "ph": 6.4,
    "nm": 380,
    "abs": 0.32034285714285715
  },
  {
    "ph": 6.5,
    "nm": 380,
    "abs": 0.3170285714285714
  },
  {
    "ph": 6.6,
    "nm": 380,
    "abs": 0.3137714285714286
  },
  {
    "ph": 6.7,
    "nm": 380,
    "abs": 0.3104571428571429
  },
  {
    "ph": 6.8,
    "nm": 380,
    "abs": 0.3071428571428571
  },
  {
    "ph": 6.9,
    "nm": 380,
    "abs": 0.3038285714285714
  },
  {
    "ph": 7,
    "nm": 380,
    "abs": 0.3005714285714286
  },
  {
    "ph": 7.1,
    "nm": 380,
    "abs": 0.29725714285714283
  },
  {
    "ph": 7.2,
    "nm": 380,
    "abs": 0.2939428571428571
  },
  {
    "ph": 7.3,
    "nm": 380,
    "abs": 0.29062857142857146
  },
  {
    "ph": 7.4,
    "nm": 380,
    "abs": 0.28737142857142856
  },
  {
    "ph": 7.5,
    "nm": 380,
    "abs": 0.28405714285714284
  },
  {
    "ph": 7.6,
    "nm": 380,
    "abs": 0.2807428571428571
  },
  {
    "ph": 7.7,
    "nm": 380,
    "abs": 0.2774285714285714
  },
  {
    "ph": 7.8,
    "nm": 380,
    "abs": 0.27417142857142857
  },
  {
    "ph": 7.9,
    "nm": 380,
    "abs": 0.27085714285714285
  },
  {
    "ph": 8,
    "nm": 380,
    "abs": 0.26754285714285714
  },
  {
    "ph": 5,
    "nm": 385,
    "abs": 0.34759999999999996
  },
  {
    "ph": 5.1,
    "nm": 385,
    "abs": 0.34794285714285716
  },
  {
    "ph": 5.2,
    "nm": 385,
    "abs": 0.34822857142857144
  },
  {
    "ph": 5.3,
    "nm": 385,
    "abs": 0.3485142857142857
  },
  {
    "ph": 5.4,
    "nm": 385,
    "abs": 0.34880000000000005
  },
  {
    "ph": 5.5,
    "nm": 385,
    "abs": 0.3490857142857143
  },
  {
    "ph": 5.6,
    "nm": 385,
    "abs": 0.3493714285714286
  },
  {
    "ph": 5.7,
    "nm": 385,
    "abs": 0.34965714285714283
  },
  {
    "ph": 5.8,
    "nm": 385,
    "abs": 0.34994285714285717
  },
  {
    "ph": 5.9,
    "nm": 385,
    "abs": 0.35022857142857144
  },
  {
    "ph": 6,
    "nm": 385,
    "abs": 0.35051428571428567
  },
  {
    "ph": 6.1,
    "nm": 385,
    "abs": 0.3493142857142857
  },
  {
    "ph": 6.2,
    "nm": 385,
    "abs": 0.34582857142857143
  },
  {
    "ph": 6.3,
    "nm": 385,
    "abs": 0.34228571428571425
  },
  {
    "ph": 6.4,
    "nm": 385,
    "abs": 0.3388
  },
  {
    "ph": 6.5,
    "nm": 385,
    "abs": 0.33531428571428573
  },
  {
    "ph": 6.6,
    "nm": 385,
    "abs": 0.33177142857142855
  },
  {
    "ph": 6.7,
    "nm": 385,
    "abs": 0.3282857142857143
  },
  {
    "ph": 6.8,
    "nm": 385,
    "abs": 0.32480000000000003
  },
  {
    "ph": 6.9,
    "nm": 385,
    "abs": 0.32125714285714285
  },
  {
    "ph": 7,
    "nm": 385,
    "abs": 0.3177714285714286
  },
  {
    "ph": 7.1,
    "nm": 385,
    "abs": 0.31422857142857147
  },
  {
    "ph": 7.2,
    "nm": 385,
    "abs": 0.3107428571428571
  },
  {
    "ph": 7.3,
    "nm": 385,
    "abs": 0.30725714285714284
  },
  {
    "ph": 7.4,
    "nm": 385,
    "abs": 0.3037142857142857
  },
  {
    "ph": 7.5,
    "nm": 385,
    "abs": 0.3002285714285714
  },
  {
    "ph": 7.6,
    "nm": 385,
    "abs": 0.29674285714285714
  },
  {
    "ph": 7.7,
    "nm": 385,
    "abs": 0.2932
  },
  {
    "ph": 7.8,
    "nm": 385,
    "abs": 0.2897142857142857
  },
  {
    "ph": 7.9,
    "nm": 385,
    "abs": 0.2861714285714286
  },
  {
    "ph": 8,
    "nm": 385,
    "abs": 0.28268571428571426
  },
  {
    "ph": 5,
    "nm": 390,
    "abs": 0.3759428571428572
  },
  {
    "ph": 5.1,
    "nm": 390,
    "abs": 0.3753714285714286
  },
  {
    "ph": 5.2,
    "nm": 390,
    "abs": 0.3748
  },
  {
    "ph": 5.3,
    "nm": 390,
    "abs": 0.3741714285714286
  },
  {
    "ph": 5.4,
    "nm": 390,
    "abs": 0.37360000000000004
  },
  {
    "ph": 5.5,
    "nm": 390,
    "abs": 0.37302857142857143
  },
  {
    "ph": 5.6,
    "nm": 390,
    "abs": 0.3724571428571429
  },
  {
    "ph": 5.7,
    "nm": 390,
    "abs": 0.3718857142857143
  },
  {
    "ph": 5.8,
    "nm": 390,
    "abs": 0.37131428571428576
  },
  {
    "ph": 5.9,
    "nm": 390,
    "abs": 0.37074285714285715
  },
  {
    "ph": 6,
    "nm": 390,
    "abs": 0.3701714285714286
  },
  {
    "ph": 6.1,
    "nm": 390,
    "abs": 0.3684
  },
  {
    "ph": 6.2,
    "nm": 390,
    "abs": 0.3646857142857143
  },
  {
    "ph": 6.3,
    "nm": 390,
    "abs": 0.3609714285714286
  },
  {
    "ph": 6.4,
    "nm": 390,
    "abs": 0.35725714285714283
  },
  {
    "ph": 6.5,
    "nm": 390,
    "abs": 0.35354285714285716
  },
  {
    "ph": 6.6,
    "nm": 390,
    "abs": 0.34982857142857143
  },
  {
    "ph": 6.7,
    "nm": 390,
    "abs": 0.3461142857142857
  },
  {
    "ph": 6.8,
    "nm": 390,
    "abs": 0.3424
  },
  {
    "ph": 6.9,
    "nm": 390,
    "abs": 0.3386857142857143
  },
  {
    "ph": 7,
    "nm": 390,
    "abs": 0.3349714285714286
  },
  {
    "ph": 7.1,
    "nm": 390,
    "abs": 0.33125714285714286
  },
  {
    "ph": 7.2,
    "nm": 390,
    "abs": 0.3275428571428572
  },
  {
    "ph": 7.3,
    "nm": 390,
    "abs": 0.3238285714285714
  },
  {
    "ph": 7.4,
    "nm": 390,
    "abs": 0.32011428571428574
  },
  {
    "ph": 7.5,
    "nm": 390,
    "abs": 0.31639999999999996
  },
  {
    "ph": 7.6,
    "nm": 390,
    "abs": 0.3126857142857143
  },
  {
    "ph": 7.7,
    "nm": 390,
    "abs": 0.30897142857142856
  },
  {
    "ph": 7.8,
    "nm": 390,
    "abs": 0.30525714285714284
  },
  {
    "ph": 7.9,
    "nm": 390,
    "abs": 0.3015428571428571
  },
  {
    "ph": 8,
    "nm": 390,
    "abs": 0.29782857142857144
  },
  {
    "ph": 5,
    "nm": 395,
    "abs": 0.40422857142857144
  },
  {
    "ph": 5.1,
    "nm": 395,
    "abs": 0.4028
  },
  {
    "ph": 5.2,
    "nm": 395,
    "abs": 0.4013714285714286
  },
  {
    "ph": 5.3,
    "nm": 395,
    "abs": 0.3998857142857143
  },
  {
    "ph": 5.4,
    "nm": 395,
    "abs": 0.3984571428571429
  },
  {
    "ph": 5.5,
    "nm": 395,
    "abs": 0.3970285714285714
  },
  {
    "ph": 5.6,
    "nm": 395,
    "abs": 0.39554285714285714
  },
  {
    "ph": 5.7,
    "nm": 395,
    "abs": 0.3941142857142857
  },
  {
    "ph": 5.8,
    "nm": 395,
    "abs": 0.3926857142857143
  },
  {
    "ph": 5.9,
    "nm": 395,
    "abs": 0.3912
  },
  {
    "ph": 6,
    "nm": 395,
    "abs": 0.3897714285714286
  },
  {
    "ph": 6.1,
    "nm": 395,
    "abs": 0.38834285714285716
  },
  {
    "ph": 6.2,
    "nm": 395,
    "abs": 0.3862857142857143
  },
  {
    "ph": 6.3,
    "nm": 395,
    "abs": 0.38194285714285714
  },
  {
    "ph": 6.4,
    "nm": 395,
    "abs": 0.37760000000000005
  },
  {
    "ph": 6.5,
    "nm": 395,
    "abs": 0.37325714285714284
  },
  {
    "ph": 6.6,
    "nm": 395,
    "abs": 0.36885714285714283
  },
  {
    "ph": 6.7,
    "nm": 395,
    "abs": 0.36451428571428574
  },
  {
    "ph": 6.8,
    "nm": 395,
    "abs": 0.36017142857142853
  },
  {
    "ph": 6.9,
    "nm": 395,
    "abs": 0.35577142857142857
  },
  {
    "ph": 7,
    "nm": 395,
    "abs": 0.3514285714285714
  },
  {
    "ph": 7.1,
    "nm": 395,
    "abs": 0.34708571428571433
  },
  {
    "ph": 7.2,
    "nm": 395,
    "abs": 0.3427428571428571
  },
  {
    "ph": 7.3,
    "nm": 395,
    "abs": 0.3383428571428571
  },
  {
    "ph": 7.4,
    "nm": 395,
    "abs": 0.334
  },
  {
    "ph": 7.5,
    "nm": 395,
    "abs": 0.3296571428571428
  },
  {
    "ph": 7.6,
    "nm": 395,
    "abs": 0.3253142857142857
  },
  {
    "ph": 7.7,
    "nm": 395,
    "abs": 0.3209142857142857
  },
  {
    "ph": 7.8,
    "nm": 395,
    "abs": 0.3165714285714286
  },
  {
    "ph": 7.9,
    "nm": 395,
    "abs": 0.3122285714285714
  },
  {
    "ph": 8,
    "nm": 395,
    "abs": 0.3078285714285714
  },
  {
    "ph": 5,
    "nm": 400,
    "abs": 0.4353142857142857
  },
  {
    "ph": 5.1,
    "nm": 400,
    "abs": 0.4322857142857143
  },
  {
    "ph": 5.2,
    "nm": 400,
    "abs": 0.42919999999999997
  },
  {
    "ph": 5.3,
    "nm": 400,
    "abs": 0.4261714285714286
  },
  {
    "ph": 5.4,
    "nm": 400,
    "abs": 0.42314285714285715
  },
  {
    "ph": 5.5,
    "nm": 400,
    "abs": 0.4201142857142857
  },
  {
    "ph": 5.6,
    "nm": 400,
    "abs": 0.4170857142857143
  },
  {
    "ph": 5.7,
    "nm": 400,
    "abs": 0.41400000000000003
  },
  {
    "ph": 5.8,
    "nm": 400,
    "abs": 0.41097142857142854
  },
  {
    "ph": 5.9,
    "nm": 400,
    "abs": 0.4079428571428571
  },
  {
    "ph": 6,
    "nm": 400,
    "abs": 0.4049142857142857
  },
  {
    "ph": 6.1,
    "nm": 400,
    "abs": 0.4018285714285715
  },
  {
    "ph": 6.2,
    "nm": 400,
    "abs": 0.3988
  },
  {
    "ph": 6.3,
    "nm": 400,
    "abs": 0.39577142857142855
  },
  {
    "ph": 6.4,
    "nm": 400,
    "abs": 0.39274285714285717
  },
  {
    "ph": 6.5,
    "nm": 400,
    "abs": 0.3896571428571428
  },
  {
    "ph": 6.6,
    "nm": 400,
    "abs": 0.38662857142857143
  },
  {
    "ph": 6.7,
    "nm": 400,
    "abs": 0.3836
  },
  {
    "ph": 6.8,
    "nm": 400,
    "abs": 0.3805714285714286
  },
  {
    "ph": 6.9,
    "nm": 400,
    "abs": 0.37748571428571426
  },
  {
    "ph": 7,
    "nm": 400,
    "abs": 0.3744571428571429
  },
  {
    "ph": 7.1,
    "nm": 400,
    "abs": 0.37142857142857144
  },
  {
    "ph": 7.2,
    "nm": 400,
    "abs": 0.3684
  },
  {
    "ph": 7.3,
    "nm": 400,
    "abs": 0.3649142857142857
  },
  {
    "ph": 7.4,
    "nm": 400,
    "abs": 0.3550857142857143
  },
  {
    "ph": 7.5,
    "nm": 400,
    "abs": 0.3453142857142857
  },
  {
    "ph": 7.6,
    "nm": 400,
    "abs": 0.3354857142857143
  },
  {
    "ph": 7.7,
    "nm": 400,
    "abs": 0.3257142857142857
  },
  {
    "ph": 7.8,
    "nm": 400,
    "abs": 0.31588571428571427
  },
  {
    "ph": 7.9,
    "nm": 400,
    "abs": 0.30611428571428567
  },
  {
    "ph": 8,
    "nm": 400,
    "abs": 0.29628571428571426
  },
  {
    "ph": 5,
    "nm": 405,
    "abs": 0.46240000000000003
  },
  {
    "ph": 5.1,
    "nm": 405,
    "abs": 0.4588
  },
  {
    "ph": 5.2,
    "nm": 405,
    "abs": 0.4552
  },
  {
    "ph": 5.3,
    "nm": 405,
    "abs": 0.4516
  },
  {
    "ph": 5.4,
    "nm": 405,
    "abs": 0.448
  },
  {
    "ph": 5.5,
    "nm": 405,
    "abs": 0.44439999999999996
  },
  {
    "ph": 5.6,
    "nm": 405,
    "abs": 0.44079999999999997
  },
  {
    "ph": 5.7,
    "nm": 405,
    "abs": 0.4372
  },
  {
    "ph": 5.8,
    "nm": 405,
    "abs": 0.43360000000000004
  },
  {
    "ph": 5.9,
    "nm": 405,
    "abs": 0.43
  },
  {
    "ph": 6,
    "nm": 405,
    "abs": 0.4264
  },
  {
    "ph": 6.1,
    "nm": 405,
    "abs": 0.4228
  },
  {
    "ph": 6.2,
    "nm": 405,
    "abs": 0.4192
  },
  {
    "ph": 6.3,
    "nm": 405,
    "abs": 0.41559999999999997
  },
  {
    "ph": 6.4,
    "nm": 405,
    "abs": 0.412
  },
  {
    "ph": 6.5,
    "nm": 405,
    "abs": 0.4084
  },
  {
    "ph": 6.6,
    "nm": 405,
    "abs": 0.4048
  },
  {
    "ph": 6.7,
    "nm": 405,
    "abs": 0.40119999999999995
  },
  {
    "ph": 6.8,
    "nm": 405,
    "abs": 0.3976
  },
  {
    "ph": 6.9,
    "nm": 405,
    "abs": 0.394
  },
  {
    "ph": 7,
    "nm": 405,
    "abs": 0.3904
  },
  {
    "ph": 7.1,
    "nm": 405,
    "abs": 0.3868
  },
  {
    "ph": 7.2,
    "nm": 405,
    "abs": 0.38194285714285714
  },
  {
    "ph": 7.3,
    "nm": 405,
    "abs": 0.37
  },
  {
    "ph": 7.4,
    "nm": 405,
    "abs": 0.358
  },
  {
    "ph": 7.5,
    "nm": 405,
    "abs": 0.34600000000000003
  },
  {
    "ph": 7.6,
    "nm": 405,
    "abs": 0.334
  },
  {
    "ph": 7.7,
    "nm": 405,
    "abs": 0.322
  },
  {
    "ph": 7.8,
    "nm": 405,
    "abs": 0.31
  },
  {
    "ph": 7.9,
    "nm": 405,
    "abs": 0.29805714285714285
  },
  {
    "ph": 8,
    "nm": 405,
    "abs": 0.2860571428571429
  },
  {
    "ph": 5,
    "nm": 410,
    "abs": 0.4896
  },
  {
    "ph": 5.1,
    "nm": 410,
    "abs": 0.48542857142857143
  },
  {
    "ph": 5.2,
    "nm": 410,
    "abs": 0.48119999999999996
  },
  {
    "ph": 5.3,
    "nm": 410,
    "abs": 0.4770285714285714
  },
  {
    "ph": 5.4,
    "nm": 410,
    "abs": 0.47285714285714286
  },
  {
    "ph": 5.5,
    "nm": 410,
    "abs": 0.4686857142857143
  },
  {
    "ph": 5.6,
    "nm": 410,
    "abs": 0.46445714285714285
  },
  {
    "ph": 5.7,
    "nm": 410,
    "abs": 0.4602857142857143
  },
  {
    "ph": 5.8,
    "nm": 410,
    "abs": 0.45611428571428575
  },
  {
    "ph": 5.9,
    "nm": 410,
    "abs": 0.45194285714285715
  },
  {
    "ph": 6,
    "nm": 410,
    "abs": 0.4477142857142857
  },
  {
    "ph": 6.1,
    "nm": 410,
    "abs": 0.4435428571428571
  },
  {
    "ph": 6.2,
    "nm": 410,
    "abs": 0.4393714285714286
  },
  {
    "ph": 6.3,
    "nm": 410,
    "abs": 0.43520000000000003
  },
  {
    "ph": 6.4,
    "nm": 410,
    "abs": 0.43097142857142856
  },
  {
    "ph": 6.5,
    "nm": 410,
    "abs": 0.4268
  },
  {
    "ph": 6.6,
    "nm": 410,
    "abs": 0.42262857142857146
  },
  {
    "ph": 6.7,
    "nm": 410,
    "abs": 0.4184571428571428
  },
  {
    "ph": 6.8,
    "nm": 410,
    "abs": 0.41422857142857145
  },
  {
    "ph": 6.9,
    "nm": 410,
    "abs": 0.41005714285714284
  },
  {
    "ph": 7,
    "nm": 410,
    "abs": 0.3978285714285715
  },
  {
    "ph": 7.1,
    "nm": 410,
    "abs": 0.38554285714285713
  },
  {
    "ph": 7.2,
    "nm": 410,
    "abs": 0.3733142857142857
  },
  {
    "ph": 7.3,
    "nm": 410,
    "abs": 0.3610285714285714
  },
  {
    "ph": 7.4,
    "nm": 410,
    "abs": 0.34880000000000005
  },
  {
    "ph": 7.5,
    "nm": 410,
    "abs": 0.3365142857142857
  },
  {
    "ph": 7.6,
    "nm": 410,
    "abs": 0.3242857142857143
  },
  {
    "ph": 7.7,
    "nm": 410,
    "abs": 0.312
  },
  {
    "ph": 7.8,
    "nm": 410,
    "abs": 0.2997142857142857
  },
  {
    "ph": 7.9,
    "nm": 410,
    "abs": 0.2874857142857143
  },
  {
    "ph": 8,
    "nm": 410,
    "abs": 0.2752
  },
  {
    "ph": 5,
    "nm": 415,
    "abs": 0.5172571428571429
  },
  {
    "ph": 5.1,
    "nm": 415,
    "abs": 0.5124000000000001
  },
  {
    "ph": 5.2,
    "nm": 415,
    "abs": 0.5075428571428572
  },
  {
    "ph": 5.3,
    "nm": 415,
    "abs": 0.5026857142857143
  },
  {
    "ph": 5.4,
    "nm": 415,
    "abs": 0.4978285714285714
  },
  {
    "ph": 5.5,
    "nm": 415,
    "abs": 0.49297142857142856
  },
  {
    "ph": 5.6,
    "nm": 415,
    "abs": 0.48811428571428567
  },
  {
    "ph": 5.7,
    "nm": 415,
    "abs": 0.4832
  },
  {
    "ph": 5.8,
    "nm": 415,
    "abs": 0.4783428571428571
  },
  {
    "ph": 5.9,
    "nm": 415,
    "abs": 0.4734857142857143
  },
  {
    "ph": 6,
    "nm": 415,
    "abs": 0.46862857142857145
  },
  {
    "ph": 6.1,
    "nm": 415,
    "abs": 0.46377142857142856
  },
  {
    "ph": 6.2,
    "nm": 415,
    "abs": 0.4589142857142857
  },
  {
    "ph": 6.3,
    "nm": 415,
    "abs": 0.4540571428571428
  },
  {
    "ph": 6.4,
    "nm": 415,
    "abs": 0.4492
  },
  {
    "ph": 6.5,
    "nm": 415,
    "abs": 0.4443428571428571
  },
  {
    "ph": 6.6,
    "nm": 415,
    "abs": 0.4394857142857143
  },
  {
    "ph": 6.7,
    "nm": 415,
    "abs": 0.4306857142857143
  },
  {
    "ph": 6.8,
    "nm": 415,
    "abs": 0.41788571428571425
  },
  {
    "ph": 6.9,
    "nm": 415,
    "abs": 0.4050285714285714
  },
  {
    "ph": 7,
    "nm": 415,
    "abs": 0.3922285714285714
  },
  {
    "ph": 7.1,
    "nm": 415,
    "abs": 0.3793714285714286
  },
  {
    "ph": 7.2,
    "nm": 415,
    "abs": 0.3665142857142857
  },
  {
    "ph": 7.3,
    "nm": 415,
    "abs": 0.3537142857142857
  },
  {
    "ph": 7.4,
    "nm": 415,
    "abs": 0.34085714285714286
  },
  {
    "ph": 7.5,
    "nm": 415,
    "abs": 0.3280571428571429
  },
  {
    "ph": 7.6,
    "nm": 415,
    "abs": 0.3152
  },
  {
    "ph": 7.7,
    "nm": 415,
    "abs": 0.3024
  },
  {
    "ph": 7.8,
    "nm": 415,
    "abs": 0.28954285714285716
  },
  {
    "ph": 7.9,
    "nm": 415,
    "abs": 0.2767428571428571
  },
  {
    "ph": 8,
    "nm": 415,
    "abs": 0.2638857142857143
  },
  {
    "ph": 5,
    "nm": 420,
    "abs": 0.5291428571428571
  },
  {
    "ph": 5.1,
    "nm": 420,
    "abs": 0.5253142857142857
  },
  {
    "ph": 5.2,
    "nm": 420,
    "abs": 0.5215428571428571
  },
  {
    "ph": 5.3,
    "nm": 420,
    "abs": 0.5177714285714285
  },
  {
    "ph": 5.4,
    "nm": 420,
    "abs": 0.5139428571428571
  },
  {
    "ph": 5.5,
    "nm": 420,
    "abs": 0.5101714285714286
  },
  {
    "ph": 5.6,
    "nm": 420,
    "abs": 0.5064
  },
  {
    "ph": 5.7,
    "nm": 420,
    "abs": 0.5025714285714286
  },
  {
    "ph": 5.8,
    "nm": 420,
    "abs": 0.4988
  },
  {
    "ph": 5.9,
    "nm": 420,
    "abs": 0.49497142857142856
  },
  {
    "ph": 6,
    "nm": 420,
    "abs": 0.4912
  },
  {
    "ph": 6.1,
    "nm": 420,
    "abs": 0.48742857142857143
  },
  {
    "ph": 6.2,
    "nm": 420,
    "abs": 0.48360000000000003
  },
  {
    "ph": 6.3,
    "nm": 420,
    "abs": 0.4772571428571429
  },
  {
    "ph": 6.4,
    "nm": 420,
    "abs": 0.46411428571428576
  },
  {
    "ph": 6.5,
    "nm": 420,
    "abs": 0.4509142857142857
  },
  {
    "ph": 6.6,
    "nm": 420,
    "abs": 0.4377714285714286
  },
  {
    "ph": 6.7,
    "nm": 420,
    "abs": 0.42457142857142854
  },
  {
    "ph": 6.8,
    "nm": 420,
    "abs": 0.4114285714285714
  },
  {
    "ph": 6.9,
    "nm": 420,
    "abs": 0.39822857142857143
  },
  {
    "ph": 7,
    "nm": 420,
    "abs": 0.3850857142857143
  },
  {
    "ph": 7.1,
    "nm": 420,
    "abs": 0.3718857142857143
  },
  {
    "ph": 7.2,
    "nm": 420,
    "abs": 0.35874285714285714
  },
  {
    "ph": 7.3,
    "nm": 420,
    "abs": 0.34554285714285715
  },
  {
    "ph": 7.4,
    "nm": 420,
    "abs": 0.3324
  },
  {
    "ph": 7.5,
    "nm": 420,
    "abs": 0.3192
  },
  {
    "ph": 7.6,
    "nm": 420,
    "abs": 0.30605714285714286
  },
  {
    "ph": 7.7,
    "nm": 420,
    "abs": 0.2928571428571428
  },
  {
    "ph": 7.8,
    "nm": 420,
    "abs": 0.2797142857142857
  },
  {
    "ph": 7.9,
    "nm": 420,
    "abs": 0.2665142857142857
  },
  {
    "ph": 8,
    "nm": 420,
    "abs": 0.2533714285714286
  },
  {
    "ph": 5,
    "nm": 425,
    "abs": 0.5349714285714285
  },
  {
    "ph": 5.1,
    "nm": 425,
    "abs": 0.5322857142857143
  },
  {
    "ph": 5.2,
    "nm": 425,
    "abs": 0.5296571428571428
  },
  {
    "ph": 5.3,
    "nm": 425,
    "abs": 0.5269714285714285
  },
  {
    "ph": 5.4,
    "nm": 425,
    "abs": 0.5242857142857142
  },
  {
    "ph": 5.5,
    "nm": 425,
    "abs": 0.5216571428571429
  },
  {
    "ph": 5.6,
    "nm": 425,
    "abs": 0.5189714285714285
  },
  {
    "ph": 5.7,
    "nm": 425,
    "abs": 0.5162857142857142
  },
  {
    "ph": 5.8,
    "nm": 425,
    "abs": 0.5136571428571429
  },
  {
    "ph": 5.9,
    "nm": 425,
    "abs": 0.5109714285714285
  },
  {
    "ph": 6,
    "nm": 425,
    "abs": 0.5082857142857142
  },
  {
    "ph": 6.1,
    "nm": 425,
    "abs": 0.5025142857142857
  },
  {
    "ph": 6.2,
    "nm": 425,
    "abs": 0.4888
  },
  {
    "ph": 6.3,
    "nm": 425,
    "abs": 0.4750857142857143
  },
  {
    "ph": 6.4,
    "nm": 425,
    "abs": 0.4614285714285714
  },
  {
    "ph": 6.5,
    "nm": 425,
    "abs": 0.4477142857142857
  },
  {
    "ph": 6.6,
    "nm": 425,
    "abs": 0.434
  },
  {
    "ph": 6.7,
    "nm": 425,
    "abs": 0.4202857142857143
  },
  {
    "ph": 6.8,
    "nm": 425,
    "abs": 0.4065714285714286
  },
  {
    "ph": 6.9,
    "nm": 425,
    "abs": 0.3929142857142857
  },
  {
    "ph": 7,
    "nm": 425,
    "abs": 0.3792
  },
  {
    "ph": 7.1,
    "nm": 425,
    "abs": 0.36548571428571425
  },
  {
    "ph": 7.2,
    "nm": 425,
    "abs": 0.35177142857142857
  },
  {
    "ph": 7.3,
    "nm": 425,
    "abs": 0.3380571428571429
  },
  {
    "ph": 7.4,
    "nm": 425,
    "abs": 0.32439999999999997
  },
  {
    "ph": 7.5,
    "nm": 425,
    "abs": 0.3106857142857143
  },
  {
    "ph": 7.6,
    "nm": 425,
    "abs": 0.2969714285714286
  },
  {
    "ph": 7.7,
    "nm": 425,
    "abs": 0.2832571428571428
  },
  {
    "ph": 7.8,
    "nm": 425,
    "abs": 0.26954285714285714
  },
  {
    "ph": 7.9,
    "nm": 425,
    "abs": 0.25588571428571427
  },
  {
    "ph": 8,
    "nm": 425,
    "abs": 0.24217142857142857
  },
  {
    "ph": 5,
    "nm": 430,
    "abs": 0.5413714285714286
  },
  {
    "ph": 5.1,
    "nm": 430,
    "abs": 0.5377714285714286
  },
  {
    "ph": 5.2,
    "nm": 430,
    "abs": 0.5342285714285714
  },
  {
    "ph": 5.3,
    "nm": 430,
    "abs": 0.5306285714285714
  },
  {
    "ph": 5.4,
    "nm": 430,
    "abs": 0.5270857142857143
  },
  {
    "ph": 5.5,
    "nm": 430,
    "abs": 0.5234857142857143
  },
  {
    "ph": 5.6,
    "nm": 430,
    "abs": 0.5198857142857143
  },
  {
    "ph": 5.7,
    "nm": 430,
    "abs": 0.5163428571428571
  },
  {
    "ph": 5.8,
    "nm": 430,
    "abs": 0.5127428571428572
  },
  {
    "ph": 5.9,
    "nm": 430,
    "abs": 0.5092
  },
  {
    "ph": 6,
    "nm": 430,
    "abs": 0.5056
  },
  {
    "ph": 6.1,
    "nm": 430,
    "abs": 0.5014285714285714
  },
  {
    "ph": 6.2,
    "nm": 430,
    "abs": 0.4872
  },
  {
    "ph": 6.3,
    "nm": 430,
    "abs": 0.47297142857142854
  },
  {
    "ph": 6.4,
    "nm": 430,
    "abs": 0.45868571428571425
  },
  {
    "ph": 6.5,
    "nm": 430,
    "abs": 0.4444571428571429
  },
  {
    "ph": 6.6,
    "nm": 430,
    "abs": 0.43022857142857146
  },
  {
    "ph": 6.7,
    "nm": 430,
    "abs": 0.416
  },
  {
    "ph": 6.8,
    "nm": 430,
    "abs": 0.40177142857142856
  },
  {
    "ph": 6.9,
    "nm": 430,
    "abs": 0.38754285714285713
  },
  {
    "ph": 7,
    "nm": 430,
    "abs": 0.3733142857142857
  },
  {
    "ph": 7.1,
    "nm": 430,
    "abs": 0.3590857142857143
  },
  {
    "ph": 7.2,
    "nm": 430,
    "abs": 0.34485714285714286
  },
  {
    "ph": 7.3,
    "nm": 430,
    "abs": 0.33062857142857144
  },
  {
    "ph": 7.4,
    "nm": 430,
    "abs": 0.31639999999999996
  },
  {
    "ph": 7.5,
    "nm": 430,
    "abs": 0.3021714285714286
  },
  {
    "ph": 7.6,
    "nm": 430,
    "abs": 0.2878857142857143
  },
  {
    "ph": 7.7,
    "nm": 430,
    "abs": 0.2736571428571429
  },
  {
    "ph": 7.8,
    "nm": 430,
    "abs": 0.25942857142857145
  },
  {
    "ph": 7.9,
    "nm": 430,
    "abs": 0.2452
  },
  {
    "ph": 8,
    "nm": 430,
    "abs": 0.23097142857142858
  },
  {
    "ph": 5,
    "nm": 435,
    "abs": 0.5485714285714286
  },
  {
    "ph": 5.1,
    "nm": 435,
    "abs": 0.5436
  },
  {
    "ph": 5.2,
    "nm": 435,
    "abs": 0.5386285714285715
  },
  {
    "ph": 5.3,
    "nm": 435,
    "abs": 0.5337142857142857
  },
  {
    "ph": 5.4,
    "nm": 435,
    "abs": 0.5287428571428572
  },
  {
    "ph": 5.5,
    "nm": 435,
    "abs": 0.5238285714285714
  },
  {
    "ph": 5.6,
    "nm": 435,
    "abs": 0.5188571428571429
  },
  {
    "ph": 5.7,
    "nm": 435,
    "abs": 0.5138857142857143
  },
  {
    "ph": 5.8,
    "nm": 435,
    "abs": 0.5089714285714286
  },
  {
    "ph": 5.9,
    "nm": 435,
    "abs": 0.504
  },
  {
    "ph": 6,
    "nm": 435,
    "abs": 0.49902857142857143
  },
  {
    "ph": 6.1,
    "nm": 435,
    "abs": 0.49411428571428573
  },
  {
    "ph": 6.2,
    "nm": 435,
    "abs": 0.48554285714285716
  },
  {
    "ph": 6.3,
    "nm": 435,
    "abs": 0.4708
  },
  {
    "ph": 6.4,
    "nm": 435,
    "abs": 0.456
  },
  {
    "ph": 6.5,
    "nm": 435,
    "abs": 0.44125714285714285
  },
  {
    "ph": 6.6,
    "nm": 435,
    "abs": 0.4265142857142857
  },
  {
    "ph": 6.7,
    "nm": 435,
    "abs": 0.41171428571428575
  },
  {
    "ph": 6.8,
    "nm": 435,
    "abs": 0.3969714285714286
  },
  {
    "ph": 6.9,
    "nm": 435,
    "abs": 0.38217142857142855
  },
  {
    "ph": 7,
    "nm": 435,
    "abs": 0.36742857142857144
  },
  {
    "ph": 7.1,
    "nm": 435,
    "abs": 0.35268571428571427
  },
  {
    "ph": 7.2,
    "nm": 435,
    "abs": 0.3378857142857143
  },
  {
    "ph": 7.3,
    "nm": 435,
    "abs": 0.3231428571428571
  },
  {
    "ph": 7.4,
    "nm": 435,
    "abs": 0.30839999999999995
  },
  {
    "ph": 7.5,
    "nm": 435,
    "abs": 0.2936
  },
  {
    "ph": 7.6,
    "nm": 435,
    "abs": 0.27885714285714286
  },
  {
    "ph": 7.7,
    "nm": 435,
    "abs": 0.2641142857142857
  },
  {
    "ph": 7.8,
    "nm": 435,
    "abs": 0.24931428571428574
  },
  {
    "ph": 7.9,
    "nm": 435,
    "abs": 0.23457142857142857
  },
  {
    "ph": 8,
    "nm": 435,
    "abs": 0.21977142857142856
  },
  {
    "ph": 5,
    "nm": 440,
    "abs": 0.5376
  },
  {
    "ph": 5.1,
    "nm": 440,
    "abs": 0.5334285714285715
  },
  {
    "ph": 5.2,
    "nm": 440,
    "abs": 0.5293142857142857
  },
  {
    "ph": 5.3,
    "nm": 440,
    "abs": 0.5251428571428571
  },
  {
    "ph": 5.4,
    "nm": 440,
    "abs": 0.5210285714285715
  },
  {
    "ph": 5.5,
    "nm": 440,
    "abs": 0.5168571428571428
  },
  {
    "ph": 5.6,
    "nm": 440,
    "abs": 0.5126857142857143
  },
  {
    "ph": 5.7,
    "nm": 440,
    "abs": 0.5085714285714286
  },
  {
    "ph": 5.8,
    "nm": 440,
    "abs": 0.5044000000000001
  },
  {
    "ph": 5.9,
    "nm": 440,
    "abs": 0.5002857142857142
  },
  {
    "ph": 6,
    "nm": 440,
    "abs": 0.4961142857142857
  },
  {
    "ph": 6.1,
    "nm": 440,
    "abs": 0.492
  },
  {
    "ph": 6.2,
    "nm": 440,
    "abs": 0.4810857142857143
  },
  {
    "ph": 6.3,
    "nm": 440,
    "abs": 0.46594285714285716
  },
  {
    "ph": 6.4,
    "nm": 440,
    "abs": 0.4507428571428571
  },
  {
    "ph": 6.5,
    "nm": 440,
    "abs": 0.4356
  },
  {
    "ph": 6.6,
    "nm": 440,
    "abs": 0.4204
  },
  {
    "ph": 6.7,
    "nm": 440,
    "abs": 0.40525714285714287
  },
  {
    "ph": 6.8,
    "nm": 440,
    "abs": 0.3900571428571428
  },
  {
    "ph": 6.9,
    "nm": 440,
    "abs": 0.3749142857142857
  },
  {
    "ph": 7,
    "nm": 440,
    "abs": 0.3597142857142857
  },
  {
    "ph": 7.1,
    "nm": 440,
    "abs": 0.3445714285714286
  },
  {
    "ph": 7.2,
    "nm": 440,
    "abs": 0.3293714285714286
  },
  {
    "ph": 7.3,
    "nm": 440,
    "abs": 0.31422857142857147
  },
  {
    "ph": 7.4,
    "nm": 440,
    "abs": 0.2990285714285714
  },
  {
    "ph": 7.5,
    "nm": 440,
    "abs": 0.28382857142857143
  },
  {
    "ph": 7.6,
    "nm": 440,
    "abs": 0.2686857142857143
  },
  {
    "ph": 7.7,
    "nm": 440,
    "abs": 0.25348571428571426
  },
  {
    "ph": 7.8,
    "nm": 440,
    "abs": 0.23834285714285716
  },
  {
    "ph": 7.9,
    "nm": 440,
    "abs": 0.22314285714285714
  },
  {
    "ph": 8,
    "nm": 440,
    "abs": 0.208
  },
  {
    "ph": 5,
    "nm": 445,
    "abs": 0.5214285714285715
  },
  {
    "ph": 5.1,
    "nm": 445,
    "abs": 0.5176000000000001
  },
  {
    "ph": 5.2,
    "nm": 445,
    "abs": 0.5137714285714285
  },
  {
    "ph": 5.3,
    "nm": 445,
    "abs": 0.5099428571428571
  },
  {
    "ph": 5.4,
    "nm": 445,
    "abs": 0.5060571428571429
  },
  {
    "ph": 5.5,
    "nm": 445,
    "abs": 0.5022285714285715
  },
  {
    "ph": 5.6,
    "nm": 445,
    "abs": 0.4984
  },
  {
    "ph": 5.7,
    "nm": 445,
    "abs": 0.4945142857142857
  },
  {
    "ph": 5.8,
    "nm": 445,
    "abs": 0.4906857142857143
  },
  {
    "ph": 5.9,
    "nm": 445,
    "abs": 0.4868571428571428
  },
  {
    "ph": 6,
    "nm": 445,
    "abs": 0.48297142857142855
  },
  {
    "ph": 6.1,
    "nm": 445,
    "abs": 0.47914285714285715
  },
  {
    "ph": 6.2,
    "nm": 445,
    "abs": 0.47045714285714285
  },
  {
    "ph": 6.3,
    "nm": 445,
    "abs": 0.45525714285714286
  },
  {
    "ph": 6.4,
    "nm": 445,
    "abs": 0.44005714285714287
  },
  {
    "ph": 6.5,
    "nm": 445,
    "abs": 0.4248571428571429
  },
  {
    "ph": 6.6,
    "nm": 445,
    "abs": 0.40965714285714283
  },
  {
    "ph": 6.7,
    "nm": 445,
    "abs": 0.3944571428571429
  },
  {
    "ph": 6.8,
    "nm": 445,
    "abs": 0.37925714285714285
  },
  {
    "ph": 6.9,
    "nm": 445,
    "abs": 0.36405714285714286
  },
  {
    "ph": 7,
    "nm": 445,
    "abs": 0.34880000000000005
  },
  {
    "ph": 7.1,
    "nm": 445,
    "abs": 0.3336
  },
  {
    "ph": 7.2,
    "nm": 445,
    "abs": 0.3184
  },
  {
    "ph": 7.3,
    "nm": 445,
    "abs": 0.30319999999999997
  },
  {
    "ph": 7.4,
    "nm": 445,
    "abs": 0.288
  },
  {
    "ph": 7.5,
    "nm": 445,
    "abs": 0.2728
  },
  {
    "ph": 7.6,
    "nm": 445,
    "abs": 0.2576
  },
  {
    "ph": 7.7,
    "nm": 445,
    "abs": 0.2424
  },
  {
    "ph": 7.8,
    "nm": 445,
    "abs": 0.2272
  },
  {
    "ph": 7.9,
    "nm": 445,
    "abs": 0.212
  },
  {
    "ph": 8,
    "nm": 445,
    "abs": 0.1968
  },
  {
    "ph": 5,
    "nm": 450,
    "abs": 0.5036571428571428
  },
  {
    "ph": 5.1,
    "nm": 450,
    "abs": 0.49994285714285713
  },
  {
    "ph": 5.2,
    "nm": 450,
    "abs": 0.49617142857142854
  },
  {
    "ph": 5.3,
    "nm": 450,
    "abs": 0.49245714285714287
  },
  {
    "ph": 5.4,
    "nm": 450,
    "abs": 0.4887428571428571
  },
  {
    "ph": 5.5,
    "nm": 450,
    "abs": 0.48497142857142855
  },
  {
    "ph": 5.6,
    "nm": 450,
    "abs": 0.48125714285714283
  },
  {
    "ph": 5.7,
    "nm": 450,
    "abs": 0.47754285714285716
  },
  {
    "ph": 5.8,
    "nm": 450,
    "abs": 0.47377142857142857
  },
  {
    "ph": 5.9,
    "nm": 450,
    "abs": 0.47005714285714284
  },
  {
    "ph": 6,
    "nm": 450,
    "abs": 0.46634285714285717
  },
  {
    "ph": 6.1,
    "nm": 450,
    "abs": 0.4625714285714286
  },
  {
    "ph": 6.2,
    "nm": 450,
    "abs": 0.44839999999999997
  },
  {
    "ph": 6.3,
    "nm": 450,
    "abs": 0.43394285714285713
  },
  {
    "ph": 6.4,
    "nm": 450,
    "abs": 0.4194857142857143
  },
  {
    "ph": 6.5,
    "nm": 450,
    "abs": 0.4050285714285714
  },
  {
    "ph": 6.6,
    "nm": 450,
    "abs": 0.39057142857142857
  },
  {
    "ph": 6.7,
    "nm": 450,
    "abs": 0.37611428571428573
  },
  {
    "ph": 6.8,
    "nm": 450,
    "abs": 0.36165714285714284
  },
  {
    "ph": 6.9,
    "nm": 450,
    "abs": 0.3472
  },
  {
    "ph": 7,
    "nm": 450,
    "abs": 0.3327428571428572
  },
  {
    "ph": 7.1,
    "nm": 450,
    "abs": 0.31828571428571434
  },
  {
    "ph": 7.2,
    "nm": 450,
    "abs": 0.3038285714285714
  },
  {
    "ph": 7.3,
    "nm": 450,
    "abs": 0.28937142857142856
  },
  {
    "ph": 7.4,
    "nm": 450,
    "abs": 0.2749142857142857
  },
  {
    "ph": 7.5,
    "nm": 450,
    "abs": 0.26045714285714283
  },
  {
    "ph": 7.6,
    "nm": 450,
    "abs": 0.246
  },
  {
    "ph": 7.7,
    "nm": 450,
    "abs": 0.23154285714285713
  },
  {
    "ph": 7.8,
    "nm": 450,
    "abs": 0.2170857142857143
  },
  {
    "ph": 7.9,
    "nm": 450,
    "abs": 0.20262857142857144
  },
  {
    "ph": 8,
    "nm": 450,
    "abs": 0.18817142857142857
  },
  {
    "ph": 5,
    "nm": 455,
    "abs": 0.4868571428571428
  },
  {
    "ph": 5.1,
    "nm": 455,
    "abs": 0.48262857142857146
  },
  {
    "ph": 5.2,
    "nm": 455,
    "abs": 0.47845714285714286
  },
  {
    "ph": 5.3,
    "nm": 455,
    "abs": 0.4742285714285714
  },
  {
    "ph": 5.4,
    "nm": 455,
    "abs": 0.47000000000000003
  },
  {
    "ph": 5.5,
    "nm": 455,
    "abs": 0.4658285714285714
  },
  {
    "ph": 5.6,
    "nm": 455,
    "abs": 0.46159999999999995
  },
  {
    "ph": 5.7,
    "nm": 455,
    "abs": 0.4574285714285714
  },
  {
    "ph": 5.8,
    "nm": 455,
    "abs": 0.4532
  },
  {
    "ph": 5.9,
    "nm": 455,
    "abs": 0.4489714285714285
  },
  {
    "ph": 6,
    "nm": 455,
    "abs": 0.4448
  },
  {
    "ph": 6.1,
    "nm": 455,
    "abs": 0.44
  },
  {
    "ph": 6.2,
    "nm": 455,
    "abs": 0.42628571428571427
  },
  {
    "ph": 6.3,
    "nm": 455,
    "abs": 0.41257142857142853
  },
  {
    "ph": 6.4,
    "nm": 455,
    "abs": 0.3989142857142857
  },
  {
    "ph": 6.5,
    "nm": 455,
    "abs": 0.38520000000000004
  },
  {
    "ph": 6.6,
    "nm": 455,
    "abs": 0.3714857142857143
  },
  {
    "ph": 6.7,
    "nm": 455,
    "abs": 0.3577714285714286
  },
  {
    "ph": 6.8,
    "nm": 455,
    "abs": 0.34405714285714284
  },
  {
    "ph": 6.9,
    "nm": 455,
    "abs": 0.3303428571428571
  },
  {
    "ph": 7,
    "nm": 455,
    "abs": 0.3166285714285714
  },
  {
    "ph": 7.1,
    "nm": 455,
    "abs": 0.30291428571428575
  },
  {
    "ph": 7.2,
    "nm": 455,
    "abs": 0.2892571428571428
  },
  {
    "ph": 7.3,
    "nm": 455,
    "abs": 0.27554285714285714
  },
  {
    "ph": 7.4,
    "nm": 455,
    "abs": 0.2618285714285714
  },
  {
    "ph": 7.5,
    "nm": 455,
    "abs": 0.2481142857142857
  },
  {
    "ph": 7.6,
    "nm": 455,
    "abs": 0.2344
  },
  {
    "ph": 7.7,
    "nm": 455,
    "abs": 0.2206857142857143
  },
  {
    "ph": 7.8,
    "nm": 455,
    "abs": 0.20697142857142858
  },
  {
    "ph": 7.9,
    "nm": 455,
    "abs": 0.19325714285714285
  },
  {
    "ph": 8,
    "nm": 455,
    "abs": 0.1796
  },
  {
    "ph": 5,
    "nm": 460,
    "abs": 0.4618857142857143
  },
  {
    "ph": 5.1,
    "nm": 460,
    "abs": 0.45759999999999995
  },
  {
    "ph": 5.2,
    "nm": 460,
    "abs": 0.45325714285714286
  },
  {
    "ph": 5.3,
    "nm": 460,
    "abs": 0.4489142857142857
  },
  {
    "ph": 5.4,
    "nm": 460,
    "abs": 0.44462857142857143
  },
  {
    "ph": 5.5,
    "nm": 460,
    "abs": 0.4402857142857143
  },
  {
    "ph": 5.6,
    "nm": 460,
    "abs": 0.436
  },
  {
    "ph": 5.7,
    "nm": 460,
    "abs": 0.43165714285714285
  },
  {
    "ph": 5.8,
    "nm": 460,
    "abs": 0.42737142857142857
  },
  {
    "ph": 5.9,
    "nm": 460,
    "abs": 0.4230285714285714
  },
  {
    "ph": 6,
    "nm": 460,
    "abs": 0.41868571428571427
  },
  {
    "ph": 6.1,
    "nm": 460,
    "abs": 0.4144
  },
  {
    "ph": 6.2,
    "nm": 460,
    "abs": 0.40422857142857144
  },
  {
    "ph": 6.3,
    "nm": 460,
    "abs": 0.39125714285714286
  },
  {
    "ph": 6.4,
    "nm": 460,
    "abs": 0.3782857142857143
  },
  {
    "ph": 6.5,
    "nm": 460,
    "abs": 0.36537142857142857
  },
  {
    "ph": 6.6,
    "nm": 460,
    "abs": 0.3524
  },
  {
    "ph": 6.7,
    "nm": 460,
    "abs": 0.3394285714285714
  },
  {
    "ph": 6.8,
    "nm": 460,
    "abs": 0.3264571428571429
  },
  {
    "ph": 6.9,
    "nm": 460,
    "abs": 0.3135428571428571
  },
  {
    "ph": 7,
    "nm": 460,
    "abs": 0.3005714285714286
  },
  {
    "ph": 7.1,
    "nm": 460,
    "abs": 0.28759999999999997
  },
  {
    "ph": 7.2,
    "nm": 460,
    "abs": 0.27462857142857144
  },
  {
    "ph": 7.3,
    "nm": 460,
    "abs": 0.26165714285714287
  },
  {
    "ph": 7.4,
    "nm": 460,
    "abs": 0.24874285714285715
  },
  {
    "ph": 7.5,
    "nm": 460,
    "abs": 0.23577142857142858
  },
  {
    "ph": 7.6,
    "nm": 460,
    "abs": 0.22280000000000003
  },
  {
    "ph": 7.7,
    "nm": 460,
    "abs": 0.20982857142857145
  },
  {
    "ph": 7.8,
    "nm": 460,
    "abs": 0.19685714285714284
  },
  {
    "ph": 7.9,
    "nm": 460,
    "abs": 0.18394285714285716
  },
  {
    "ph": 8,
    "nm": 460,
    "abs": 0.17097142857142858
  },
  {
    "ph": 5,
    "nm": 465,
    "abs": 0.4269142857142857
  },
  {
    "ph": 5.1,
    "nm": 465,
    "abs": 0.42314285714285715
  },
  {
    "ph": 5.2,
    "nm": 465,
    "abs": 0.41942857142857143
  },
  {
    "ph": 5.3,
    "nm": 465,
    "abs": 0.41571428571428576
  },
  {
    "ph": 5.4,
    "nm": 465,
    "abs": 0.412
  },
  {
    "ph": 5.5,
    "nm": 465,
    "abs": 0.4082857142857143
  },
  {
    "ph": 5.6,
    "nm": 465,
    "abs": 0.4045142857142857
  },
  {
    "ph": 5.7,
    "nm": 465,
    "abs": 0.4008
  },
  {
    "ph": 5.8,
    "nm": 465,
    "abs": 0.39708571428571426
  },
  {
    "ph": 5.9,
    "nm": 465,
    "abs": 0.3933714285714286
  },
  {
    "ph": 6,
    "nm": 465,
    "abs": 0.3896571428571428
  },
  {
    "ph": 6.1,
    "nm": 465,
    "abs": 0.3858857142857143
  },
  {
    "ph": 6.2,
    "nm": 465,
    "abs": 0.3789142857142857
  },
  {
    "ph": 6.3,
    "nm": 465,
    "abs": 0.36719999999999997
  },
  {
    "ph": 6.4,
    "nm": 465,
    "abs": 0.3554857142857143
  },
  {
    "ph": 6.5,
    "nm": 465,
    "abs": 0.34382857142857143
  },
  {
    "ph": 6.6,
    "nm": 465,
    "abs": 0.33211428571428575
  },
  {
    "ph": 6.7,
    "nm": 465,
    "abs": 0.32039999999999996
  },
  {
    "ph": 6.8,
    "nm": 465,
    "abs": 0.30874285714285715
  },
  {
    "ph": 6.9,
    "nm": 465,
    "abs": 0.2970285714285715
  },
  {
    "ph": 7,
    "nm": 465,
    "abs": 0.28531428571428574
  },
  {
    "ph": 7.1,
    "nm": 465,
    "abs": 0.2736571428571429
  },
  {
    "ph": 7.2,
    "nm": 465,
    "abs": 0.26194285714285714
  },
  {
    "ph": 7.3,
    "nm": 465,
    "abs": 0.2502285714285714
  },
  {
    "ph": 7.4,
    "nm": 465,
    "abs": 0.2385142857142857
  },
  {
    "ph": 7.5,
    "nm": 465,
    "abs": 0.22685714285714287
  },
  {
    "ph": 7.6,
    "nm": 465,
    "abs": 0.21514285714285714
  },
  {
    "ph": 7.7,
    "nm": 465,
    "abs": 0.20342857142857143
  },
  {
    "ph": 7.8,
    "nm": 465,
    "abs": 0.19177142857142856
  },
  {
    "ph": 7.9,
    "nm": 465,
    "abs": 0.18005714285714286
  },
  {
    "ph": 8,
    "nm": 465,
    "abs": 0.16834285714285713
  },
  {
    "ph": 5,
    "nm": 470,
    "abs": 0.39171428571428574
  },
  {
    "ph": 5.1,
    "nm": 470,
    "abs": 0.38862857142857143
  },
  {
    "ph": 5.2,
    "nm": 470,
    "abs": 0.38548571428571426
  },
  {
    "ph": 5.3,
    "nm": 470,
    "abs": 0.38234285714285715
  },
  {
    "ph": 5.4,
    "nm": 470,
    "abs": 0.3792
  },
  {
    "ph": 5.5,
    "nm": 470,
    "abs": 0.37605714285714287
  },
  {
    "ph": 5.6,
    "nm": 470,
    "abs": 0.37297142857142856
  },
  {
    "ph": 5.7,
    "nm": 470,
    "abs": 0.36982857142857145
  },
  {
    "ph": 5.8,
    "nm": 470,
    "abs": 0.36668571428571434
  },
  {
    "ph": 5.9,
    "nm": 470,
    "abs": 0.3635428571428571
  },
  {
    "ph": 6,
    "nm": 470,
    "abs": 0.3604
  },
  {
    "ph": 6.1,
    "nm": 470,
    "abs": 0.35725714285714283
  },
  {
    "ph": 6.2,
    "nm": 470,
    "abs": 0.3522285714285714
  },
  {
    "ph": 6.3,
    "nm": 470,
    "abs": 0.342
  },
  {
    "ph": 6.4,
    "nm": 470,
    "abs": 0.33177142857142855
  },
  {
    "ph": 6.5,
    "nm": 470,
    "abs": 0.32154285714285713
  },
  {
    "ph": 6.6,
    "nm": 470,
    "abs": 0.3113142857142857
  },
  {
    "ph": 6.7,
    "nm": 470,
    "abs": 0.30114285714285716
  },
  {
    "ph": 6.8,
    "nm": 470,
    "abs": 0.29091428571428574
  },
  {
    "ph": 6.9,
    "nm": 470,
    "abs": 0.2806857142857143
  },
  {
    "ph": 7,
    "nm": 470,
    "abs": 0.27045714285714284
  },
  {
    "ph": 7.1,
    "nm": 470,
    "abs": 0.2602285714285714
  },
  {
    "ph": 7.2,
    "nm": 470,
    "abs": 0.25
  },
  {
    "ph": 7.3,
    "nm": 470,
    "abs": 0.23977142857142855
  },
  {
    "ph": 7.4,
    "nm": 470,
    "abs": 0.22954285714285713
  },
  {
    "ph": 7.5,
    "nm": 470,
    "abs": 0.2193142857142857
  },
  {
    "ph": 7.6,
    "nm": 470,
    "abs": 0.2090857142857143
  },
  {
    "ph": 7.7,
    "nm": 470,
    "abs": 0.19885714285714284
  },
  {
    "ph": 7.8,
    "nm": 470,
    "abs": 0.18862857142857142
  },
  {
    "ph": 7.9,
    "nm": 470,
    "abs": 0.17839999999999998
  },
  {
    "ph": 8,
    "nm": 470,
    "abs": 0.16817142857142858
  },
  {
    "ph": 5,
    "nm": 475,
    "abs": 0.3565714285714286
  },
  {
    "ph": 5.1,
    "nm": 475,
    "abs": 0.3540571428571429
  },
  {
    "ph": 5.2,
    "nm": 475,
    "abs": 0.3514857142857143
  },
  {
    "ph": 5.3,
    "nm": 475,
    "abs": 0.3489714285714286
  },
  {
    "ph": 5.4,
    "nm": 475,
    "abs": 0.3464
  },
  {
    "ph": 5.5,
    "nm": 475,
    "abs": 0.3438857142857143
  },
  {
    "ph": 5.6,
    "nm": 475,
    "abs": 0.3413714285714286
  },
  {
    "ph": 5.7,
    "nm": 475,
    "abs": 0.3388
  },
  {
    "ph": 5.8,
    "nm": 475,
    "abs": 0.3362857142857143
  },
  {
    "ph": 5.9,
    "nm": 475,
    "abs": 0.3337142857142857
  },
  {
    "ph": 6,
    "nm": 475,
    "abs": 0.3312
  },
  {
    "ph": 6.1,
    "nm": 475,
    "abs": 0.3286285714285714
  },
  {
    "ph": 6.2,
    "nm": 475,
    "abs": 0.3258857142857143
  },
  {
    "ph": 6.3,
    "nm": 475,
    "abs": 0.31725714285714285
  },
  {
    "ph": 6.4,
    "nm": 475,
    "abs": 0.3086285714285714
  },
  {
    "ph": 6.5,
    "nm": 475,
    "abs": 0.3
  },
  {
    "ph": 6.6,
    "nm": 475,
    "abs": 0.2914285714285714
  },
  {
    "ph": 6.7,
    "nm": 475,
    "abs": 0.2828
  },
  {
    "ph": 6.8,
    "nm": 475,
    "abs": 0.27417142857142857
  },
  {
    "ph": 6.9,
    "nm": 475,
    "abs": 0.26554285714285714
  },
  {
    "ph": 7,
    "nm": 475,
    "abs": 0.2569714285714286
  },
  {
    "ph": 7.1,
    "nm": 475,
    "abs": 0.24834285714285714
  },
  {
    "ph": 7.2,
    "nm": 475,
    "abs": 0.2397142857142857
  },
  {
    "ph": 7.3,
    "nm": 475,
    "abs": 0.23114285714285715
  },
  {
    "ph": 7.4,
    "nm": 475,
    "abs": 0.22251428571428572
  },
  {
    "ph": 7.5,
    "nm": 475,
    "abs": 0.2138857142857143
  },
  {
    "ph": 7.6,
    "nm": 475,
    "abs": 0.20525714285714286
  },
  {
    "ph": 7.7,
    "nm": 475,
    "abs": 0.1966857142857143
  },
  {
    "ph": 7.8,
    "nm": 475,
    "abs": 0.18805714285714287
  },
  {
    "ph": 7.9,
    "nm": 475,
    "abs": 0.17942857142857144
  },
  {
    "ph": 8,
    "nm": 475,
    "abs": 0.1708
  },
  {
    "ph": 5,
    "nm": 480,
    "abs": 0.32142857142857145
  },
  {
    "ph": 5.1,
    "nm": 480,
    "abs": 0.3194857142857143
  },
  {
    "ph": 5.2,
    "nm": 480,
    "abs": 0.3175428571428571
  },
  {
    "ph": 5.3,
    "nm": 480,
    "abs": 0.3156
  },
  {
    "ph": 5.4,
    "nm": 480,
    "abs": 0.3136571428571429
  },
  {
    "ph": 5.5,
    "nm": 480,
    "abs": 0.3117142857142857
  },
  {
    "ph": 5.6,
    "nm": 480,
    "abs": 0.3097714285714286
  },
  {
    "ph": 5.7,
    "nm": 480,
    "abs": 0.3078285714285714
  },
  {
    "ph": 5.8,
    "nm": 480,
    "abs": 0.30582857142857145
  },
  {
    "ph": 5.9,
    "nm": 480,
    "abs": 0.3038857142857143
  },
  {
    "ph": 6,
    "nm": 480,
    "abs": 0.3019428571428571
  },
  {
    "ph": 6.1,
    "nm": 480,
    "abs": 0.3
  },
  {
    "ph": 6.2,
    "nm": 480,
    "abs": 0.29805714285714285
  },
  {
    "ph": 6.3,
    "nm": 480,
    "abs": 0.2925142857142857
  },
  {
    "ph": 6.4,
    "nm": 480,
    "abs": 0.28554285714285715
  },
  {
    "ph": 6.5,
    "nm": 480,
    "abs": 0.2785142857142857
  },
  {
    "ph": 6.6,
    "nm": 480,
    "abs": 0.27154285714285714
  },
  {
    "ph": 6.7,
    "nm": 480,
    "abs": 0.26457142857142857
  },
  {
    "ph": 6.8,
    "nm": 480,
    "abs": 0.2576
  },
  {
    "ph": 6.9,
    "nm": 480,
    "abs": 0.25057142857142856
  },
  {
    "ph": 7,
    "nm": 480,
    "abs": 0.2436
  },
  {
    "ph": 7.1,
    "nm": 480,
    "abs": 0.23662857142857144
  },
  {
    "ph": 7.2,
    "nm": 480,
    "abs": 0.2296
  },
  {
    "ph": 7.3,
    "nm": 480,
    "abs": 0.22262857142857143
  },
  {
    "ph": 7.4,
    "nm": 480,
    "abs": 0.21565714285714285
  },
  {
    "ph": 7.5,
    "nm": 480,
    "abs": 0.2086285714285714
  },
  {
    "ph": 7.6,
    "nm": 480,
    "abs": 0.20165714285714284
  },
  {
    "ph": 7.7,
    "nm": 480,
    "abs": 0.1946857142857143
  },
  {
    "ph": 7.8,
    "nm": 480,
    "abs": 0.18771428571428572
  },
  {
    "ph": 7.9,
    "nm": 480,
    "abs": 0.18068571428571428
  },
  {
    "ph": 8,
    "nm": 480,
    "abs": 0.1737142857142857
  },
  {
    "ph": 5,
    "nm": 485,
    "abs": 0.28622857142857144
  },
  {
    "ph": 5.1,
    "nm": 485,
    "abs": 0.28491428571428573
  },
  {
    "ph": 5.2,
    "nm": 485,
    "abs": 0.28354285714285715
  },
  {
    "ph": 5.3,
    "nm": 485,
    "abs": 0.28222857142857144
  },
  {
    "ph": 5.4,
    "nm": 485,
    "abs": 0.28085714285714286
  },
  {
    "ph": 5.5,
    "nm": 485,
    "abs": 0.2794857142857143
  },
  {
    "ph": 5.6,
    "nm": 485,
    "abs": 0.27817142857142857
  },
  {
    "ph": 5.7,
    "nm": 485,
    "abs": 0.2768
  },
  {
    "ph": 5.8,
    "nm": 485,
    "abs": 0.2754285714285714
  },
  {
    "ph": 5.9,
    "nm": 485,
    "abs": 0.2741142857142857
  },
  {
    "ph": 6,
    "nm": 485,
    "abs": 0.2727428571428571
  },
  {
    "ph": 6.1,
    "nm": 485,
    "abs": 0.27137142857142854
  },
  {
    "ph": 6.2,
    "nm": 485,
    "abs": 0.2700571428571429
  },
  {
    "ph": 6.3,
    "nm": 485,
    "abs": 0.2677714285714286
  },
  {
    "ph": 6.4,
    "nm": 485,
    "abs": 0.2624
  },
  {
    "ph": 6.5,
    "nm": 485,
    "abs": 0.2570857142857143
  },
  {
    "ph": 6.6,
    "nm": 485,
    "abs": 0.2517142857142857
  },
  {
    "ph": 6.7,
    "nm": 485,
    "abs": 0.24634285714285714
  },
  {
    "ph": 6.8,
    "nm": 485,
    "abs": 0.2409714285714286
  },
  {
    "ph": 6.9,
    "nm": 485,
    "abs": 0.2356
  },
  {
    "ph": 7,
    "nm": 485,
    "abs": 0.23022857142857142
  },
  {
    "ph": 7.1,
    "nm": 485,
    "abs": 0.22485714285714287
  },
  {
    "ph": 7.2,
    "nm": 485,
    "abs": 0.21948571428571428
  },
  {
    "ph": 7.3,
    "nm": 485,
    "abs": 0.2141714285714286
  },
  {
    "ph": 7.4,
    "nm": 485,
    "abs": 0.2088
  },
  {
    "ph": 7.5,
    "nm": 485,
    "abs": 0.20342857142857143
  },
  {
    "ph": 7.6,
    "nm": 485,
    "abs": 0.19805714285714288
  },
  {
    "ph": 7.7,
    "nm": 485,
    "abs": 0.1926857142857143
  },
  {
    "ph": 7.8,
    "nm": 485,
    "abs": 0.1873142857142857
  },
  {
    "ph": 7.9,
    "nm": 485,
    "abs": 0.18194285714285716
  },
  {
    "ph": 8,
    "nm": 485,
    "abs": 0.1766285714285714
  },
  {
    "ph": 5,
    "nm": 490,
    "abs": 0.2517714285714286
  },
  {
    "ph": 5.1,
    "nm": 490,
    "abs": 0.25102857142857143
  },
  {
    "ph": 5.2,
    "nm": 490,
    "abs": 0.2502857142857143
  },
  {
    "ph": 5.3,
    "nm": 490,
    "abs": 0.24954285714285712
  },
  {
    "ph": 5.4,
    "nm": 490,
    "abs": 0.24874285714285715
  },
  {
    "ph": 5.5,
    "nm": 490,
    "abs": 0.248
  },
  {
    "ph": 5.6,
    "nm": 490,
    "abs": 0.24725714285714284
  },
  {
    "ph": 5.7,
    "nm": 490,
    "abs": 0.2465142857142857
  },
  {
    "ph": 5.8,
    "nm": 490,
    "abs": 0.24571428571428572
  },
  {
    "ph": 5.9,
    "nm": 490,
    "abs": 0.2449714285714286
  },
  {
    "ph": 6,
    "nm": 490,
    "abs": 0.24422857142857143
  },
  {
    "ph": 6.1,
    "nm": 490,
    "abs": 0.24348571428571428
  },
  {
    "ph": 6.2,
    "nm": 490,
    "abs": 0.2426857142857143
  },
  {
    "ph": 6.3,
    "nm": 490,
    "abs": 0.24194285714285715
  },
  {
    "ph": 6.4,
    "nm": 490,
    "abs": 0.23931428571428573
  },
  {
    "ph": 6.5,
    "nm": 490,
    "abs": 0.2356
  },
  {
    "ph": 6.6,
    "nm": 490,
    "abs": 0.23182857142857144
  },
  {
    "ph": 6.7,
    "nm": 490,
    "abs": 0.22811428571428571
  },
  {
    "ph": 6.8,
    "nm": 490,
    "abs": 0.22434285714285715
  },
  {
    "ph": 6.9,
    "nm": 490,
    "abs": 0.22062857142857142
  },
  {
    "ph": 7,
    "nm": 490,
    "abs": 0.21685714285714286
  },
  {
    "ph": 7.1,
    "nm": 490,
    "abs": 0.21314285714285713
  },
  {
    "ph": 7.2,
    "nm": 490,
    "abs": 0.20942857142857144
  },
  {
    "ph": 7.3,
    "nm": 490,
    "abs": 0.20565714285714284
  },
  {
    "ph": 7.4,
    "nm": 490,
    "abs": 0.20194285714285715
  },
  {
    "ph": 7.5,
    "nm": 490,
    "abs": 0.19817142857142858
  },
  {
    "ph": 7.6,
    "nm": 490,
    "abs": 0.19445714285714286
  },
  {
    "ph": 7.7,
    "nm": 490,
    "abs": 0.1906857142857143
  },
  {
    "ph": 7.8,
    "nm": 490,
    "abs": 0.18697142857142857
  },
  {
    "ph": 7.9,
    "nm": 490,
    "abs": 0.18325714285714284
  },
  {
    "ph": 8,
    "nm": 490,
    "abs": 0.17948571428571428
  },
  {
    "ph": 5,
    "nm": 495,
    "abs": 0.21782857142857143
  },
  {
    "ph": 5.1,
    "nm": 495,
    "abs": 0.21765714285714285
  },
  {
    "ph": 5.2,
    "nm": 495,
    "abs": 0.21748571428571428
  },
  {
    "ph": 5.3,
    "nm": 495,
    "abs": 0.21731428571428574
  },
  {
    "ph": 5.4,
    "nm": 495,
    "abs": 0.21714285714285714
  },
  {
    "ph": 5.5,
    "nm": 495,
    "abs": 0.21697142857142857
  },
  {
    "ph": 5.6,
    "nm": 495,
    "abs": 0.21685714285714286
  },
  {
    "ph": 5.7,
    "nm": 495,
    "abs": 0.2166857142857143
  },
  {
    "ph": 5.8,
    "nm": 495,
    "abs": 0.21651428571428571
  },
  {
    "ph": 5.9,
    "nm": 495,
    "abs": 0.21634285714285714
  },
  {
    "ph": 6,
    "nm": 495,
    "abs": 0.2161714285714286
  },
  {
    "ph": 6.1,
    "nm": 495,
    "abs": 0.216
  },
  {
    "ph": 6.2,
    "nm": 495,
    "abs": 0.21582857142857143
  },
  {
    "ph": 6.3,
    "nm": 495,
    "abs": 0.21571428571428572
  },
  {
    "ph": 6.4,
    "nm": 495,
    "abs": 0.21554285714285712
  },
  {
    "ph": 6.5,
    "nm": 495,
    "abs": 0.2141142857142857
  },
  {
    "ph": 6.6,
    "nm": 495,
    "abs": 0.212
  },
  {
    "ph": 6.7,
    "nm": 495,
    "abs": 0.2098857142857143
  },
  {
    "ph": 6.8,
    "nm": 495,
    "abs": 0.20777142857142855
  },
  {
    "ph": 6.9,
    "nm": 495,
    "abs": 0.20565714285714284
  },
  {
    "ph": 7,
    "nm": 495,
    "abs": 0.20354285714285716
  },
  {
    "ph": 7.1,
    "nm": 495,
    "abs": 0.20142857142857143
  },
  {
    "ph": 7.2,
    "nm": 495,
    "abs": 0.19931428571428572
  },
  {
    "ph": 7.3,
    "nm": 495,
    "abs": 0.19720000000000001
  },
  {
    "ph": 7.4,
    "nm": 495,
    "abs": 0.19508571428571428
  },
  {
    "ph": 7.5,
    "nm": 495,
    "abs": 0.19297142857142857
  },
  {
    "ph": 7.6,
    "nm": 495,
    "abs": 0.19085714285714286
  },
  {
    "ph": 7.7,
    "nm": 495,
    "abs": 0.18874285714285713
  },
  {
    "ph": 7.8,
    "nm": 495,
    "abs": 0.18662857142857142
  },
  {
    "ph": 7.9,
    "nm": 495,
    "abs": 0.18451428571428571
  },
  {
    "ph": 8,
    "nm": 495,
    "abs": 0.18239999999999998
  },
  {
    "ph": 5,
    "nm": 500,
    "abs": 0.19034285714285715
  },
  {
    "ph": 5.1,
    "nm": 500,
    "abs": 0.19034285714285715
  },
  {
    "ph": 5.2,
    "nm": 500,
    "abs": 0.1902857142857143
  },
  {
    "ph": 5.3,
    "nm": 500,
    "abs": 0.1902285714285714
  },
  {
    "ph": 5.4,
    "nm": 500,
    "abs": 0.19017142857142857
  },
  {
    "ph": 5.5,
    "nm": 500,
    "abs": 0.19017142857142857
  },
  {
    "ph": 5.6,
    "nm": 500,
    "abs": 0.1901142857142857
  },
  {
    "ph": 5.7,
    "nm": 500,
    "abs": 0.19005714285714287
  },
  {
    "ph": 5.8,
    "nm": 500,
    "abs": 0.19
  },
  {
    "ph": 5.9,
    "nm": 500,
    "abs": 0.19
  },
  {
    "ph": 6,
    "nm": 500,
    "abs": 0.18994285714285714
  },
  {
    "ph": 6.1,
    "nm": 500,
    "abs": 0.18988571428571427
  },
  {
    "ph": 6.2,
    "nm": 500,
    "abs": 0.18982857142857143
  },
  {
    "ph": 6.3,
    "nm": 500,
    "abs": 0.18982857142857143
  },
  {
    "ph": 6.4,
    "nm": 500,
    "abs": 0.18977142857142856
  },
  {
    "ph": 6.5,
    "nm": 500,
    "abs": 0.18971428571428572
  },
  {
    "ph": 6.6,
    "nm": 500,
    "abs": 0.18965714285714283
  },
  {
    "ph": 6.7,
    "nm": 500,
    "abs": 0.1896
  },
  {
    "ph": 6.8,
    "nm": 500,
    "abs": 0.1896
  },
  {
    "ph": 6.9,
    "nm": 500,
    "abs": 0.18954285714285715
  },
  {
    "ph": 7,
    "nm": 500,
    "abs": 0.18948571428571429
  },
  {
    "ph": 7.1,
    "nm": 500,
    "abs": 0.18942857142857145
  },
  {
    "ph": 7.2,
    "nm": 500,
    "abs": 0.18942857142857145
  },
  {
    "ph": 7.3,
    "nm": 500,
    "abs": 0.18937142857142855
  },
  {
    "ph": 7.4,
    "nm": 500,
    "abs": 0.1893142857142857
  },
  {
    "ph": 7.5,
    "nm": 500,
    "abs": 0.1896
  },
  {
    "ph": 7.6,
    "nm": 500,
    "abs": 0.1912
  },
  {
    "ph": 7.7,
    "nm": 500,
    "abs": 0.19285714285714287
  },
  {
    "ph": 7.8,
    "nm": 500,
    "abs": 0.19445714285714286
  },
  {
    "ph": 7.9,
    "nm": 500,
    "abs": 0.19605714285714287
  },
  {
    "ph": 8,
    "nm": 500,
    "abs": 0.1977142857142857
  },
  {
    "ph": 5,
    "nm": 505,
    "abs": 0.17085714285714285
  },
  {
    "ph": 5.1,
    "nm": 505,
    "abs": 0.16805714285714285
  },
  {
    "ph": 5.2,
    "nm": 505,
    "abs": 0.1652
  },
  {
    "ph": 5.3,
    "nm": 505,
    "abs": 0.16240000000000002
  },
  {
    "ph": 5.4,
    "nm": 505,
    "abs": 0.15954285714285715
  },
  {
    "ph": 5.5,
    "nm": 505,
    "abs": 0.15674285714285713
  },
  {
    "ph": 5.6,
    "nm": 505,
    "abs": 0.15388571428571426
  },
  {
    "ph": 5.7,
    "nm": 505,
    "abs": 0.1510857142857143
  },
  {
    "ph": 5.8,
    "nm": 505,
    "abs": 0.15102857142857143
  },
  {
    "ph": 5.9,
    "nm": 505,
    "abs": 0.15371428571428572
  },
  {
    "ph": 6,
    "nm": 505,
    "abs": 0.1564
  },
  {
    "ph": 6.1,
    "nm": 505,
    "abs": 0.15908571428571427
  },
  {
    "ph": 6.2,
    "nm": 505,
    "abs": 0.1617142857142857
  },
  {
    "ph": 6.3,
    "nm": 505,
    "abs": 0.16440000000000002
  },
  {
    "ph": 6.4,
    "nm": 505,
    "abs": 0.16708571428571428
  },
  {
    "ph": 6.5,
    "nm": 505,
    "abs": 0.16977142857142855
  },
  {
    "ph": 6.6,
    "nm": 505,
    "abs": 0.17245714285714286
  },
  {
    "ph": 6.7,
    "nm": 505,
    "abs": 0.17514285714285713
  },
  {
    "ph": 6.8,
    "nm": 505,
    "abs": 0.17777142857142855
  },
  {
    "ph": 6.9,
    "nm": 505,
    "abs": 0.18045714285714287
  },
  {
    "ph": 7,
    "nm": 505,
    "abs": 0.18314285714285714
  },
  {
    "ph": 7.1,
    "nm": 505,
    "abs": 0.18582857142857143
  },
  {
    "ph": 7.2,
    "nm": 505,
    "abs": 0.18851428571428572
  },
  {
    "ph": 7.3,
    "nm": 505,
    "abs": 0.1912
  },
  {
    "ph": 7.4,
    "nm": 505,
    "abs": 0.19382857142857143
  },
  {
    "ph": 7.5,
    "nm": 505,
    "abs": 0.1965142857142857
  },
  {
    "ph": 7.6,
    "nm": 505,
    "abs": 0.19920000000000002
  },
  {
    "ph": 7.7,
    "nm": 505,
    "abs": 0.20188571428571428
  },
  {
    "ph": 7.8,
    "nm": 505,
    "abs": 0.20457142857142857
  },
  {
    "ph": 7.9,
    "nm": 505,
    "abs": 0.2072
  },
  {
    "ph": 8,
    "nm": 505,
    "abs": 0.2098857142857143
  },
  {
    "ph": 5,
    "nm": 510,
    "abs": 0.14845714285714284
  },
  {
    "ph": 5.1,
    "nm": 510,
    "abs": 0.1441142857142857
  },
  {
    "ph": 5.2,
    "nm": 510,
    "abs": 0.1397142857142857
  },
  {
    "ph": 5.3,
    "nm": 510,
    "abs": 0.13537142857142856
  },
  {
    "ph": 5.4,
    "nm": 510,
    "abs": 0.13102857142857144
  },
  {
    "ph": 5.5,
    "nm": 510,
    "abs": 0.1266857142857143
  },
  {
    "ph": 5.6,
    "nm": 510,
    "abs": 0.12234285714285716
  },
  {
    "ph": 5.7,
    "nm": 510,
    "abs": 0.12371428571428571
  },
  {
    "ph": 5.8,
    "nm": 510,
    "abs": 0.12828571428571428
  },
  {
    "ph": 5.9,
    "nm": 510,
    "abs": 0.1328
  },
  {
    "ph": 6,
    "nm": 510,
    "abs": 0.13737142857142856
  },
  {
    "ph": 6.1,
    "nm": 510,
    "abs": 0.14194285714285715
  },
  {
    "ph": 6.2,
    "nm": 510,
    "abs": 0.14645714285714284
  },
  {
    "ph": 6.3,
    "nm": 510,
    "abs": 0.15102857142857143
  },
  {
    "ph": 6.4,
    "nm": 510,
    "abs": 0.1556
  },
  {
    "ph": 6.5,
    "nm": 510,
    "abs": 0.1601142857142857
  },
  {
    "ph": 6.6,
    "nm": 510,
    "abs": 0.1646857142857143
  },
  {
    "ph": 6.7,
    "nm": 510,
    "abs": 0.16925714285714286
  },
  {
    "ph": 6.8,
    "nm": 510,
    "abs": 0.17377142857142855
  },
  {
    "ph": 6.9,
    "nm": 510,
    "abs": 0.17834285714285714
  },
  {
    "ph": 7,
    "nm": 510,
    "abs": 0.18291428571428572
  },
  {
    "ph": 7.1,
    "nm": 510,
    "abs": 0.18742857142857144
  },
  {
    "ph": 7.2,
    "nm": 510,
    "abs": 0.192
  },
  {
    "ph": 7.3,
    "nm": 510,
    "abs": 0.19657142857142856
  },
  {
    "ph": 7.4,
    "nm": 510,
    "abs": 0.20108571428571428
  },
  {
    "ph": 7.5,
    "nm": 510,
    "abs": 0.20565714285714284
  },
  {
    "ph": 7.6,
    "nm": 510,
    "abs": 0.21022857142857143
  },
  {
    "ph": 7.7,
    "nm": 510,
    "abs": 0.21474285714285715
  },
  {
    "ph": 7.8,
    "nm": 510,
    "abs": 0.2193142857142857
  },
  {
    "ph": 7.9,
    "nm": 510,
    "abs": 0.22388571428571427
  },
  {
    "ph": 8,
    "nm": 510,
    "abs": 0.2284
  },
  {
    "ph": 5,
    "nm": 515,
    "abs": 0.12605714285714284
  },
  {
    "ph": 5.1,
    "nm": 515,
    "abs": 0.1224
  },
  {
    "ph": 5.2,
    "nm": 515,
    "abs": 0.11874285714285715
  },
  {
    "ph": 5.3,
    "nm": 515,
    "abs": 0.11508571428571428
  },
  {
    "ph": 5.4,
    "nm": 515,
    "abs": 0.11148571428571429
  },
  {
    "ph": 5.5,
    "nm": 515,
    "abs": 0.10782857142857143
  },
  {
    "ph": 5.6,
    "nm": 515,
    "abs": 0.10417142857142857
  },
  {
    "ph": 5.7,
    "nm": 515,
    "abs": 0.10594285714285714
  },
  {
    "ph": 5.8,
    "nm": 515,
    "abs": 0.11205714285714286
  },
  {
    "ph": 5.9,
    "nm": 515,
    "abs": 0.11811428571428571
  },
  {
    "ph": 6,
    "nm": 515,
    "abs": 0.12422857142857144
  },
  {
    "ph": 6.1,
    "nm": 515,
    "abs": 0.13028571428571428
  },
  {
    "ph": 6.2,
    "nm": 515,
    "abs": 0.1364
  },
  {
    "ph": 6.3,
    "nm": 515,
    "abs": 0.14245714285714287
  },
  {
    "ph": 6.4,
    "nm": 515,
    "abs": 0.14857142857142858
  },
  {
    "ph": 6.5,
    "nm": 515,
    "abs": 0.15462857142857142
  },
  {
    "ph": 6.6,
    "nm": 515,
    "abs": 0.16074285714285713
  },
  {
    "ph": 6.7,
    "nm": 515,
    "abs": 0.1668
  },
  {
    "ph": 6.8,
    "nm": 515,
    "abs": 0.17291428571428571
  },
  {
    "ph": 6.9,
    "nm": 515,
    "abs": 0.17902857142857145
  },
  {
    "ph": 7,
    "nm": 515,
    "abs": 0.1850857142857143
  },
  {
    "ph": 7.1,
    "nm": 515,
    "abs": 0.1912
  },
  {
    "ph": 7.2,
    "nm": 515,
    "abs": 0.19725714285714285
  },
  {
    "ph": 7.3,
    "nm": 515,
    "abs": 0.20337142857142856
  },
  {
    "ph": 7.4,
    "nm": 515,
    "abs": 0.20942857142857144
  },
  {
    "ph": 7.5,
    "nm": 515,
    "abs": 0.21554285714285712
  },
  {
    "ph": 7.6,
    "nm": 515,
    "abs": 0.2216
  },
  {
    "ph": 7.7,
    "nm": 515,
    "abs": 0.22771428571428573
  },
  {
    "ph": 7.8,
    "nm": 515,
    "abs": 0.23377142857142857
  },
  {
    "ph": 7.9,
    "nm": 515,
    "abs": 0.23988571428571429
  },
  {
    "ph": 8,
    "nm": 515,
    "abs": 0.24594285714285716
  },
  {
    "ph": 5,
    "nm": 520,
    "abs": 0.10365714285714286
  },
  {
    "ph": 5.1,
    "nm": 520,
    "abs": 0.10251428571428571
  },
  {
    "ph": 5.2,
    "nm": 520,
    "abs": 0.10137142857142857
  },
  {
    "ph": 5.3,
    "nm": 520,
    "abs": 0.10028571428571428
  },
  {
    "ph": 5.4,
    "nm": 520,
    "abs": 0.09914285714285713
  },
  {
    "ph": 5.5,
    "nm": 520,
    "abs": 0.098
  },
  {
    "ph": 5.6,
    "nm": 520,
    "abs": 0.09691428571428572
  },
  {
    "ph": 5.7,
    "nm": 520,
    "abs": 0.09577142857142858
  },
  {
    "ph": 5.8,
    "nm": 520,
    "abs": 0.09582857142857142
  },
  {
    "ph": 5.9,
    "nm": 520,
    "abs": 0.10342857142857143
  },
  {
    "ph": 6,
    "nm": 520,
    "abs": 0.11108571428571427
  },
  {
    "ph": 6.1,
    "nm": 520,
    "abs": 0.11868571428571428
  },
  {
    "ph": 6.2,
    "nm": 520,
    "abs": 0.12628571428571428
  },
  {
    "ph": 6.3,
    "nm": 520,
    "abs": 0.13394285714285714
  },
  {
    "ph": 6.4,
    "nm": 520,
    "abs": 0.14154285714285714
  },
  {
    "ph": 6.5,
    "nm": 520,
    "abs": 0.1492
  },
  {
    "ph": 6.6,
    "nm": 520,
    "abs": 0.1568
  },
  {
    "ph": 6.7,
    "nm": 520,
    "abs": 0.16440000000000002
  },
  {
    "ph": 6.8,
    "nm": 520,
    "abs": 0.17205714285714285
  },
  {
    "ph": 6.9,
    "nm": 520,
    "abs": 0.17965714285714288
  },
  {
    "ph": 7,
    "nm": 520,
    "abs": 0.18725714285714284
  },
  {
    "ph": 7.1,
    "nm": 520,
    "abs": 0.19491428571428573
  },
  {
    "ph": 7.2,
    "nm": 520,
    "abs": 0.2025142857142857
  },
  {
    "ph": 7.3,
    "nm": 520,
    "abs": 0.21011428571428573
  },
  {
    "ph": 7.4,
    "nm": 520,
    "abs": 0.21777142857142856
  },
  {
    "ph": 7.5,
    "nm": 520,
    "abs": 0.22537142857142856
  },
  {
    "ph": 7.6,
    "nm": 520,
    "abs": 0.23297142857142858
  },
  {
    "ph": 7.7,
    "nm": 520,
    "abs": 0.24062857142857141
  },
  {
    "ph": 7.8,
    "nm": 520,
    "abs": 0.24822857142857144
  },
  {
    "ph": 7.9,
    "nm": 520,
    "abs": 0.2558285714285714
  },
  {
    "ph": 8,
    "nm": 520,
    "abs": 0.26348571428571427
  },
  {
    "ph": 5,
    "nm": 525,
    "abs": 0.08125714285714285
  },
  {
    "ph": 5.1,
    "nm": 525,
    "abs": 0.08262857142857143
  },
  {
    "ph": 5.2,
    "nm": 525,
    "abs": 0.08399999999999999
  },
  {
    "ph": 5.3,
    "nm": 525,
    "abs": 0.08542857142857142
  },
  {
    "ph": 5.4,
    "nm": 525,
    "abs": 0.0868
  },
  {
    "ph": 5.5,
    "nm": 525,
    "abs": 0.08822857142857143
  },
  {
    "ph": 5.6,
    "nm": 525,
    "abs": 0.0896
  },
  {
    "ph": 5.7,
    "nm": 525,
    "abs": 0.09102857142857143
  },
  {
    "ph": 5.8,
    "nm": 525,
    "abs": 0.09240000000000001
  },
  {
    "ph": 5.9,
    "nm": 525,
    "abs": 0.09382857142857144
  },
  {
    "ph": 6,
    "nm": 525,
    "abs": 0.09794285714285714
  },
  {
    "ph": 6.1,
    "nm": 525,
    "abs": 0.1070857142857143
  },
  {
    "ph": 6.2,
    "nm": 525,
    "abs": 0.11622857142857143
  },
  {
    "ph": 6.3,
    "nm": 525,
    "abs": 0.12537142857142858
  },
  {
    "ph": 6.4,
    "nm": 525,
    "abs": 0.13451428571428573
  },
  {
    "ph": 6.5,
    "nm": 525,
    "abs": 0.1437142857142857
  },
  {
    "ph": 6.6,
    "nm": 525,
    "abs": 0.15285714285714286
  },
  {
    "ph": 6.7,
    "nm": 525,
    "abs": 0.16199999999999998
  },
  {
    "ph": 6.8,
    "nm": 525,
    "abs": 0.17114285714285712
  },
  {
    "ph": 6.9,
    "nm": 525,
    "abs": 0.1802857142857143
  },
  {
    "ph": 7,
    "nm": 525,
    "abs": 0.18942857142857145
  },
  {
    "ph": 7.1,
    "nm": 525,
    "abs": 0.19862857142857143
  },
  {
    "ph": 7.2,
    "nm": 525,
    "abs": 0.20777142857142855
  },
  {
    "ph": 7.3,
    "nm": 525,
    "abs": 0.2169142857142857
  },
  {
    "ph": 7.4,
    "nm": 525,
    "abs": 0.22605714285714287
  },
  {
    "ph": 7.5,
    "nm": 525,
    "abs": 0.23520000000000002
  },
  {
    "ph": 7.6,
    "nm": 525,
    "abs": 0.2444
  },
  {
    "ph": 7.7,
    "nm": 525,
    "abs": 0.2535428571428571
  },
  {
    "ph": 7.8,
    "nm": 525,
    "abs": 0.2626857142857143
  },
  {
    "ph": 7.9,
    "nm": 525,
    "abs": 0.2718285714285714
  },
  {
    "ph": 8,
    "nm": 525,
    "abs": 0.2809714285714286
  },
  {
    "ph": 5,
    "nm": 530,
    "abs": 0.07034285714285714
  },
  {
    "ph": 5.1,
    "nm": 530,
    "abs": 0.07182857142857144
  },
  {
    "ph": 5.2,
    "nm": 530,
    "abs": 0.07337142857142856
  },
  {
    "ph": 5.3,
    "nm": 530,
    "abs": 0.07485714285714286
  },
  {
    "ph": 5.4,
    "nm": 530,
    "abs": 0.07640000000000001
  },
  {
    "ph": 5.5,
    "nm": 530,
    "abs": 0.0778857142857143
  },
  {
    "ph": 5.6,
    "nm": 530,
    "abs": 0.07942857142857143
  },
  {
    "ph": 5.7,
    "nm": 530,
    "abs": 0.08091428571428572
  },
  {
    "ph": 5.8,
    "nm": 530,
    "abs": 0.08245714285714287
  },
  {
    "ph": 5.9,
    "nm": 530,
    "abs": 0.08394285714285714
  },
  {
    "ph": 6,
    "nm": 530,
    "abs": 0.08548571428571429
  },
  {
    "ph": 6.1,
    "nm": 530,
    "abs": 0.09617142857142857
  },
  {
    "ph": 6.2,
    "nm": 530,
    "abs": 0.10685714285714286
  },
  {
    "ph": 6.3,
    "nm": 530,
    "abs": 0.11754285714285714
  },
  {
    "ph": 6.4,
    "nm": 530,
    "abs": 0.12828571428571428
  },
  {
    "ph": 6.5,
    "nm": 530,
    "abs": 0.13897142857142858
  },
  {
    "ph": 6.6,
    "nm": 530,
    "abs": 0.14965714285714288
  },
  {
    "ph": 6.7,
    "nm": 530,
    "abs": 0.16034285714285715
  },
  {
    "ph": 6.8,
    "nm": 530,
    "abs": 0.17108571428571429
  },
  {
    "ph": 6.9,
    "nm": 530,
    "abs": 0.18177142857142856
  },
  {
    "ph": 7,
    "nm": 530,
    "abs": 0.19245714285714285
  },
  {
    "ph": 7.1,
    "nm": 530,
    "abs": 0.20314285714285713
  },
  {
    "ph": 7.2,
    "nm": 530,
    "abs": 0.2138857142857143
  },
  {
    "ph": 7.3,
    "nm": 530,
    "abs": 0.2245714285714286
  },
  {
    "ph": 7.4,
    "nm": 530,
    "abs": 0.23525714285714286
  },
  {
    "ph": 7.5,
    "nm": 530,
    "abs": 0.24594285714285716
  },
  {
    "ph": 7.6,
    "nm": 530,
    "abs": 0.25662857142857143
  },
  {
    "ph": 7.7,
    "nm": 530,
    "abs": 0.26737142857142854
  },
  {
    "ph": 7.8,
    "nm": 530,
    "abs": 0.27805714285714284
  },
  {
    "ph": 7.9,
    "nm": 530,
    "abs": 0.28874285714285713
  },
  {
    "ph": 8,
    "nm": 530,
    "abs": 0.29942857142857143
  },
  {
    "ph": 5,
    "nm": 535,
    "abs": 0.062171428571428565
  },
  {
    "ph": 5.1,
    "nm": 535,
    "abs": 0.06348571428571428
  },
  {
    "ph": 5.2,
    "nm": 535,
    "abs": 0.06474285714285714
  },
  {
    "ph": 5.3,
    "nm": 535,
    "abs": 0.06605714285714286
  },
  {
    "ph": 5.4,
    "nm": 535,
    "abs": 0.06731428571428572
  },
  {
    "ph": 5.5,
    "nm": 535,
    "abs": 0.06862857142857143
  },
  {
    "ph": 5.6,
    "nm": 535,
    "abs": 0.06988571428571429
  },
  {
    "ph": 5.7,
    "nm": 535,
    "abs": 0.0712
  },
  {
    "ph": 5.8,
    "nm": 535,
    "abs": 0.07245714285714286
  },
  {
    "ph": 5.9,
    "nm": 535,
    "abs": 0.07377142857142857
  },
  {
    "ph": 6,
    "nm": 535,
    "abs": 0.07902857142857143
  },
  {
    "ph": 6.1,
    "nm": 535,
    "abs": 0.09165714285714285
  },
  {
    "ph": 6.2,
    "nm": 535,
    "abs": 0.10434285714285715
  },
  {
    "ph": 6.3,
    "nm": 535,
    "abs": 0.11697142857142857
  },
  {
    "ph": 6.4,
    "nm": 535,
    "abs": 0.1296
  },
  {
    "ph": 6.5,
    "nm": 535,
    "abs": 0.14222857142857143
  },
  {
    "ph": 6.6,
    "nm": 535,
    "abs": 0.15485714285714286
  },
  {
    "ph": 6.7,
    "nm": 535,
    "abs": 0.1674857142857143
  },
  {
    "ph": 6.8,
    "nm": 535,
    "abs": 0.1801142857142857
  },
  {
    "ph": 6.9,
    "nm": 535,
    "abs": 0.19274285714285713
  },
  {
    "ph": 7,
    "nm": 535,
    "abs": 0.20542857142857143
  },
  {
    "ph": 7.1,
    "nm": 535,
    "abs": 0.21805714285714287
  },
  {
    "ph": 7.2,
    "nm": 535,
    "abs": 0.2306857142857143
  },
  {
    "ph": 7.3,
    "nm": 535,
    "abs": 0.24331428571428573
  },
  {
    "ph": 7.4,
    "nm": 535,
    "abs": 0.25594285714285714
  },
  {
    "ph": 7.5,
    "nm": 535,
    "abs": 0.26857142857142857
  },
  {
    "ph": 7.6,
    "nm": 535,
    "abs": 0.2812
  },
  {
    "ph": 7.7,
    "nm": 535,
    "abs": 0.29382857142857144
  },
  {
    "ph": 7.8,
    "nm": 535,
    "abs": 0.3065142857142857
  },
  {
    "ph": 7.9,
    "nm": 535,
    "abs": 0.3191428571428571
  },
  {
    "ph": 8,
    "nm": 535,
    "abs": 0.33177142857142855
  },
  {
    "ph": 5,
    "nm": 540,
    "abs": 0.05194285714285714
  },
  {
    "ph": 5.1,
    "nm": 540,
    "abs": 0.054228571428571425
  },
  {
    "ph": 5.2,
    "nm": 540,
    "abs": 0.05657142857142857
  },
  {
    "ph": 5.3,
    "nm": 540,
    "abs": 0.05885714285714285
  },
  {
    "ph": 5.4,
    "nm": 540,
    "abs": 0.0612
  },
  {
    "ph": 5.5,
    "nm": 540,
    "abs": 0.06348571428571428
  },
  {
    "ph": 5.6,
    "nm": 540,
    "abs": 0.06582857142857143
  },
  {
    "ph": 5.7,
    "nm": 540,
    "abs": 0.06811428571428571
  },
  {
    "ph": 5.8,
    "nm": 540,
    "abs": 0.07045714285714286
  },
  {
    "ph": 5.9,
    "nm": 540,
    "abs": 0.07274285714285714
  },
  {
    "ph": 6,
    "nm": 540,
    "abs": 0.07502857142857143
  },
  {
    "ph": 6.1,
    "nm": 540,
    "abs": 0.0818857142857143
  },
  {
    "ph": 6.2,
    "nm": 540,
    "abs": 0.09685714285714286
  },
  {
    "ph": 6.3,
    "nm": 540,
    "abs": 0.11188571428571428
  },
  {
    "ph": 6.4,
    "nm": 540,
    "abs": 0.12685714285714286
  },
  {
    "ph": 6.5,
    "nm": 540,
    "abs": 0.14182857142857144
  },
  {
    "ph": 6.6,
    "nm": 540,
    "abs": 0.1568
  },
  {
    "ph": 6.7,
    "nm": 540,
    "abs": 0.17182857142857144
  },
  {
    "ph": 6.8,
    "nm": 540,
    "abs": 0.18680000000000002
  },
  {
    "ph": 6.9,
    "nm": 540,
    "abs": 0.20177142857142857
  },
  {
    "ph": 7,
    "nm": 540,
    "abs": 0.21680000000000002
  },
  {
    "ph": 7.1,
    "nm": 540,
    "abs": 0.23177142857142857
  },
  {
    "ph": 7.2,
    "nm": 540,
    "abs": 0.24674285714285715
  },
  {
    "ph": 7.3,
    "nm": 540,
    "abs": 0.2617714285714286
  },
  {
    "ph": 7.4,
    "nm": 540,
    "abs": 0.2767428571428571
  },
  {
    "ph": 7.5,
    "nm": 540,
    "abs": 0.2917142857142857
  },
  {
    "ph": 7.6,
    "nm": 540,
    "abs": 0.3066857142857143
  },
  {
    "ph": 7.7,
    "nm": 540,
    "abs": 0.3217142857142857
  },
  {
    "ph": 7.8,
    "nm": 540,
    "abs": 0.33668571428571425
  },
  {
    "ph": 7.9,
    "nm": 540,
    "abs": 0.35165714285714283
  },
  {
    "ph": 8,
    "nm": 540,
    "abs": 0.36668571428571434
  },
  {
    "ph": 5,
    "nm": 545,
    "abs": 0.04251428571428571
  },
  {
    "ph": 5.1,
    "nm": 545,
    "abs": 0.04537142857142857
  },
  {
    "ph": 5.2,
    "nm": 545,
    "abs": 0.04817142857142857
  },
  {
    "ph": 5.3,
    "nm": 545,
    "abs": 0.05102857142857143
  },
  {
    "ph": 5.4,
    "nm": 545,
    "abs": 0.053828571428571434
  },
  {
    "ph": 5.5,
    "nm": 545,
    "abs": 0.056685714285714284
  },
  {
    "ph": 5.6,
    "nm": 545,
    "abs": 0.05948571428571429
  },
  {
    "ph": 5.7,
    "nm": 545,
    "abs": 0.062342857142857144
  },
  {
    "ph": 5.8,
    "nm": 545,
    "abs": 0.06514285714285714
  },
  {
    "ph": 5.9,
    "nm": 545,
    "abs": 0.06794285714285715
  },
  {
    "ph": 6,
    "nm": 545,
    "abs": 0.0708
  },
  {
    "ph": 6.1,
    "nm": 545,
    "abs": 0.07365714285714285
  },
  {
    "ph": 6.2,
    "nm": 545,
    "abs": 0.09091428571428571
  },
  {
    "ph": 6.3,
    "nm": 545,
    "abs": 0.10811428571428572
  },
  {
    "ph": 6.4,
    "nm": 545,
    "abs": 0.12537142857142858
  },
  {
    "ph": 6.5,
    "nm": 545,
    "abs": 0.14257142857142857
  },
  {
    "ph": 6.6,
    "nm": 545,
    "abs": 0.15982857142857143
  },
  {
    "ph": 6.7,
    "nm": 545,
    "abs": 0.17702857142857145
  },
  {
    "ph": 6.8,
    "nm": 545,
    "abs": 0.1942857142857143
  },
  {
    "ph": 6.9,
    "nm": 545,
    "abs": 0.21148571428571428
  },
  {
    "ph": 7,
    "nm": 545,
    "abs": 0.22874285714285714
  },
  {
    "ph": 7.1,
    "nm": 545,
    "abs": 0.24594285714285716
  },
  {
    "ph": 7.2,
    "nm": 545,
    "abs": 0.2632
  },
  {
    "ph": 7.3,
    "nm": 545,
    "abs": 0.28040000000000004
  },
  {
    "ph": 7.4,
    "nm": 545,
    "abs": 0.2976571428571429
  },
  {
    "ph": 7.5,
    "nm": 545,
    "abs": 0.3148571428571429
  },
  {
    "ph": 7.6,
    "nm": 545,
    "abs": 0.33211428571428575
  },
  {
    "ph": 7.7,
    "nm": 545,
    "abs": 0.3493142857142857
  },
  {
    "ph": 7.8,
    "nm": 545,
    "abs": 0.36657142857142855
  },
  {
    "ph": 7.9,
    "nm": 545,
    "abs": 0.38377142857142854
  },
  {
    "ph": 8,
    "nm": 545,
    "abs": 0.4010285714285714
  },
  {
    "ph": 5,
    "nm": 550,
    "abs": 0.038457142857142856
  },
  {
    "ph": 5.1,
    "nm": 550,
    "abs": 0.03862857142857142
  },
  {
    "ph": 5.2,
    "nm": 550,
    "abs": 0.03874285714285714
  },
  {
    "ph": 5.3,
    "nm": 550,
    "abs": 0.038914285714285714
  },
  {
    "ph": 5.4,
    "nm": 550,
    "abs": 0.039028571428571426
  },
  {
    "ph": 5.5,
    "nm": 550,
    "abs": 0.0392
  },
  {
    "ph": 5.6,
    "nm": 550,
    "abs": 0.03931428571428571
  },
  {
    "ph": 5.7,
    "nm": 550,
    "abs": 0.039485714285714284
  },
  {
    "ph": 5.8,
    "nm": 550,
    "abs": 0.039657142857142856
  },
  {
    "ph": 5.9,
    "nm": 550,
    "abs": 0.04531428571428571
  },
  {
    "ph": 6,
    "nm": 550,
    "abs": 0.06371428571428571
  },
  {
    "ph": 6.1,
    "nm": 550,
    "abs": 0.08217142857142858
  },
  {
    "ph": 6.2,
    "nm": 550,
    "abs": 0.10057142857142856
  },
  {
    "ph": 6.3,
    "nm": 550,
    "abs": 0.11902857142857144
  },
  {
    "ph": 6.4,
    "nm": 550,
    "abs": 0.1374857142857143
  },
  {
    "ph": 6.5,
    "nm": 550,
    "abs": 0.15588571428571427
  },
  {
    "ph": 6.6,
    "nm": 550,
    "abs": 0.17434285714285713
  },
  {
    "ph": 6.7,
    "nm": 550,
    "abs": 0.19274285714285713
  },
  {
    "ph": 6.8,
    "nm": 550,
    "abs": 0.2112
  },
  {
    "ph": 6.9,
    "nm": 550,
    "abs": 0.22965714285714284
  },
  {
    "ph": 7,
    "nm": 550,
    "abs": 0.24805714285714284
  },
  {
    "ph": 7.1,
    "nm": 550,
    "abs": 0.2665142857142857
  },
  {
    "ph": 7.2,
    "nm": 550,
    "abs": 0.28491428571428573
  },
  {
    "ph": 7.3,
    "nm": 550,
    "abs": 0.30337142857142857
  },
  {
    "ph": 7.4,
    "nm": 550,
    "abs": 0.32182857142857146
  },
  {
    "ph": 7.5,
    "nm": 550,
    "abs": 0.34022857142857144
  },
  {
    "ph": 7.6,
    "nm": 550,
    "abs": 0.35868571428571433
  },
  {
    "ph": 7.7,
    "nm": 550,
    "abs": 0.3770857142857143
  },
  {
    "ph": 7.8,
    "nm": 550,
    "abs": 0.39554285714285714
  },
  {
    "ph": 7.9,
    "nm": 550,
    "abs": 0.41400000000000003
  },
  {
    "ph": 8,
    "nm": 550,
    "abs": 0.4324
  },
  {
    "ph": 5,
    "nm": 555,
    "abs": 0.030571428571428572
  },
  {
    "ph": 5.1,
    "nm": 555,
    "abs": 0.031200000000000002
  },
  {
    "ph": 5.2,
    "nm": 555,
    "abs": 0.03177142857142857
  },
  {
    "ph": 5.3,
    "nm": 555,
    "abs": 0.0324
  },
  {
    "ph": 5.4,
    "nm": 555,
    "abs": 0.03302857142857143
  },
  {
    "ph": 5.5,
    "nm": 555,
    "abs": 0.03365714285714286
  },
  {
    "ph": 5.6,
    "nm": 555,
    "abs": 0.03428571428571429
  },
  {
    "ph": 5.7,
    "nm": 555,
    "abs": 0.03485714285714286
  },
  {
    "ph": 5.8,
    "nm": 555,
    "abs": 0.03548571428571429
  },
  {
    "ph": 5.9,
    "nm": 555,
    "abs": 0.04131428571428571
  },
  {
    "ph": 6,
    "nm": 555,
    "abs": 0.061657142857142855
  },
  {
    "ph": 6.1,
    "nm": 555,
    "abs": 0.08205714285714286
  },
  {
    "ph": 6.2,
    "nm": 555,
    "abs": 0.1024
  },
  {
    "ph": 6.3,
    "nm": 555,
    "abs": 0.1228
  },
  {
    "ph": 6.4,
    "nm": 555,
    "abs": 0.14314285714285716
  },
  {
    "ph": 6.5,
    "nm": 555,
    "abs": 0.1634857142857143
  },
  {
    "ph": 6.6,
    "nm": 555,
    "abs": 0.18388571428571426
  },
  {
    "ph": 6.7,
    "nm": 555,
    "abs": 0.20422857142857143
  },
  {
    "ph": 6.8,
    "nm": 555,
    "abs": 0.22462857142857143
  },
  {
    "ph": 6.9,
    "nm": 555,
    "abs": 0.2449714285714286
  },
  {
    "ph": 7,
    "nm": 555,
    "abs": 0.2653142857142857
  },
  {
    "ph": 7.1,
    "nm": 555,
    "abs": 0.2857142857142857
  },
  {
    "ph": 7.2,
    "nm": 555,
    "abs": 0.30605714285714286
  },
  {
    "ph": 7.3,
    "nm": 555,
    "abs": 0.3264571428571429
  },
  {
    "ph": 7.4,
    "nm": 555,
    "abs": 0.3468
  },
  {
    "ph": 7.5,
    "nm": 555,
    "abs": 0.36719999999999997
  },
  {
    "ph": 7.6,
    "nm": 555,
    "abs": 0.38754285714285713
  },
  {
    "ph": 7.7,
    "nm": 555,
    "abs": 0.4078857142857143
  },
  {
    "ph": 7.8,
    "nm": 555,
    "abs": 0.4282857142857143
  },
  {
    "ph": 7.9,
    "nm": 555,
    "abs": 0.44862857142857143
  },
  {
    "ph": 8,
    "nm": 555,
    "abs": 0.4690285714285714
  },
  {
    "ph": 5,
    "nm": 560,
    "abs": 0.022628571428571432
  },
  {
    "ph": 5.1,
    "nm": 560,
    "abs": 0.02497142857142857
  },
  {
    "ph": 5.2,
    "nm": 560,
    "abs": 0.027314285714285715
  },
  {
    "ph": 5.3,
    "nm": 560,
    "abs": 0.029599999999999998
  },
  {
    "ph": 5.4,
    "nm": 560,
    "abs": 0.03194285714285714
  },
  {
    "ph": 5.5,
    "nm": 560,
    "abs": 0.03422857142857143
  },
  {
    "ph": 5.6,
    "nm": 560,
    "abs": 0.036571428571428574
  },
  {
    "ph": 5.7,
    "nm": 560,
    "abs": 0.03885714285714286
  },
  {
    "ph": 5.8,
    "nm": 560,
    "abs": 0.0412
  },
  {
    "ph": 5.9,
    "nm": 560,
    "abs": 0.04354285714285715
  },
  {
    "ph": 6,
    "nm": 560,
    "abs": 0.06188571428571428
  },
  {
    "ph": 6.1,
    "nm": 560,
    "abs": 0.08428571428571428
  },
  {
    "ph": 6.2,
    "nm": 560,
    "abs": 0.10668571428571429
  },
  {
    "ph": 6.3,
    "nm": 560,
    "abs": 0.12908571428571428
  },
  {
    "ph": 6.4,
    "nm": 560,
    "abs": 0.15142857142857144
  },
  {
    "ph": 6.5,
    "nm": 560,
    "abs": 0.17382857142857144
  },
  {
    "ph": 6.6,
    "nm": 560,
    "abs": 0.19622857142857142
  },
  {
    "ph": 6.7,
    "nm": 560,
    "abs": 0.21862857142857142
  },
  {
    "ph": 6.8,
    "nm": 560,
    "abs": 0.2409714285714286
  },
  {
    "ph": 6.9,
    "nm": 560,
    "abs": 0.26337142857142853
  },
  {
    "ph": 7,
    "nm": 560,
    "abs": 0.28577142857142857
  },
  {
    "ph": 7.1,
    "nm": 560,
    "abs": 0.3081714285714286
  },
  {
    "ph": 7.2,
    "nm": 560,
    "abs": 0.3305142857142857
  },
  {
    "ph": 7.3,
    "nm": 560,
    "abs": 0.35291428571428574
  },
  {
    "ph": 7.4,
    "nm": 560,
    "abs": 0.37531428571428577
  },
  {
    "ph": 7.5,
    "nm": 560,
    "abs": 0.3977142857142857
  },
  {
    "ph": 7.6,
    "nm": 560,
    "abs": 0.42005714285714285
  },
  {
    "ph": 7.7,
    "nm": 560,
    "abs": 0.4424571428571428
  },
  {
    "ph": 7.8,
    "nm": 560,
    "abs": 0.46485714285714286
  },
  {
    "ph": 7.9,
    "nm": 560,
    "abs": 0.4872571428571429
  },
  {
    "ph": 8,
    "nm": 560,
    "abs": 0.5096
  },
  {
    "ph": 5,
    "nm": 565,
    "abs": 0.018914285714285713
  },
  {
    "ph": 5.1,
    "nm": 565,
    "abs": 0.022114285714285715
  },
  {
    "ph": 5.2,
    "nm": 565,
    "abs": 0.02525714285714286
  },
  {
    "ph": 5.3,
    "nm": 565,
    "abs": 0.028457142857142854
  },
  {
    "ph": 5.4,
    "nm": 565,
    "abs": 0.031657142857142856
  },
  {
    "ph": 5.5,
    "nm": 565,
    "abs": 0.03485714285714286
  },
  {
    "ph": 5.6,
    "nm": 565,
    "abs": 0.03805714285714286
  },
  {
    "ph": 5.7,
    "nm": 565,
    "abs": 0.0412
  },
  {
    "ph": 5.8,
    "nm": 565,
    "abs": 0.0444
  },
  {
    "ph": 5.9,
    "nm": 565,
    "abs": 0.047599999999999996
  },
  {
    "ph": 6,
    "nm": 565,
    "abs": 0.06451428571428572
  },
  {
    "ph": 6.1,
    "nm": 565,
    "abs": 0.08897142857142858
  },
  {
    "ph": 6.2,
    "nm": 565,
    "abs": 0.11348571428571429
  },
  {
    "ph": 6.3,
    "nm": 565,
    "abs": 0.13794285714285714
  },
  {
    "ph": 6.4,
    "nm": 565,
    "abs": 0.16240000000000002
  },
  {
    "ph": 6.5,
    "nm": 565,
    "abs": 0.18691428571428573
  },
  {
    "ph": 6.6,
    "nm": 565,
    "abs": 0.21137142857142857
  },
  {
    "ph": 6.7,
    "nm": 565,
    "abs": 0.23582857142857144
  },
  {
    "ph": 6.8,
    "nm": 565,
    "abs": 0.26034285714285715
  },
  {
    "ph": 6.9,
    "nm": 565,
    "abs": 0.2848
  },
  {
    "ph": 7,
    "nm": 565,
    "abs": 0.30925714285714284
  },
  {
    "ph": 7.1,
    "nm": 565,
    "abs": 0.33377142857142855
  },
  {
    "ph": 7.2,
    "nm": 565,
    "abs": 0.35822857142857145
  },
  {
    "ph": 7.3,
    "nm": 565,
    "abs": 0.38268571428571424
  },
  {
    "ph": 7.4,
    "nm": 565,
    "abs": 0.4072
  },
  {
    "ph": 7.5,
    "nm": 565,
    "abs": 0.43165714285714285
  },
  {
    "ph": 7.6,
    "nm": 565,
    "abs": 0.45611428571428575
  },
  {
    "ph": 7.7,
    "nm": 565,
    "abs": 0.4806285714285714
  },
  {
    "ph": 7.8,
    "nm": 565,
    "abs": 0.5050857142857142
  },
  {
    "ph": 7.9,
    "nm": 565,
    "abs": 0.5295428571428571
  },
  {
    "ph": 8,
    "nm": 565,
    "abs": 0.5540571428571429
  },
  {
    "ph": 5,
    "nm": 570,
    "abs": 0.01902857142857143
  },
  {
    "ph": 5.1,
    "nm": 570,
    "abs": 0.022342857142857143
  },
  {
    "ph": 5.2,
    "nm": 570,
    "abs": 0.0256
  },
  {
    "ph": 5.3,
    "nm": 570,
    "abs": 0.02885714285714286
  },
  {
    "ph": 5.4,
    "nm": 570,
    "abs": 0.03217142857142857
  },
  {
    "ph": 5.5,
    "nm": 570,
    "abs": 0.03542857142857143
  },
  {
    "ph": 5.6,
    "nm": 570,
    "abs": 0.03874285714285714
  },
  {
    "ph": 5.7,
    "nm": 570,
    "abs": 0.041999999999999996
  },
  {
    "ph": 5.8,
    "nm": 570,
    "abs": 0.04531428571428571
  },
  {
    "ph": 5.9,
    "nm": 570,
    "abs": 0.04857142857142858
  },
  {
    "ph": 6,
    "nm": 570,
    "abs": 0.06748571428571429
  },
  {
    "ph": 6.1,
    "nm": 570,
    "abs": 0.09422857142857143
  },
  {
    "ph": 6.2,
    "nm": 570,
    "abs": 0.12091428571428572
  },
  {
    "ph": 6.3,
    "nm": 570,
    "abs": 0.14765714285714288
  },
  {
    "ph": 6.4,
    "nm": 570,
    "abs": 0.17440000000000003
  },
  {
    "ph": 6.5,
    "nm": 570,
    "abs": 0.20108571428571428
  },
  {
    "ph": 6.6,
    "nm": 570,
    "abs": 0.22782857142857144
  },
  {
    "ph": 6.7,
    "nm": 570,
    "abs": 0.25457142857142856
  },
  {
    "ph": 6.8,
    "nm": 570,
    "abs": 0.28125714285714287
  },
  {
    "ph": 6.9,
    "nm": 570,
    "abs": 0.308
  },
  {
    "ph": 7,
    "nm": 570,
    "abs": 0.3347428571428571
  },
  {
    "ph": 7.1,
    "nm": 570,
    "abs": 0.3614857142857143
  },
  {
    "ph": 7.2,
    "nm": 570,
    "abs": 0.38817142857142856
  },
  {
    "ph": 7.3,
    "nm": 570,
    "abs": 0.4149142857142857
  },
  {
    "ph": 7.4,
    "nm": 570,
    "abs": 0.44165714285714286
  },
  {
    "ph": 7.5,
    "nm": 570,
    "abs": 0.4683428571428571
  },
  {
    "ph": 7.6,
    "nm": 570,
    "abs": 0.49508571428571424
  },
  {
    "ph": 7.7,
    "nm": 570,
    "abs": 0.5218285714285714
  },
  {
    "ph": 7.8,
    "nm": 570,
    "abs": 0.5485714285714286
  },
  {
    "ph": 7.9,
    "nm": 570,
    "abs": 0.5752571428571428
  },
  {
    "ph": 8,
    "nm": 570,
    "abs": 0.6020000000000001
  },
  {
    "ph": 5,
    "nm": 575,
    "abs": 0.0152
  },
  {
    "ph": 5.1,
    "nm": 575,
    "abs": 0.020971428571428575
  },
  {
    "ph": 5.2,
    "nm": 575,
    "abs": 0.026685714285714285
  },
  {
    "ph": 5.3,
    "nm": 575,
    "abs": 0.03245714285714286
  },
  {
    "ph": 5.4,
    "nm": 575,
    "abs": 0.03822857142857143
  },
  {
    "ph": 5.5,
    "nm": 575,
    "abs": 0.04394285714285714
  },
  {
    "ph": 5.6,
    "nm": 575,
    "abs": 0.04971428571428571
  },
  {
    "ph": 5.7,
    "nm": 575,
    "abs": 0.05548571428571429
  },
  {
    "ph": 5.8,
    "nm": 575,
    "abs": 0.0612
  },
  {
    "ph": 5.9,
    "nm": 575,
    "abs": 0.06697142857142857
  },
  {
    "ph": 6,
    "nm": 575,
    "abs": 0.07268571428571428
  },
  {
    "ph": 6.1,
    "nm": 575,
    "abs": 0.09068571428571429
  },
  {
    "ph": 6.2,
    "nm": 575,
    "abs": 0.12028571428571429
  },
  {
    "ph": 6.3,
    "nm": 575,
    "abs": 0.14988571428571426
  },
  {
    "ph": 6.4,
    "nm": 575,
    "abs": 0.17948571428571428
  },
  {
    "ph": 6.5,
    "nm": 575,
    "abs": 0.2090857142857143
  },
  {
    "ph": 6.6,
    "nm": 575,
    "abs": 0.2386857142857143
  },
  {
    "ph": 6.7,
    "nm": 575,
    "abs": 0.2682857142857143
  },
  {
    "ph": 6.8,
    "nm": 575,
    "abs": 0.29788571428571425
  },
  {
    "ph": 6.9,
    "nm": 575,
    "abs": 0.3274857142857143
  },
  {
    "ph": 7,
    "nm": 575,
    "abs": 0.3570857142857143
  },
  {
    "ph": 7.1,
    "nm": 575,
    "abs": 0.38668571428571424
  },
  {
    "ph": 7.2,
    "nm": 575,
    "abs": 0.4162857142857143
  },
  {
    "ph": 7.3,
    "nm": 575,
    "abs": 0.4458857142857143
  },
  {
    "ph": 7.4,
    "nm": 575,
    "abs": 0.47548571428571423
  },
  {
    "ph": 7.5,
    "nm": 575,
    "abs": 0.5050857142857142
  },
  {
    "ph": 7.6,
    "nm": 575,
    "abs": 0.5346857142857143
  },
  {
    "ph": 7.7,
    "nm": 575,
    "abs": 0.5642857142857143
  },
  {
    "ph": 7.8,
    "nm": 575,
    "abs": 0.5938857142857142
  },
  {
    "ph": 7.9,
    "nm": 575,
    "abs": 0.6234857142857143
  },
  {
    "ph": 8,
    "nm": 575,
    "abs": 0.6530857142857143
  },
  {
    "ph": 5,
    "nm": 580,
    "abs": 0.014799999999999999
  },
  {
    "ph": 5.1,
    "nm": 580,
    "abs": 0.020971428571428575
  },
  {
    "ph": 5.2,
    "nm": 580,
    "abs": 0.027142857142857142
  },
  {
    "ph": 5.3,
    "nm": 580,
    "abs": 0.03331428571428571
  },
  {
    "ph": 5.4,
    "nm": 580,
    "abs": 0.039485714285714284
  },
  {
    "ph": 5.5,
    "nm": 580,
    "abs": 0.045657142857142854
  },
  {
    "ph": 5.6,
    "nm": 580,
    "abs": 0.05182857142857143
  },
  {
    "ph": 5.7,
    "nm": 580,
    "abs": 0.058057142857142856
  },
  {
    "ph": 5.8,
    "nm": 580,
    "abs": 0.06422857142857143
  },
  {
    "ph": 5.9,
    "nm": 580,
    "abs": 0.0704
  },
  {
    "ph": 6,
    "nm": 580,
    "abs": 0.07657142857142858
  },
  {
    "ph": 6.1,
    "nm": 580,
    "abs": 0.09382857142857144
  },
  {
    "ph": 6.2,
    "nm": 580,
    "abs": 0.12582857142857143
  },
  {
    "ph": 6.3,
    "nm": 580,
    "abs": 0.15782857142857143
  },
  {
    "ph": 6.4,
    "nm": 580,
    "abs": 0.18982857142857143
  },
  {
    "ph": 6.5,
    "nm": 580,
    "abs": 0.22182857142857143
  },
  {
    "ph": 6.6,
    "nm": 580,
    "abs": 0.2538285714285714
  },
  {
    "ph": 6.7,
    "nm": 580,
    "abs": 0.28582857142857143
  },
  {
    "ph": 6.8,
    "nm": 580,
    "abs": 0.31782857142857146
  },
  {
    "ph": 6.9,
    "nm": 580,
    "abs": 0.34982857142857143
  },
  {
    "ph": 7,
    "nm": 580,
    "abs": 0.38182857142857146
  },
  {
    "ph": 7.1,
    "nm": 580,
    "abs": 0.4138285714285714
  },
  {
    "ph": 7.2,
    "nm": 580,
    "abs": 0.4458285714285714
  },
  {
    "ph": 7.3,
    "nm": 580,
    "abs": 0.47782857142857144
  },
  {
    "ph": 7.4,
    "nm": 580,
    "abs": 0.5097714285714285
  },
  {
    "ph": 7.5,
    "nm": 580,
    "abs": 0.5417714285714286
  },
  {
    "ph": 7.6,
    "nm": 580,
    "abs": 0.5737714285714286
  },
  {
    "ph": 7.7,
    "nm": 580,
    "abs": 0.6057714285714286
  },
  {
    "ph": 7.8,
    "nm": 580,
    "abs": 0.6377714285714287
  },
  {
    "ph": 7.9,
    "nm": 580,
    "abs": 0.6697714285714286
  },
  {
    "ph": 8,
    "nm": 580,
    "abs": 0.7017714285714286
  },
  {
    "ph": 5,
    "nm": 585,
    "abs": 0.014342857142857143
  },
  {
    "ph": 5.1,
    "nm": 585,
    "abs": 0.020971428571428575
  },
  {
    "ph": 5.2,
    "nm": 585,
    "abs": 0.027542857142857143
  },
  {
    "ph": 5.3,
    "nm": 585,
    "abs": 0.03417142857142857
  },
  {
    "ph": 5.4,
    "nm": 585,
    "abs": 0.0408
  },
  {
    "ph": 5.5,
    "nm": 585,
    "abs": 0.04737142857142857
  },
  {
    "ph": 5.6,
    "nm": 585,
    "abs": 0.054
  },
  {
    "ph": 5.7,
    "nm": 585,
    "abs": 0.06057142857142857
  },
  {
    "ph": 5.8,
    "nm": 585,
    "abs": 0.0672
  },
  {
    "ph": 5.9,
    "nm": 585,
    "abs": 0.07382857142857144
  },
  {
    "ph": 6,
    "nm": 585,
    "abs": 0.0804
  },
  {
    "ph": 6.1,
    "nm": 585,
    "abs": 0.09702857142857144
  },
  {
    "ph": 6.2,
    "nm": 585,
    "abs": 0.13142857142857142
  },
  {
    "ph": 6.3,
    "nm": 585,
    "abs": 0.16582857142857144
  },
  {
    "ph": 6.4,
    "nm": 585,
    "abs": 0.20017142857142858
  },
  {
    "ph": 6.5,
    "nm": 585,
    "abs": 0.23457142857142857
  },
  {
    "ph": 6.6,
    "nm": 585,
    "abs": 0.2689714285714286
  },
  {
    "ph": 6.7,
    "nm": 585,
    "abs": 0.30337142857142857
  },
  {
    "ph": 6.8,
    "nm": 585,
    "abs": 0.33777142857142856
  },
  {
    "ph": 6.9,
    "nm": 585,
    "abs": 0.37217142857142854
  },
  {
    "ph": 7,
    "nm": 585,
    "abs": 0.4065714285714286
  },
  {
    "ph": 7.1,
    "nm": 585,
    "abs": 0.4409142857142857
  },
  {
    "ph": 7.2,
    "nm": 585,
    "abs": 0.4753142857142857
  },
  {
    "ph": 7.3,
    "nm": 585,
    "abs": 0.5097142857142857
  },
  {
    "ph": 7.4,
    "nm": 585,
    "abs": 0.5441142857142858
  },
  {
    "ph": 7.5,
    "nm": 585,
    "abs": 0.5785142857142856
  },
  {
    "ph": 7.6,
    "nm": 585,
    "abs": 0.6129142857142857
  },
  {
    "ph": 7.7,
    "nm": 585,
    "abs": 0.6473142857142857
  },
  {
    "ph": 7.8,
    "nm": 585,
    "abs": 0.6817142857142857
  },
  {
    "ph": 7.9,
    "nm": 585,
    "abs": 0.716057142857143
  },
  {
    "ph": 8,
    "nm": 585,
    "abs": 0.7504571428571428
  },
  {
    "ph": 5,
    "nm": 590,
    "abs": 0.013942857142857144
  },
  {
    "ph": 5.1,
    "nm": 590,
    "abs": 0.020971428571428575
  },
  {
    "ph": 5.2,
    "nm": 590,
    "abs": 0.028
  },
  {
    "ph": 5.3,
    "nm": 590,
    "abs": 0.03502857142857143
  },
  {
    "ph": 5.4,
    "nm": 590,
    "abs": 0.042057142857142855
  },
  {
    "ph": 5.5,
    "nm": 590,
    "abs": 0.04908571428571429
  },
  {
    "ph": 5.6,
    "nm": 590,
    "abs": 0.056114285714285714
  },
  {
    "ph": 5.7,
    "nm": 590,
    "abs": 0.06314285714285714
  },
  {
    "ph": 5.8,
    "nm": 590,
    "abs": 0.07022857142857143
  },
  {
    "ph": 5.9,
    "nm": 590,
    "abs": 0.07725714285714284
  },
  {
    "ph": 6,
    "nm": 590,
    "abs": 0.08428571428571428
  },
  {
    "ph": 6.1,
    "nm": 590,
    "abs": 0.10017142857142858
  },
  {
    "ph": 6.2,
    "nm": 590,
    "abs": 0.13697142857142858
  },
  {
    "ph": 6.3,
    "nm": 590,
    "abs": 0.17377142857142855
  },
  {
    "ph": 6.4,
    "nm": 590,
    "abs": 0.21057142857142858
  },
  {
    "ph": 6.5,
    "nm": 590,
    "abs": 0.24731428571428574
  },
  {
    "ph": 6.6,
    "nm": 590,
    "abs": 0.2841142857142857
  },
  {
    "ph": 6.7,
    "nm": 590,
    "abs": 0.3209142857142857
  },
  {
    "ph": 6.8,
    "nm": 590,
    "abs": 0.3577142857142857
  },
  {
    "ph": 6.9,
    "nm": 590,
    "abs": 0.3945142857142857
  },
  {
    "ph": 7,
    "nm": 590,
    "abs": 0.4312571428571429
  },
  {
    "ph": 7.1,
    "nm": 590,
    "abs": 0.4680571428571429
  },
  {
    "ph": 7.2,
    "nm": 590,
    "abs": 0.5048571428571428
  },
  {
    "ph": 7.3,
    "nm": 590,
    "abs": 0.5416571428571428
  },
  {
    "ph": 7.4,
    "nm": 590,
    "abs": 0.5784571428571429
  },
  {
    "ph": 7.5,
    "nm": 590,
    "abs": 0.6152
  },
  {
    "ph": 7.6,
    "nm": 590,
    "abs": 0.652
  },
  {
    "ph": 7.7,
    "nm": 590,
    "abs": 0.6888
  },
  {
    "ph": 7.8,
    "nm": 590,
    "abs": 0.7256
  },
  {
    "ph": 7.9,
    "nm": 590,
    "abs": 0.7624000000000001
  },
  {
    "ph": 8,
    "nm": 590,
    "abs": 0.7991428571428572
  },
  {
    "ph": 5,
    "nm": 595,
    "abs": 0.013485714285714285
  },
  {
    "ph": 5.1,
    "nm": 595,
    "abs": 0.020971428571428575
  },
  {
    "ph": 5.2,
    "nm": 595,
    "abs": 0.0284
  },
  {
    "ph": 5.3,
    "nm": 595,
    "abs": 0.035885714285714285
  },
  {
    "ph": 5.4,
    "nm": 595,
    "abs": 0.043314285714285715
  },
  {
    "ph": 5.5,
    "nm": 595,
    "abs": 0.050800000000000005
  },
  {
    "ph": 5.6,
    "nm": 595,
    "abs": 0.05828571428571428
  },
  {
    "ph": 5.7,
    "nm": 595,
    "abs": 0.06571428571428571
  },
  {
    "ph": 5.8,
    "nm": 595,
    "abs": 0.0732
  },
  {
    "ph": 5.9,
    "nm": 595,
    "abs": 0.08068571428571428
  },
  {
    "ph": 6,
    "nm": 595,
    "abs": 0.08811428571428571
  },
  {
    "ph": 6.1,
    "nm": 595,
    "abs": 0.10337142857142857
  },
  {
    "ph": 6.2,
    "nm": 595,
    "abs": 0.14251428571428573
  },
  {
    "ph": 6.3,
    "nm": 595,
    "abs": 0.18171428571428572
  },
  {
    "ph": 6.4,
    "nm": 595,
    "abs": 0.2209142857142857
  },
  {
    "ph": 6.5,
    "nm": 595,
    "abs": 0.2601142857142857
  },
  {
    "ph": 6.6,
    "nm": 595,
    "abs": 0.2992571428571429
  },
  {
    "ph": 6.7,
    "nm": 595,
    "abs": 0.3384571428571429
  },
  {
    "ph": 6.8,
    "nm": 595,
    "abs": 0.37765714285714286
  },
  {
    "ph": 6.9,
    "nm": 595,
    "abs": 0.41685714285714287
  },
  {
    "ph": 7,
    "nm": 595,
    "abs": 0.456
  },
  {
    "ph": 7.1,
    "nm": 595,
    "abs": 0.49520000000000003
  },
  {
    "ph": 7.2,
    "nm": 595,
    "abs": 0.5344
  },
  {
    "ph": 7.3,
    "nm": 595,
    "abs": 0.5735428571428571
  },
  {
    "ph": 7.4,
    "nm": 595,
    "abs": 0.6127428571428571
  },
  {
    "ph": 7.5,
    "nm": 595,
    "abs": 0.6519428571428572
  },
  {
    "ph": 7.6,
    "nm": 595,
    "abs": 0.6911428571428572
  },
  {
    "ph": 7.7,
    "nm": 595,
    "abs": 0.7302857142857143
  },
  {
    "ph": 7.8,
    "nm": 595,
    "abs": 0.7694857142857143
  },
  {
    "ph": 7.9,
    "nm": 595,
    "abs": 0.8086857142857143
  },
  {
    "ph": 8,
    "nm": 595,
    "abs": 0.8478857142857142
  },
  {
    "ph": 5,
    "nm": 600,
    "abs": 0.01302857142857143
  },
  {
    "ph": 5.1,
    "nm": 600,
    "abs": 0.020971428571428575
  },
  {
    "ph": 5.2,
    "nm": 600,
    "abs": 0.02885714285714286
  },
  {
    "ph": 5.3,
    "nm": 600,
    "abs": 0.03674285714285714
  },
  {
    "ph": 5.4,
    "nm": 600,
    "abs": 0.04462857142857143
  },
  {
    "ph": 5.5,
    "nm": 600,
    "abs": 0.052514285714285715
  },
  {
    "ph": 5.6,
    "nm": 600,
    "abs": 0.0604
  },
  {
    "ph": 5.7,
    "nm": 600,
    "abs": 0.06828571428571428
  },
  {
    "ph": 5.8,
    "nm": 600,
    "abs": 0.07617142857142857
  },
  {
    "ph": 5.9,
    "nm": 600,
    "abs": 0.08411428571428571
  },
  {
    "ph": 6,
    "nm": 600,
    "abs": 0.092
  },
  {
    "ph": 6.1,
    "nm": 600,
    "abs": 0.10651428571428571
  },
  {
    "ph": 6.2,
    "nm": 600,
    "abs": 0.1481142857142857
  },
  {
    "ph": 6.3,
    "nm": 600,
    "abs": 0.18965714285714283
  },
  {
    "ph": 6.4,
    "nm": 600,
    "abs": 0.23125714285714286
  },
  {
    "ph": 6.5,
    "nm": 600,
    "abs": 0.27285714285714285
  },
  {
    "ph": 6.6,
    "nm": 600,
    "abs": 0.3144
  },
  {
    "ph": 6.7,
    "nm": 600,
    "abs": 0.356
  },
  {
    "ph": 6.8,
    "nm": 600,
    "abs": 0.3976
  },
  {
    "ph": 6.9,
    "nm": 600,
    "abs": 0.4391428571428571
  },
  {
    "ph": 7,
    "nm": 600,
    "abs": 0.4807428571428572
  },
  {
    "ph": 7.1,
    "nm": 600,
    "abs": 0.5223428571428571
  },
  {
    "ph": 7.2,
    "nm": 600,
    "abs": 0.5638857142857143
  },
  {
    "ph": 7.3,
    "nm": 600,
    "abs": 0.6054857142857143
  },
  {
    "ph": 7.4,
    "nm": 600,
    "abs": 0.6470857142857144
  },
  {
    "ph": 7.5,
    "nm": 600,
    "abs": 0.6886285714285715
  },
  {
    "ph": 7.6,
    "nm": 600,
    "abs": 0.7302285714285714
  },
  {
    "ph": 7.7,
    "nm": 600,
    "abs": 0.7718285714285714
  },
  {
    "ph": 7.8,
    "nm": 600,
    "abs": 0.8133714285714285
  },
  {
    "ph": 7.9,
    "nm": 600,
    "abs": 0.8549714285714286
  },
  {
    "ph": 8,
    "nm": 600,
    "abs": 0.8965714285714286
  },
  {
    "ph": 5,
    "nm": 605,
    "abs": 0.01262857142857143
  },
  {
    "ph": 5.1,
    "nm": 605,
    "abs": 0.020971428571428575
  },
  {
    "ph": 5.2,
    "nm": 605,
    "abs": 0.02925714285714286
  },
  {
    "ph": 5.3,
    "nm": 605,
    "abs": 0.0376
  },
  {
    "ph": 5.4,
    "nm": 605,
    "abs": 0.04588571428571429
  },
  {
    "ph": 5.5,
    "nm": 605,
    "abs": 0.054228571428571425
  },
  {
    "ph": 5.6,
    "nm": 605,
    "abs": 0.06257142857142857
  },
  {
    "ph": 5.7,
    "nm": 605,
    "abs": 0.07085714285714285
  },
  {
    "ph": 5.8,
    "nm": 605,
    "abs": 0.0792
  },
  {
    "ph": 5.9,
    "nm": 605,
    "abs": 0.08748571428571429
  },
  {
    "ph": 6,
    "nm": 605,
    "abs": 0.09582857142857142
  },
  {
    "ph": 6.1,
    "nm": 605,
    "abs": 0.10971428571428572
  },
  {
    "ph": 6.2,
    "nm": 605,
    "abs": 0.15365714285714285
  },
  {
    "ph": 6.3,
    "nm": 605,
    "abs": 0.19765714285714284
  },
  {
    "ph": 6.4,
    "nm": 605,
    "abs": 0.2416
  },
  {
    "ph": 6.5,
    "nm": 605,
    "abs": 0.2856
  },
  {
    "ph": 6.6,
    "nm": 605,
    "abs": 0.3296
  },
  {
    "ph": 6.7,
    "nm": 605,
    "abs": 0.3735428571428571
  },
  {
    "ph": 6.8,
    "nm": 605,
    "abs": 0.41754285714285716
  },
  {
    "ph": 6.9,
    "nm": 605,
    "abs": 0.4614857142857143
  },
  {
    "ph": 7,
    "nm": 605,
    "abs": 0.5054857142857143
  },
  {
    "ph": 7.1,
    "nm": 605,
    "abs": 0.5494857142857142
  },
  {
    "ph": 7.2,
    "nm": 605,
    "abs": 0.5934285714285714
  },
  {
    "ph": 7.3,
    "nm": 605,
    "abs": 0.6374285714285713
  },
  {
    "ph": 7.4,
    "nm": 605,
    "abs": 0.6813714285714285
  },
  {
    "ph": 7.5,
    "nm": 605,
    "abs": 0.7253714285714287
  },
  {
    "ph": 7.6,
    "nm": 605,
    "abs": 0.7693714285714286
  },
  {
    "ph": 7.7,
    "nm": 605,
    "abs": 0.8133142857142858
  },
  {
    "ph": 7.8,
    "nm": 605,
    "abs": 0.8573142857142857
  },
  {
    "ph": 7.9,
    "nm": 605,
    "abs": 0.9012571428571429
  },
  {
    "ph": 8,
    "nm": 605,
    "abs": 0.9452571428571428
  },
  {
    "ph": 5,
    "nm": 610,
    "abs": 0.020057142857142857
  },
  {
    "ph": 5.1,
    "nm": 610,
    "abs": 0.024057142857142857
  },
  {
    "ph": 5.2,
    "nm": 610,
    "abs": 0.028114285714285713
  },
  {
    "ph": 5.3,
    "nm": 610,
    "abs": 0.03217142857142857
  },
  {
    "ph": 5.4,
    "nm": 610,
    "abs": 0.03622857142857143
  },
  {
    "ph": 5.5,
    "nm": 610,
    "abs": 0.04028571428571428
  },
  {
    "ph": 5.6,
    "nm": 610,
    "abs": 0.04428571428571428
  },
  {
    "ph": 5.7,
    "nm": 610,
    "abs": 0.04834285714285714
  },
  {
    "ph": 5.8,
    "nm": 610,
    "abs": 0.0524
  },
  {
    "ph": 5.9,
    "nm": 610,
    "abs": 0.05645714285714286
  },
  {
    "ph": 6,
    "nm": 610,
    "abs": 0.09674285714285714
  },
  {
    "ph": 6.1,
    "nm": 610,
    "abs": 0.14034285714285716
  },
  {
    "ph": 6.2,
    "nm": 610,
    "abs": 0.18394285714285716
  },
  {
    "ph": 6.3,
    "nm": 610,
    "abs": 0.22754285714285713
  },
  {
    "ph": 6.4,
    "nm": 610,
    "abs": 0.27114285714285713
  },
  {
    "ph": 6.5,
    "nm": 610,
    "abs": 0.3147428571428571
  },
  {
    "ph": 6.6,
    "nm": 610,
    "abs": 0.3584
  },
  {
    "ph": 6.7,
    "nm": 610,
    "abs": 0.402
  },
  {
    "ph": 6.8,
    "nm": 610,
    "abs": 0.44560000000000005
  },
  {
    "ph": 6.9,
    "nm": 610,
    "abs": 0.48919999999999997
  },
  {
    "ph": 7,
    "nm": 610,
    "abs": 0.5328
  },
  {
    "ph": 7.1,
    "nm": 610,
    "abs": 0.5763999999999999
  },
  {
    "ph": 7.2,
    "nm": 610,
    "abs": 0.62
  },
  {
    "ph": 7.3,
    "nm": 610,
    "abs": 0.6636
  },
  {
    "ph": 7.4,
    "nm": 610,
    "abs": 0.7072
  },
  {
    "ph": 7.5,
    "nm": 610,
    "abs": 0.7508571428571429
  },
  {
    "ph": 7.6,
    "nm": 610,
    "abs": 0.7944571428571429
  },
  {
    "ph": 7.7,
    "nm": 610,
    "abs": 0.8380571428571428
  },
  {
    "ph": 7.8,
    "nm": 610,
    "abs": 0.8816571428571428
  },
  {
    "ph": 7.9,
    "nm": 610,
    "abs": 0.9252571428571429
  },
  {
    "ph": 8,
    "nm": 610,
    "abs": 0.9688571428571429
  },
  {
    "ph": 5,
    "nm": 615,
    "abs": 0.02017142857142857
  },
  {
    "ph": 5.1,
    "nm": 615,
    "abs": 0.02428571428571429
  },
  {
    "ph": 5.2,
    "nm": 615,
    "abs": 0.028457142857142854
  },
  {
    "ph": 5.3,
    "nm": 615,
    "abs": 0.03257142857142857
  },
  {
    "ph": 5.4,
    "nm": 615,
    "abs": 0.03674285714285714
  },
  {
    "ph": 5.5,
    "nm": 615,
    "abs": 0.040857142857142856
  },
  {
    "ph": 5.6,
    "nm": 615,
    "abs": 0.045028571428571425
  },
  {
    "ph": 5.7,
    "nm": 615,
    "abs": 0.04914285714285714
  },
  {
    "ph": 5.8,
    "nm": 615,
    "abs": 0.05331428571428571
  },
  {
    "ph": 5.9,
    "nm": 615,
    "abs": 0.06314285714285714
  },
  {
    "ph": 6,
    "nm": 615,
    "abs": 0.11040000000000001
  },
  {
    "ph": 6.1,
    "nm": 615,
    "abs": 0.14971428571428572
  },
  {
    "ph": 6.2,
    "nm": 615,
    "abs": 0.19297142857142857
  },
  {
    "ph": 6.3,
    "nm": 615,
    "abs": 0.23628571428571427
  },
  {
    "ph": 6.4,
    "nm": 615,
    "abs": 0.2796
  },
  {
    "ph": 6.5,
    "nm": 615,
    "abs": 0.32285714285714284
  },
  {
    "ph": 6.6,
    "nm": 615,
    "abs": 0.3661714285714286
  },
  {
    "ph": 6.7,
    "nm": 615,
    "abs": 0.4094285714285714
  },
  {
    "ph": 6.8,
    "nm": 615,
    "abs": 0.45274285714285717
  },
  {
    "ph": 6.9,
    "nm": 615,
    "abs": 0.49605714285714286
  },
  {
    "ph": 7,
    "nm": 615,
    "abs": 0.5393142857142857
  },
  {
    "ph": 7.1,
    "nm": 615,
    "abs": 0.5826285714285715
  },
  {
    "ph": 7.2,
    "nm": 615,
    "abs": 0.6258857142857143
  },
  {
    "ph": 7.3,
    "nm": 615,
    "abs": 0.6692
  },
  {
    "ph": 7.4,
    "nm": 615,
    "abs": 0.7125142857142857
  },
  {
    "ph": 7.5,
    "nm": 615,
    "abs": 0.7557714285714285
  },
  {
    "ph": 7.6,
    "nm": 615,
    "abs": 0.7990857142857143
  },
  {
    "ph": 7.7,
    "nm": 615,
    "abs": 0.8423428571428572
  },
  {
    "ph": 7.8,
    "nm": 615,
    "abs": 0.8856571428571429
  },
  {
    "ph": 7.9,
    "nm": 615,
    "abs": 0.9289714285714286
  },
  {
    "ph": 8,
    "nm": 615,
    "abs": 0.9722285714285714
  },
  {
    "ph": 5,
    "nm": 620,
    "abs": 0.01845714285714286
  },
  {
    "ph": 5.1,
    "nm": 620,
    "abs": 0.023085714285714286
  },
  {
    "ph": 5.2,
    "nm": 620,
    "abs": 0.027657142857142856
  },
  {
    "ph": 5.3,
    "nm": 620,
    "abs": 0.032285714285714286
  },
  {
    "ph": 5.4,
    "nm": 620,
    "abs": 0.03685714285714286
  },
  {
    "ph": 5.5,
    "nm": 620,
    "abs": 0.041485714285714285
  },
  {
    "ph": 5.6,
    "nm": 620,
    "abs": 0.04605714285714286
  },
  {
    "ph": 5.7,
    "nm": 620,
    "abs": 0.050685714285714285
  },
  {
    "ph": 5.8,
    "nm": 620,
    "abs": 0.05525714285714285
  },
  {
    "ph": 5.9,
    "nm": 620,
    "abs": 0.059885714285714285
  },
  {
    "ph": 6,
    "nm": 620,
    "abs": 0.10205714285714286
  },
  {
    "ph": 6.1,
    "nm": 620,
    "abs": 0.14474285714285715
  },
  {
    "ph": 6.2,
    "nm": 620,
    "abs": 0.18742857142857144
  },
  {
    "ph": 6.3,
    "nm": 620,
    "abs": 0.23005714285714288
  },
  {
    "ph": 6.4,
    "nm": 620,
    "abs": 0.2727428571428571
  },
  {
    "ph": 6.5,
    "nm": 620,
    "abs": 0.31542857142857145
  },
  {
    "ph": 6.6,
    "nm": 620,
    "abs": 0.3581142857142857
  },
  {
    "ph": 6.7,
    "nm": 620,
    "abs": 0.4008
  },
  {
    "ph": 6.8,
    "nm": 620,
    "abs": 0.44342857142857145
  },
  {
    "ph": 6.9,
    "nm": 620,
    "abs": 0.4861142857142857
  },
  {
    "ph": 7,
    "nm": 620,
    "abs": 0.5288
  },
  {
    "ph": 7.1,
    "nm": 620,
    "abs": 0.5714857142857143
  },
  {
    "ph": 7.2,
    "nm": 620,
    "abs": 0.6141714285714286
  },
  {
    "ph": 7.3,
    "nm": 620,
    "abs": 0.6568571428571428
  },
  {
    "ph": 7.4,
    "nm": 620,
    "abs": 0.6994857142857143
  },
  {
    "ph": 7.5,
    "nm": 620,
    "abs": 0.7421714285714286
  },
  {
    "ph": 7.6,
    "nm": 620,
    "abs": 0.7848571428571428
  },
  {
    "ph": 7.7,
    "nm": 620,
    "abs": 0.8275428571428571
  },
  {
    "ph": 7.8,
    "nm": 620,
    "abs": 0.8702285714285714
  },
  {
    "ph": 7.9,
    "nm": 620,
    "abs": 0.9129142857142857
  },
  {
    "ph": 8,
    "nm": 620,
    "abs": 0.9555428571428571
  },
  {
    "ph": 5,
    "nm": 625,
    "abs": 0.016285714285714285
  },
  {
    "ph": 5.1,
    "nm": 625,
    "abs": 0.021085714285714287
  },
  {
    "ph": 5.2,
    "nm": 625,
    "abs": 0.025942857142857146
  },
  {
    "ph": 5.3,
    "nm": 625,
    "abs": 0.030742857142857145
  },
  {
    "ph": 5.4,
    "nm": 625,
    "abs": 0.03554285714285714
  },
  {
    "ph": 5.5,
    "nm": 625,
    "abs": 0.0404
  },
  {
    "ph": 5.6,
    "nm": 625,
    "abs": 0.045200000000000004
  },
  {
    "ph": 5.7,
    "nm": 625,
    "abs": 0.050057142857142856
  },
  {
    "ph": 5.8,
    "nm": 625,
    "abs": 0.05485714285714286
  },
  {
    "ph": 5.9,
    "nm": 625,
    "abs": 0.05965714285714286
  },
  {
    "ph": 6,
    "nm": 625,
    "abs": 0.09382857142857144
  },
  {
    "ph": 6.1,
    "nm": 625,
    "abs": 0.1358857142857143
  },
  {
    "ph": 6.2,
    "nm": 625,
    "abs": 0.17794285714285715
  },
  {
    "ph": 6.3,
    "nm": 625,
    "abs": 0.22
  },
  {
    "ph": 6.4,
    "nm": 625,
    "abs": 0.2620571428571429
  },
  {
    "ph": 6.5,
    "nm": 625,
    "abs": 0.3041142857142857
  },
  {
    "ph": 6.6,
    "nm": 625,
    "abs": 0.3461714285714286
  },
  {
    "ph": 6.7,
    "nm": 625,
    "abs": 0.3882285714285714
  },
  {
    "ph": 6.8,
    "nm": 625,
    "abs": 0.43034285714285714
  },
  {
    "ph": 6.9,
    "nm": 625,
    "abs": 0.4724
  },
  {
    "ph": 7,
    "nm": 625,
    "abs": 0.5144571428571428
  },
  {
    "ph": 7.1,
    "nm": 625,
    "abs": 0.5565142857142857
  },
  {
    "ph": 7.2,
    "nm": 625,
    "abs": 0.5985714285714286
  },
  {
    "ph": 7.3,
    "nm": 625,
    "abs": 0.6406285714285714
  },
  {
    "ph": 7.4,
    "nm": 625,
    "abs": 0.6826857142857143
  },
  {
    "ph": 7.5,
    "nm": 625,
    "abs": 0.7247428571428571
  },
  {
    "ph": 7.6,
    "nm": 625,
    "abs": 0.7668
  },
  {
    "ph": 7.7,
    "nm": 625,
    "abs": 0.8088571428571428
  },
  {
    "ph": 7.8,
    "nm": 625,
    "abs": 0.8509142857142857
  },
  {
    "ph": 7.9,
    "nm": 625,
    "abs": 0.8929714285714285
  },
  {
    "ph": 8,
    "nm": 625,
    "abs": 0.9350285714285714
  },
  {
    "ph": 5,
    "nm": 630,
    "abs": 0.007714285714285714
  },
  {
    "ph": 5.1,
    "nm": 630,
    "abs": 0.016
  },
  {
    "ph": 5.2,
    "nm": 630,
    "abs": 0.024342857142857142
  },
  {
    "ph": 5.3,
    "nm": 630,
    "abs": 0.03268571428571428
  },
  {
    "ph": 5.4,
    "nm": 630,
    "abs": 0.04102857142857143
  },
  {
    "ph": 5.5,
    "nm": 630,
    "abs": 0.04937142857142857
  },
  {
    "ph": 5.6,
    "nm": 630,
    "abs": 0.05765714285714286
  },
  {
    "ph": 5.7,
    "nm": 630,
    "abs": 0.066
  },
  {
    "ph": 5.8,
    "nm": 630,
    "abs": 0.07434285714285714
  },
  {
    "ph": 5.9,
    "nm": 630,
    "abs": 0.08268571428571428
  },
  {
    "ph": 6,
    "nm": 630,
    "abs": 0.09102857142857143
  },
  {
    "ph": 6.1,
    "nm": 630,
    "abs": 0.10297142857142857
  },
  {
    "ph": 6.2,
    "nm": 630,
    "abs": 0.1457142857142857
  },
  {
    "ph": 6.3,
    "nm": 630,
    "abs": 0.18845714285714285
  },
  {
    "ph": 6.4,
    "nm": 630,
    "abs": 0.23120000000000002
  },
  {
    "ph": 6.5,
    "nm": 630,
    "abs": 0.27394285714285715
  },
  {
    "ph": 6.6,
    "nm": 630,
    "abs": 0.3166857142857143
  },
  {
    "ph": 6.7,
    "nm": 630,
    "abs": 0.35942857142857143
  },
  {
    "ph": 6.8,
    "nm": 630,
    "abs": 0.40217142857142857
  },
  {
    "ph": 6.9,
    "nm": 630,
    "abs": 0.4449142857142857
  },
  {
    "ph": 7,
    "nm": 630,
    "abs": 0.4876571428571429
  },
  {
    "ph": 7.1,
    "nm": 630,
    "abs": 0.5304
  },
  {
    "ph": 7.2,
    "nm": 630,
    "abs": 0.5731428571428571
  },
  {
    "ph": 7.3,
    "nm": 630,
    "abs": 0.6158857142857144
  },
  {
    "ph": 7.4,
    "nm": 630,
    "abs": 0.6586285714285715
  },
  {
    "ph": 7.5,
    "nm": 630,
    "abs": 0.7013714285714286
  },
  {
    "ph": 7.6,
    "nm": 630,
    "abs": 0.7441142857142857
  },
  {
    "ph": 7.7,
    "nm": 630,
    "abs": 0.7868
  },
  {
    "ph": 7.8,
    "nm": 630,
    "abs": 0.8295428571428571
  },
  {
    "ph": 7.9,
    "nm": 630,
    "abs": 0.8722857142857142
  },
  {
    "ph": 8,
    "nm": 630,
    "abs": 0.9150285714285714
  },
  {
    "ph": 5,
    "nm": 635,
    "abs": 0.0064
  },
  {
    "ph": 5.1,
    "nm": 635,
    "abs": 0.013885714285714284
  },
  {
    "ph": 5.2,
    "nm": 635,
    "abs": 0.021371428571428572
  },
  {
    "ph": 5.3,
    "nm": 635,
    "abs": 0.02885714285714286
  },
  {
    "ph": 5.4,
    "nm": 635,
    "abs": 0.03634285714285714
  },
  {
    "ph": 5.5,
    "nm": 635,
    "abs": 0.04382857142857143
  },
  {
    "ph": 5.6,
    "nm": 635,
    "abs": 0.051314285714285715
  },
  {
    "ph": 5.7,
    "nm": 635,
    "abs": 0.058800000000000005
  },
  {
    "ph": 5.8,
    "nm": 635,
    "abs": 0.0662857142857143
  },
  {
    "ph": 5.9,
    "nm": 635,
    "abs": 0.07377142857142857
  },
  {
    "ph": 6,
    "nm": 635,
    "abs": 0.08125714285714285
  },
  {
    "ph": 6.1,
    "nm": 635,
    "abs": 0.09114285714285715
  },
  {
    "ph": 6.2,
    "nm": 635,
    "abs": 0.12937142857142855
  },
  {
    "ph": 6.3,
    "nm": 635,
    "abs": 0.16754285714285716
  },
  {
    "ph": 6.4,
    "nm": 635,
    "abs": 0.20577142857142855
  },
  {
    "ph": 6.5,
    "nm": 635,
    "abs": 0.244
  },
  {
    "ph": 6.6,
    "nm": 635,
    "abs": 0.2821714285714286
  },
  {
    "ph": 6.7,
    "nm": 635,
    "abs": 0.32039999999999996
  },
  {
    "ph": 6.8,
    "nm": 635,
    "abs": 0.35857142857142854
  },
  {
    "ph": 6.9,
    "nm": 635,
    "abs": 0.3968
  },
  {
    "ph": 7,
    "nm": 635,
    "abs": 0.43502857142857143
  },
  {
    "ph": 7.1,
    "nm": 635,
    "abs": 0.47319999999999995
  },
  {
    "ph": 7.2,
    "nm": 635,
    "abs": 0.5114285714285715
  },
  {
    "ph": 7.3,
    "nm": 635,
    "abs": 0.5496
  },
  {
    "ph": 7.4,
    "nm": 635,
    "abs": 0.5878285714285714
  },
  {
    "ph": 7.5,
    "nm": 635,
    "abs": 0.626
  },
  {
    "ph": 7.6,
    "nm": 635,
    "abs": 0.6642285714285715
  },
  {
    "ph": 7.7,
    "nm": 635,
    "abs": 0.7024571428571429
  },
  {
    "ph": 7.8,
    "nm": 635,
    "abs": 0.7406285714285714
  },
  {
    "ph": 7.9,
    "nm": 635,
    "abs": 0.7788571428571428
  },
  {
    "ph": 8,
    "nm": 635,
    "abs": 0.8170285714285714
  },
  {
    "ph": 5,
    "nm": 640,
    "abs": 0.005028571428571429
  },
  {
    "ph": 5.1,
    "nm": 640,
    "abs": 0.011714285714285715
  },
  {
    "ph": 5.2,
    "nm": 640,
    "abs": 0.01834285714285714
  },
  {
    "ph": 5.3,
    "nm": 640,
    "abs": 0.02497142857142857
  },
  {
    "ph": 5.4,
    "nm": 640,
    "abs": 0.0316
  },
  {
    "ph": 5.5,
    "nm": 640,
    "abs": 0.03822857142857143
  },
  {
    "ph": 5.6,
    "nm": 640,
    "abs": 0.04491428571428572
  },
  {
    "ph": 5.7,
    "nm": 640,
    "abs": 0.05154285714285715
  },
  {
    "ph": 5.8,
    "nm": 640,
    "abs": 0.058171428571428575
  },
  {
    "ph": 5.9,
    "nm": 640,
    "abs": 0.0648
  },
  {
    "ph": 6,
    "nm": 640,
    "abs": 0.07142857142857142
  },
  {
    "ph": 6.1,
    "nm": 640,
    "abs": 0.0781142857142857
  },
  {
    "ph": 6.2,
    "nm": 640,
    "abs": 0.11177142857142856
  },
  {
    "ph": 6.3,
    "nm": 640,
    "abs": 0.14548571428571427
  },
  {
    "ph": 6.4,
    "nm": 640,
    "abs": 0.1792
  },
  {
    "ph": 6.5,
    "nm": 640,
    "abs": 0.2129142857142857
  },
  {
    "ph": 6.6,
    "nm": 640,
    "abs": 0.24662857142857142
  },
  {
    "ph": 6.7,
    "nm": 640,
    "abs": 0.2803428571428571
  },
  {
    "ph": 6.8,
    "nm": 640,
    "abs": 0.3141142857142857
  },
  {
    "ph": 6.9,
    "nm": 640,
    "abs": 0.34782857142857143
  },
  {
    "ph": 7,
    "nm": 640,
    "abs": 0.38154285714285713
  },
  {
    "ph": 7.1,
    "nm": 640,
    "abs": 0.4152571428571429
  },
  {
    "ph": 7.2,
    "nm": 640,
    "abs": 0.4489714285714285
  },
  {
    "ph": 7.3,
    "nm": 640,
    "abs": 0.48274285714285714
  },
  {
    "ph": 7.4,
    "nm": 640,
    "abs": 0.5164571428571428
  },
  {
    "ph": 7.5,
    "nm": 640,
    "abs": 0.5501714285714285
  },
  {
    "ph": 7.6,
    "nm": 640,
    "abs": 0.5838857142857143
  },
  {
    "ph": 7.7,
    "nm": 640,
    "abs": 0.6176
  },
  {
    "ph": 7.8,
    "nm": 640,
    "abs": 0.6513142857142856
  },
  {
    "ph": 7.9,
    "nm": 640,
    "abs": 0.6850857142857143
  },
  {
    "ph": 8,
    "nm": 640,
    "abs": 0.7188
  },
  {
    "ph": 5,
    "nm": 645,
    "abs": 0.0037142857142857142
  },
  {
    "ph": 5.1,
    "nm": 645,
    "abs": 0.009542857142857143
  },
  {
    "ph": 5.2,
    "nm": 645,
    "abs": 0.015314285714285714
  },
  {
    "ph": 5.3,
    "nm": 645,
    "abs": 0.02114285714285714
  },
  {
    "ph": 5.4,
    "nm": 645,
    "abs": 0.026914285714285717
  },
  {
    "ph": 5.5,
    "nm": 645,
    "abs": 0.03268571428571428
  },
  {
    "ph": 5.6,
    "nm": 645,
    "abs": 0.038514285714285716
  },
  {
    "ph": 5.7,
    "nm": 645,
    "abs": 0.04428571428571428
  },
  {
    "ph": 5.8,
    "nm": 645,
    "abs": 0.050114285714285715
  },
  {
    "ph": 5.9,
    "nm": 645,
    "abs": 0.05588571428571428
  },
  {
    "ph": 6,
    "nm": 645,
    "abs": 0.061657142857142855
  },
  {
    "ph": 6.1,
    "nm": 645,
    "abs": 0.06748571428571429
  },
  {
    "ph": 6.2,
    "nm": 645,
    "abs": 0.09411428571428572
  },
  {
    "ph": 6.3,
    "nm": 645,
    "abs": 0.12337142857142858
  },
  {
    "ph": 6.4,
    "nm": 645,
    "abs": 0.15262857142857142
  },
  {
    "ph": 6.5,
    "nm": 645,
    "abs": 0.1818857142857143
  },
  {
    "ph": 6.6,
    "nm": 645,
    "abs": 0.2110857142857143
  },
  {
    "ph": 6.7,
    "nm": 645,
    "abs": 0.24034285714285714
  },
  {
    "ph": 6.8,
    "nm": 645,
    "abs": 0.2696
  },
  {
    "ph": 6.9,
    "nm": 645,
    "abs": 0.2988571428571429
  },
  {
    "ph": 7,
    "nm": 645,
    "abs": 0.3280571428571429
  },
  {
    "ph": 7.1,
    "nm": 645,
    "abs": 0.3573142857142857
  },
  {
    "ph": 7.2,
    "nm": 645,
    "abs": 0.38657142857142857
  },
  {
    "ph": 7.3,
    "nm": 645,
    "abs": 0.41582857142857144
  },
  {
    "ph": 7.4,
    "nm": 645,
    "abs": 0.44502857142857144
  },
  {
    "ph": 7.5,
    "nm": 645,
    "abs": 0.47428571428571425
  },
  {
    "ph": 7.6,
    "nm": 645,
    "abs": 0.5035428571428572
  },
  {
    "ph": 7.7,
    "nm": 645,
    "abs": 0.5328
  },
  {
    "ph": 7.8,
    "nm": 645,
    "abs": 0.5620571428571429
  },
  {
    "ph": 7.9,
    "nm": 645,
    "abs": 0.5912571428571428
  },
  {
    "ph": 8,
    "nm": 645,
    "abs": 0.6205142857142858
  },
  {
    "ph": 5,
    "nm": 650,
    "abs": 0.0024
  },
  {
    "ph": 5.1,
    "nm": 650,
    "abs": 0.007371428571428571
  },
  {
    "ph": 5.2,
    "nm": 650,
    "abs": 0.012285714285714285
  },
  {
    "ph": 5.3,
    "nm": 650,
    "abs": 0.017257142857142856
  },
  {
    "ph": 5.4,
    "nm": 650,
    "abs": 0.022228571428571427
  },
  {
    "ph": 5.5,
    "nm": 650,
    "abs": 0.027142857142857142
  },
  {
    "ph": 5.6,
    "nm": 650,
    "abs": 0.03211428571428571
  },
  {
    "ph": 5.7,
    "nm": 650,
    "abs": 0.037028571428571425
  },
  {
    "ph": 5.8,
    "nm": 650,
    "abs": 0.041999999999999996
  },
  {
    "ph": 5.9,
    "nm": 650,
    "abs": 0.04697142857142857
  },
  {
    "ph": 6,
    "nm": 650,
    "abs": 0.05188571428571429
  },
  {
    "ph": 6.1,
    "nm": 650,
    "abs": 0.05685714285714286
  },
  {
    "ph": 6.2,
    "nm": 650,
    "abs": 0.07651428571428572
  },
  {
    "ph": 6.3,
    "nm": 650,
    "abs": 0.10131428571428572
  },
  {
    "ph": 6.4,
    "nm": 650,
    "abs": 0.12605714285714284
  },
  {
    "ph": 6.5,
    "nm": 650,
    "abs": 0.15080000000000002
  },
  {
    "ph": 6.6,
    "nm": 650,
    "abs": 0.1756
  },
  {
    "ph": 6.7,
    "nm": 650,
    "abs": 0.20034285714285716
  },
  {
    "ph": 6.8,
    "nm": 650,
    "abs": 0.22508571428571428
  },
  {
    "ph": 6.9,
    "nm": 650,
    "abs": 0.2498857142857143
  },
  {
    "ph": 7,
    "nm": 650,
    "abs": 0.27462857142857144
  },
  {
    "ph": 7.1,
    "nm": 650,
    "abs": 0.29937142857142857
  },
  {
    "ph": 7.2,
    "nm": 650,
    "abs": 0.3241714285714286
  },
  {
    "ph": 7.3,
    "nm": 650,
    "abs": 0.34891428571428573
  },
  {
    "ph": 7.4,
    "nm": 650,
    "abs": 0.37365714285714285
  },
  {
    "ph": 7.5,
    "nm": 650,
    "abs": 0.3984571428571429
  },
  {
    "ph": 7.6,
    "nm": 650,
    "abs": 0.4232
  },
  {
    "ph": 7.7,
    "nm": 650,
    "abs": 0.44794285714285714
  },
  {
    "ph": 7.8,
    "nm": 650,
    "abs": 0.4727428571428572
  },
  {
    "ph": 7.9,
    "nm": 650,
    "abs": 0.4974857142857143
  },
  {
    "ph": 8,
    "nm": 650,
    "abs": 0.5222285714285715
  },
  {
    "ph": 5,
    "nm": 655,
    "abs": 0.0025714285714285713
  },
  {
    "ph": 5.1,
    "nm": 655,
    "abs": 0.006514285714285715
  },
  {
    "ph": 5.2,
    "nm": 655,
    "abs": 0.010400000000000001
  },
  {
    "ph": 5.3,
    "nm": 655,
    "abs": 0.014342857142857143
  },
  {
    "ph": 5.4,
    "nm": 655,
    "abs": 0.018285714285714287
  },
  {
    "ph": 5.5,
    "nm": 655,
    "abs": 0.02217142857142857
  },
  {
    "ph": 5.6,
    "nm": 655,
    "abs": 0.02611428571428571
  },
  {
    "ph": 5.7,
    "nm": 655,
    "abs": 0.03005714285714286
  },
  {
    "ph": 5.8,
    "nm": 655,
    "abs": 0.03394285714285714
  },
  {
    "ph": 5.9,
    "nm": 655,
    "abs": 0.037885714285714286
  },
  {
    "ph": 6,
    "nm": 655,
    "abs": 0.04182857142857143
  },
  {
    "ph": 6.1,
    "nm": 655,
    "abs": 0.045771428571428574
  },
  {
    "ph": 6.2,
    "nm": 655,
    "abs": 0.05891428571428571
  },
  {
    "ph": 6.3,
    "nm": 655,
    "abs": 0.0792
  },
  {
    "ph": 6.4,
    "nm": 655,
    "abs": 0.09948571428571429
  },
  {
    "ph": 6.5,
    "nm": 655,
    "abs": 0.11977142857142857
  },
  {
    "ph": 6.6,
    "nm": 655,
    "abs": 0.14005714285714285
  },
  {
    "ph": 6.7,
    "nm": 655,
    "abs": 0.16034285714285715
  },
  {
    "ph": 6.8,
    "nm": 655,
    "abs": 0.18062857142857142
  },
  {
    "ph": 6.9,
    "nm": 655,
    "abs": 0.20085714285714285
  },
  {
    "ph": 7,
    "nm": 655,
    "abs": 0.22114285714285714
  },
  {
    "ph": 7.1,
    "nm": 655,
    "abs": 0.2414285714285714
  },
  {
    "ph": 7.2,
    "nm": 655,
    "abs": 0.26171428571428573
  },
  {
    "ph": 7.3,
    "nm": 655,
    "abs": 0.282
  },
  {
    "ph": 7.4,
    "nm": 655,
    "abs": 0.3022857142857143
  },
  {
    "ph": 7.5,
    "nm": 655,
    "abs": 0.32257142857142856
  },
  {
    "ph": 7.6,
    "nm": 655,
    "abs": 0.34285714285714286
  },
  {
    "ph": 7.7,
    "nm": 655,
    "abs": 0.3631428571428571
  },
  {
    "ph": 7.8,
    "nm": 655,
    "abs": 0.38342857142857145
  },
  {
    "ph": 7.9,
    "nm": 655,
    "abs": 0.40371428571428575
  },
  {
    "ph": 8,
    "nm": 655,
    "abs": 0.424
  },
  {
    "ph": 5,
    "nm": 660,
    "abs": 0.002857142857142857
  },
  {
    "ph": 5.1,
    "nm": 660,
    "abs": 0.005714285714285714
  },
  {
    "ph": 5.2,
    "nm": 660,
    "abs": 0.008628571428571428
  },
  {
    "ph": 5.3,
    "nm": 660,
    "abs": 0.011485714285714285
  },
  {
    "ph": 5.4,
    "nm": 660,
    "abs": 0.0144
  },
  {
    "ph": 5.5,
    "nm": 660,
    "abs": 0.017257142857142856
  },
  {
    "ph": 5.6,
    "nm": 660,
    "abs": 0.02017142857142857
  },
  {
    "ph": 5.7,
    "nm": 660,
    "abs": 0.023085714285714286
  },
  {
    "ph": 5.8,
    "nm": 660,
    "abs": 0.025942857142857146
  },
  {
    "ph": 5.9,
    "nm": 660,
    "abs": 0.02885714285714286
  },
  {
    "ph": 6,
    "nm": 660,
    "abs": 0.031714285714285716
  },
  {
    "ph": 6.1,
    "nm": 660,
    "abs": 0.03462857142857143
  },
  {
    "ph": 6.2,
    "nm": 660,
    "abs": 0.04131428571428571
  },
  {
    "ph": 6.3,
    "nm": 660,
    "abs": 0.05708571428571429
  },
  {
    "ph": 6.4,
    "nm": 660,
    "abs": 0.07291428571428571
  },
  {
    "ph": 6.5,
    "nm": 660,
    "abs": 0.08868571428571428
  },
  {
    "ph": 6.6,
    "nm": 660,
    "abs": 0.10451428571428571
  },
  {
    "ph": 6.7,
    "nm": 660,
    "abs": 0.12028571428571429
  },
  {
    "ph": 6.8,
    "nm": 660,
    "abs": 0.13611428571428572
  },
  {
    "ph": 6.9,
    "nm": 660,
    "abs": 0.15188571428571426
  },
  {
    "ph": 7,
    "nm": 660,
    "abs": 0.1677142857142857
  },
  {
    "ph": 7.1,
    "nm": 660,
    "abs": 0.18348571428571428
  },
  {
    "ph": 7.2,
    "nm": 660,
    "abs": 0.19931428571428572
  },
  {
    "ph": 7.3,
    "nm": 660,
    "abs": 0.2150857142857143
  },
  {
    "ph": 7.4,
    "nm": 660,
    "abs": 0.2309142857142857
  },
  {
    "ph": 7.5,
    "nm": 660,
    "abs": 0.24668571428571426
  },
  {
    "ph": 7.6,
    "nm": 660,
    "abs": 0.2625142857142857
  },
  {
    "ph": 7.7,
    "nm": 660,
    "abs": 0.2782857142857143
  },
  {
    "ph": 7.8,
    "nm": 660,
    "abs": 0.2941142857142857
  },
  {
    "ph": 7.9,
    "nm": 660,
    "abs": 0.30988571428571426
  },
  {
    "ph": 8,
    "nm": 660,
    "abs": 0.3257142857142857
  },
  {
    "ph": 5,
    "nm": 665,
    "abs": 0.0031428571428571426
  },
  {
    "ph": 5.1,
    "nm": 665,
    "abs": 0.004971428571428571
  },
  {
    "ph": 5.2,
    "nm": 665,
    "abs": 0.0068000000000000005
  },
  {
    "ph": 5.3,
    "nm": 665,
    "abs": 0.008685714285714286
  },
  {
    "ph": 5.4,
    "nm": 665,
    "abs": 0.010514285714285714
  },
  {
    "ph": 5.5,
    "nm": 665,
    "abs": 0.012342857142857143
  },
  {
    "ph": 5.6,
    "nm": 665,
    "abs": 0.014228571428571427
  },
  {
    "ph": 5.7,
    "nm": 665,
    "abs": 0.016057142857142857
  },
  {
    "ph": 5.8,
    "nm": 665,
    "abs": 0.017942857142857142
  },
  {
    "ph": 5.9,
    "nm": 665,
    "abs": 0.019771428571428572
  },
  {
    "ph": 6,
    "nm": 665,
    "abs": 0.0216
  },
  {
    "ph": 6.1,
    "nm": 665,
    "abs": 0.023485714285714283
  },
  {
    "ph": 6.2,
    "nm": 665,
    "abs": 0.025314285714285713
  },
  {
    "ph": 6.3,
    "nm": 665,
    "abs": 0.03674285714285714
  },
  {
    "ph": 6.4,
    "nm": 665,
    "abs": 0.048628571428571424
  },
  {
    "ph": 6.5,
    "nm": 665,
    "abs": 0.06051428571428571
  },
  {
    "ph": 6.6,
    "nm": 665,
    "abs": 0.07234285714285714
  },
  {
    "ph": 6.7,
    "nm": 665,
    "abs": 0.08422857142857143
  },
  {
    "ph": 6.8,
    "nm": 665,
    "abs": 0.09611428571428571
  },
  {
    "ph": 6.9,
    "nm": 665,
    "abs": 0.10794285714285715
  },
  {
    "ph": 7,
    "nm": 665,
    "abs": 0.11982857142857142
  },
  {
    "ph": 7.1,
    "nm": 665,
    "abs": 0.13171428571428573
  },
  {
    "ph": 7.2,
    "nm": 665,
    "abs": 0.14354285714285714
  },
  {
    "ph": 7.3,
    "nm": 665,
    "abs": 0.15542857142857144
  },
  {
    "ph": 7.4,
    "nm": 665,
    "abs": 0.16731428571428572
  },
  {
    "ph": 7.5,
    "nm": 665,
    "abs": 0.17914285714285713
  },
  {
    "ph": 7.6,
    "nm": 665,
    "abs": 0.1910285714285714
  },
  {
    "ph": 7.7,
    "nm": 665,
    "abs": 0.20291428571428574
  },
  {
    "ph": 7.8,
    "nm": 665,
    "abs": 0.21480000000000002
  },
  {
    "ph": 7.9,
    "nm": 665,
    "abs": 0.22662857142857143
  },
  {
    "ph": 8,
    "nm": 665,
    "abs": 0.2385142857142857
  },
  {
    "ph": 5,
    "nm": 670,
    "abs": 0.0033714285714285712
  },
  {
    "ph": 5.1,
    "nm": 670,
    "abs": 0.004228571428571429
  },
  {
    "ph": 5.2,
    "nm": 670,
    "abs": 0.005028571428571429
  },
  {
    "ph": 5.3,
    "nm": 670,
    "abs": 0.005828571428571429
  },
  {
    "ph": 5.4,
    "nm": 670,
    "abs": 0.006628571428571428
  },
  {
    "ph": 5.5,
    "nm": 670,
    "abs": 0.007485714285714286
  },
  {
    "ph": 5.6,
    "nm": 670,
    "abs": 0.008285714285714287
  },
  {
    "ph": 5.7,
    "nm": 670,
    "abs": 0.009085714285714286
  },
  {
    "ph": 5.8,
    "nm": 670,
    "abs": 0.009885714285714286
  },
  {
    "ph": 5.9,
    "nm": 670,
    "abs": 0.010742857142857143
  },
  {
    "ph": 6,
    "nm": 670,
    "abs": 0.011542857142857143
  },
  {
    "ph": 6.1,
    "nm": 670,
    "abs": 0.012342857142857143
  },
  {
    "ph": 6.2,
    "nm": 670,
    "abs": 0.013142857142857142
  },
  {
    "ph": 6.3,
    "nm": 670,
    "abs": 0.01777142857142857
  },
  {
    "ph": 6.4,
    "nm": 670,
    "abs": 0.02817142857142857
  },
  {
    "ph": 6.5,
    "nm": 670,
    "abs": 0.038514285714285716
  },
  {
    "ph": 6.6,
    "nm": 670,
    "abs": 0.04885714285714286
  },
  {
    "ph": 6.7,
    "nm": 670,
    "abs": 0.059257142857142855
  },
  {
    "ph": 6.8,
    "nm": 670,
    "abs": 0.06960000000000001
  },
  {
    "ph": 6.9,
    "nm": 670,
    "abs": 0.07994285714285713
  },
  {
    "ph": 7,
    "nm": 670,
    "abs": 0.09028571428571429
  },
  {
    "ph": 7.1,
    "nm": 670,
    "abs": 0.10068571428571428
  },
  {
    "ph": 7.2,
    "nm": 670,
    "abs": 0.11102857142857143
  },
  {
    "ph": 7.3,
    "nm": 670,
    "abs": 0.12137142857142857
  },
  {
    "ph": 7.4,
    "nm": 670,
    "abs": 0.13171428571428573
  },
  {
    "ph": 7.5,
    "nm": 670,
    "abs": 0.14211428571428572
  },
  {
    "ph": 7.6,
    "nm": 670,
    "abs": 0.15245714285714285
  },
  {
    "ph": 7.7,
    "nm": 670,
    "abs": 0.1628
  },
  {
    "ph": 7.8,
    "nm": 670,
    "abs": 0.1732
  },
  {
    "ph": 7.9,
    "nm": 670,
    "abs": 0.18354285714285715
  },
  {
    "ph": 8,
    "nm": 670,
    "abs": 0.19388571428571427
  },
  {
    "ph": 5,
    "nm": 675,
    "abs": 0.0024
  },
  {
    "ph": 5.1,
    "nm": 675,
    "abs": 0.003085714285714286
  },
  {
    "ph": 5.2,
    "nm": 675,
    "abs": 0.0037714285714285714
  },
  {
    "ph": 5.3,
    "nm": 675,
    "abs": 0.004457142857142857
  },
  {
    "ph": 5.4,
    "nm": 675,
    "abs": 0.005142857142857143
  },
  {
    "ph": 5.5,
    "nm": 675,
    "abs": 0.005828571428571429
  },
  {
    "ph": 5.6,
    "nm": 675,
    "abs": 0.006514285714285715
  },
  {
    "ph": 5.7,
    "nm": 675,
    "abs": 0.0072
  },
  {
    "ph": 5.8,
    "nm": 675,
    "abs": 0.007885714285714286
  },
  {
    "ph": 5.9,
    "nm": 675,
    "abs": 0.008571428571428572
  },
  {
    "ph": 6,
    "nm": 675,
    "abs": 0.009257142857142856
  },
  {
    "ph": 6.1,
    "nm": 675,
    "abs": 0.009942857142857142
  },
  {
    "ph": 6.2,
    "nm": 675,
    "abs": 0.010628571428571428
  },
  {
    "ph": 6.3,
    "nm": 675,
    "abs": 0.01257142857142857
  },
  {
    "ph": 6.4,
    "nm": 675,
    "abs": 0.02057142857142857
  },
  {
    "ph": 6.5,
    "nm": 675,
    "abs": 0.028571428571428574
  },
  {
    "ph": 6.6,
    "nm": 675,
    "abs": 0.036571428571428574
  },
  {
    "ph": 6.7,
    "nm": 675,
    "abs": 0.044571428571428574
  },
  {
    "ph": 6.8,
    "nm": 675,
    "abs": 0.05257142857142857
  },
  {
    "ph": 6.9,
    "nm": 675,
    "abs": 0.06057142857142857
  },
  {
    "ph": 7,
    "nm": 675,
    "abs": 0.06857142857142857
  },
  {
    "ph": 7.1,
    "nm": 675,
    "abs": 0.07657142857142858
  },
  {
    "ph": 7.2,
    "nm": 675,
    "abs": 0.08457142857142856
  },
  {
    "ph": 7.3,
    "nm": 675,
    "abs": 0.09257142857142857
  },
  {
    "ph": 7.4,
    "nm": 675,
    "abs": 0.10057142857142856
  },
  {
    "ph": 7.5,
    "nm": 675,
    "abs": 0.10857142857142857
  },
  {
    "ph": 7.6,
    "nm": 675,
    "abs": 0.11657142857142856
  },
  {
    "ph": 7.7,
    "nm": 675,
    "abs": 0.12457142857142857
  },
  {
    "ph": 7.8,
    "nm": 675,
    "abs": 0.1325714285714286
  },
  {
    "ph": 7.9,
    "nm": 675,
    "abs": 0.14057142857142857
  },
  {
    "ph": 8,
    "nm": 675,
    "abs": 0.14851428571428574
  },
  {
    "ph": 5,
    "nm": 680,
    "abs": 0.0022285714285714283
  },
  {
    "ph": 5.1,
    "nm": 680,
    "abs": 0.002857142857142857
  },
  {
    "ph": 5.2,
    "nm": 680,
    "abs": 0.003485714285714286
  },
  {
    "ph": 5.3,
    "nm": 680,
    "abs": 0.004114285714285714
  },
  {
    "ph": 5.4,
    "nm": 680,
    "abs": 0.004742857142857143
  },
  {
    "ph": 5.5,
    "nm": 680,
    "abs": 0.005314285714285714
  },
  {
    "ph": 5.6,
    "nm": 680,
    "abs": 0.005942857142857143
  },
  {
    "ph": 5.7,
    "nm": 680,
    "abs": 0.006571428571428571
  },
  {
    "ph": 5.8,
    "nm": 680,
    "abs": 0.0072
  },
  {
    "ph": 5.9,
    "nm": 680,
    "abs": 0.00782857142857143
  },
  {
    "ph": 6,
    "nm": 680,
    "abs": 0.0084
  },
  {
    "ph": 6.1,
    "nm": 680,
    "abs": 0.00902857142857143
  },
  {
    "ph": 6.2,
    "nm": 680,
    "abs": 0.009657142857142855
  },
  {
    "ph": 6.3,
    "nm": 680,
    "abs": 0.014285714285714287
  },
  {
    "ph": 6.4,
    "nm": 680,
    "abs": 0.01937142857142857
  },
  {
    "ph": 6.5,
    "nm": 680,
    "abs": 0.024514285714285714
  },
  {
    "ph": 6.6,
    "nm": 680,
    "abs": 0.029657142857142858
  },
  {
    "ph": 6.7,
    "nm": 680,
    "abs": 0.034800000000000005
  },
  {
    "ph": 6.8,
    "nm": 680,
    "abs": 0.03994285714285715
  },
  {
    "ph": 6.9,
    "nm": 680,
    "abs": 0.045085714285714285
  },
  {
    "ph": 7,
    "nm": 680,
    "abs": 0.050171428571428575
  },
  {
    "ph": 7.1,
    "nm": 680,
    "abs": 0.05531428571428571
  },
  {
    "ph": 7.2,
    "nm": 680,
    "abs": 0.06045714285714286
  },
  {
    "ph": 7.3,
    "nm": 680,
    "abs": 0.0656
  },
  {
    "ph": 7.4,
    "nm": 680,
    "abs": 0.07074285714285714
  },
  {
    "ph": 7.5,
    "nm": 680,
    "abs": 0.07582857142857144
  },
  {
    "ph": 7.6,
    "nm": 680,
    "abs": 0.08097142857142857
  },
  {
    "ph": 7.7,
    "nm": 680,
    "abs": 0.08611428571428571
  },
  {
    "ph": 7.8,
    "nm": 680,
    "abs": 0.09125714285714286
  },
  {
    "ph": 7.9,
    "nm": 680,
    "abs": 0.0964
  },
  {
    "ph": 8,
    "nm": 680,
    "abs": 0.10154285714285714
  },
  {
    "ph": 5,
    "nm": 685,
    "abs": 0
  },
  {
    "ph": 5.1,
    "nm": 685,
    "abs": 0.0006285714285714286
  },
  {
    "ph": 5.2,
    "nm": 685,
    "abs": 0.002057142857142857
  },
  {
    "ph": 5.3,
    "nm": 685,
    "abs": 0.0035428571428571427
  },
  {
    "ph": 5.4,
    "nm": 685,
    "abs": 0.004971428571428571
  },
  {
    "ph": 5.5,
    "nm": 685,
    "abs": 0.006457142857142857
  },
  {
    "ph": 5.6,
    "nm": 685,
    "abs": 0.007885714285714286
  },
  {
    "ph": 5.7,
    "nm": 685,
    "abs": 0.009371428571428572
  },
  {
    "ph": 5.8,
    "nm": 685,
    "abs": 0.0108
  },
  {
    "ph": 5.9,
    "nm": 685,
    "abs": 0.012285714285714285
  },
  {
    "ph": 6,
    "nm": 685,
    "abs": 0.013714285714285715
  },
  {
    "ph": 6.1,
    "nm": 685,
    "abs": 0.0152
  },
  {
    "ph": 6.2,
    "nm": 685,
    "abs": 0.01662857142857143
  },
  {
    "ph": 6.3,
    "nm": 685,
    "abs": 0.01805714285714286
  },
  {
    "ph": 6.4,
    "nm": 685,
    "abs": 0.019542857142857143
  },
  {
    "ph": 6.5,
    "nm": 685,
    "abs": 0.020971428571428575
  },
  {
    "ph": 6.6,
    "nm": 685,
    "abs": 0.02245714285714286
  },
  {
    "ph": 6.7,
    "nm": 685,
    "abs": 0.023885714285714284
  },
  {
    "ph": 6.8,
    "nm": 685,
    "abs": 0.025371428571428573
  },
  {
    "ph": 6.9,
    "nm": 685,
    "abs": 0.026799999999999997
  },
  {
    "ph": 7,
    "nm": 685,
    "abs": 0.028285714285714286
  },
  {
    "ph": 7.1,
    "nm": 685,
    "abs": 0.029714285714285714
  },
  {
    "ph": 7.2,
    "nm": 685,
    "abs": 0.031200000000000002
  },
  {
    "ph": 7.3,
    "nm": 685,
    "abs": 0.03274285714285714
  },
  {
    "ph": 7.4,
    "nm": 685,
    "abs": 0.03691428571428572
  },
  {
    "ph": 7.5,
    "nm": 685,
    "abs": 0.04114285714285714
  },
  {
    "ph": 7.6,
    "nm": 685,
    "abs": 0.04531428571428571
  },
  {
    "ph": 7.7,
    "nm": 685,
    "abs": 0.049485714285714286
  },
  {
    "ph": 7.8,
    "nm": 685,
    "abs": 0.053714285714285714
  },
  {
    "ph": 7.9,
    "nm": 685,
    "abs": 0.05788571428571428
  },
  {
    "ph": 8,
    "nm": 685,
    "abs": 0.06205714285714286
  },
  {
    "ph": 5,
    "nm": 690,
    "abs": 0.0026857142857142856
  },
  {
    "ph": 5.1,
    "nm": 690,
    "abs": 0.002857142857142857
  },
  {
    "ph": 5.2,
    "nm": 690,
    "abs": 0.0030285714285714286
  },
  {
    "ph": 5.3,
    "nm": 690,
    "abs": 0.0032
  },
  {
    "ph": 5.4,
    "nm": 690,
    "abs": 0.0033714285714285712
  },
  {
    "ph": 5.5,
    "nm": 690,
    "abs": 0.0035428571428571427
  },
  {
    "ph": 5.6,
    "nm": 690,
    "abs": 0.0037142857142857142
  },
  {
    "ph": 5.7,
    "nm": 690,
    "abs": 0.0038857142857142853
  },
  {
    "ph": 5.8,
    "nm": 690,
    "abs": 0.004285714285714286
  },
  {
    "ph": 5.9,
    "nm": 690,
    "abs": 0.005485714285714286
  },
  {
    "ph": 6,
    "nm": 690,
    "abs": 0.006628571428571428
  },
  {
    "ph": 6.1,
    "nm": 690,
    "abs": 0.00782857142857143
  },
  {
    "ph": 6.2,
    "nm": 690,
    "abs": 0.00902857142857143
  },
  {
    "ph": 6.3,
    "nm": 690,
    "abs": 0.01017142857142857
  },
  {
    "ph": 6.4,
    "nm": 690,
    "abs": 0.011371428571428572
  },
  {
    "ph": 6.5,
    "nm": 690,
    "abs": 0.01257142857142857
  },
  {
    "ph": 6.6,
    "nm": 690,
    "abs": 0.013771428571428572
  },
  {
    "ph": 6.7,
    "nm": 690,
    "abs": 0.014914285714285715
  },
  {
    "ph": 6.8,
    "nm": 690,
    "abs": 0.016114285714285713
  },
  {
    "ph": 6.9,
    "nm": 690,
    "abs": 0.017314285714285716
  },
  {
    "ph": 7,
    "nm": 690,
    "abs": 0.018514285714285712
  },
  {
    "ph": 7.1,
    "nm": 690,
    "abs": 0.019657142857142856
  },
  {
    "ph": 7.2,
    "nm": 690,
    "abs": 0.020857142857142855
  },
  {
    "ph": 7.3,
    "nm": 690,
    "abs": 0.02205714285714286
  },
  {
    "ph": 7.4,
    "nm": 690,
    "abs": 0.0232
  },
  {
    "ph": 7.5,
    "nm": 690,
    "abs": 0.0244
  },
  {
    "ph": 7.6,
    "nm": 690,
    "abs": 0.0256
  },
  {
    "ph": 7.7,
    "nm": 690,
    "abs": 0.026799999999999997
  },
  {
    "ph": 7.8,
    "nm": 690,
    "abs": 0.02794285714285714
  },
  {
    "ph": 7.9,
    "nm": 690,
    "abs": 0.02914285714285714
  },
  {
    "ph": 8,
    "nm": 690,
    "abs": 0.030342857142857144
  },
  {
    "ph": 5,
    "nm": 695,
    "abs": 0.0010285714285714286
  },
  {
    "ph": 5.1,
    "nm": 695,
    "abs": 0.0017714285714285714
  },
  {
    "ph": 5.2,
    "nm": 695,
    "abs": 0.0025714285714285713
  },
  {
    "ph": 5.3,
    "nm": 695,
    "abs": 0.003314285714285714
  },
  {
    "ph": 5.4,
    "nm": 695,
    "abs": 0.004114285714285714
  },
  {
    "ph": 5.5,
    "nm": 695,
    "abs": 0.004914285714285714
  },
  {
    "ph": 5.6,
    "nm": 695,
    "abs": 0.005657142857142858
  },
  {
    "ph": 5.7,
    "nm": 695,
    "abs": 0.006457142857142857
  },
  {
    "ph": 5.8,
    "nm": 695,
    "abs": 0.0072
  },
  {
    "ph": 5.9,
    "nm": 695,
    "abs": 0.008
  },
  {
    "ph": 6,
    "nm": 695,
    "abs": 0.0088
  },
  {
    "ph": 6.1,
    "nm": 695,
    "abs": 0.009542857142857143
  },
  {
    "ph": 6.2,
    "nm": 695,
    "abs": 0.010342857142857143
  },
  {
    "ph": 6.3,
    "nm": 695,
    "abs": 0.011085714285714286
  },
  {
    "ph": 6.4,
    "nm": 695,
    "abs": 0.011885714285714286
  },
  {
    "ph": 6.5,
    "nm": 695,
    "abs": 0.012685714285714286
  },
  {
    "ph": 6.6,
    "nm": 695,
    "abs": 0.013428571428571429
  },
  {
    "ph": 6.7,
    "nm": 695,
    "abs": 0.014228571428571427
  },
  {
    "ph": 6.8,
    "nm": 695,
    "abs": 0.014971428571428571
  },
  {
    "ph": 6.9,
    "nm": 695,
    "abs": 0.01577142857142857
  },
  {
    "ph": 7,
    "nm": 695,
    "abs": 0.016514285714285714
  },
  {
    "ph": 7.1,
    "nm": 695,
    "abs": 0.017828571428571426
  },
  {
    "ph": 7.2,
    "nm": 695,
    "abs": 0.019142857142857145
  },
  {
    "ph": 7.3,
    "nm": 695,
    "abs": 0.020514285714285714
  },
  {
    "ph": 7.4,
    "nm": 695,
    "abs": 0.021885714285714286
  },
  {
    "ph": 7.5,
    "nm": 695,
    "abs": 0.0232
  },
  {
    "ph": 7.6,
    "nm": 695,
    "abs": 0.02457142857142857
  },
  {
    "ph": 7.7,
    "nm": 695,
    "abs": 0.025885714285714286
  },
  {
    "ph": 7.8,
    "nm": 695,
    "abs": 0.027257142857142858
  },
  {
    "ph": 7.9,
    "nm": 695,
    "abs": 0.028628571428571427
  },
  {
    "ph": 8,
    "nm": 695,
    "abs": 0.029942857142857143
  },
  {
    "ph": 5,
    "nm": 700,
    "abs": 0.0021142857142857144
  },
  {
    "ph": 5.1,
    "nm": 700,
    "abs": 0.0021714285714285715
  },
  {
    "ph": 5.2,
    "nm": 700,
    "abs": 0.0022285714285714283
  },
  {
    "ph": 5.3,
    "nm": 700,
    "abs": 0.002342857142857143
  },
  {
    "ph": 5.4,
    "nm": 700,
    "abs": 0.0024
  },
  {
    "ph": 5.5,
    "nm": 700,
    "abs": 0.002457142857142857
  },
  {
    "ph": 5.6,
    "nm": 700,
    "abs": 0.0031428571428571426
  },
  {
    "ph": 5.7,
    "nm": 700,
    "abs": 0.004114285714285714
  },
  {
    "ph": 5.8,
    "nm": 700,
    "abs": 0.005028571428571429
  },
  {
    "ph": 5.9,
    "nm": 700,
    "abs": 0.005942857142857143
  },
  {
    "ph": 6,
    "nm": 700,
    "abs": 0.006914285714285714
  },
  {
    "ph": 6.1,
    "nm": 700,
    "abs": 0.00782857142857143
  },
  {
    "ph": 6.2,
    "nm": 700,
    "abs": 0.008742857142857142
  },
  {
    "ph": 6.3,
    "nm": 700,
    "abs": 0.009714285714285715
  },
  {
    "ph": 6.4,
    "nm": 700,
    "abs": 0.010628571428571428
  },
  {
    "ph": 6.5,
    "nm": 700,
    "abs": 0.0116
  },
  {
    "ph": 6.6,
    "nm": 700,
    "abs": 0.012514285714285714
  },
  {
    "ph": 6.7,
    "nm": 700,
    "abs": 0.013428571428571429
  },
  {
    "ph": 6.8,
    "nm": 700,
    "abs": 0.0144
  },
  {
    "ph": 6.9,
    "nm": 700,
    "abs": 0.015314285714285714
  },
  {
    "ph": 7,
    "nm": 700,
    "abs": 0.016285714285714285
  },
  {
    "ph": 7.1,
    "nm": 700,
    "abs": 0.0172
  },
  {
    "ph": 7.2,
    "nm": 700,
    "abs": 0.018114285714285715
  },
  {
    "ph": 7.3,
    "nm": 700,
    "abs": 0.019085714285714286
  },
  {
    "ph": 7.4,
    "nm": 700,
    "abs": 0.02
  },
  {
    "ph": 7.5,
    "nm": 700,
    "abs": 0.020971428571428575
  },
  {
    "ph": 7.6,
    "nm": 700,
    "abs": 0.021885714285714286
  },
  {
    "ph": 7.7,
    "nm": 700,
    "abs": 0.022799999999999997
  },
  {
    "ph": 7.8,
    "nm": 700,
    "abs": 0.023771428571428572
  },
  {
    "ph": 7.9,
    "nm": 700,
    "abs": 0.024685714285714287
  },
  {
    "ph": 8,
    "nm": 700,
    "abs": 0.0256
  },
  {
    "ph": 5,
    "nm": 705,
    "abs": 0.0018285714285714288
  },
  {
    "ph": 5.1,
    "nm": 705,
    "abs": 0.0018857142857142857
  },
  {
    "ph": 5.2,
    "nm": 705,
    "abs": 0.002
  },
  {
    "ph": 5.3,
    "nm": 705,
    "abs": 0.002057142857142857
  },
  {
    "ph": 5.4,
    "nm": 705,
    "abs": 0.0021714285714285715
  },
  {
    "ph": 5.5,
    "nm": 705,
    "abs": 0.002285714285714286
  },
  {
    "ph": 5.6,
    "nm": 705,
    "abs": 0.0024
  },
  {
    "ph": 5.7,
    "nm": 705,
    "abs": 0.0032571428571428573
  },
  {
    "ph": 5.8,
    "nm": 705,
    "abs": 0.004057142857142857
  },
  {
    "ph": 5.9,
    "nm": 705,
    "abs": 0.004914285714285714
  },
  {
    "ph": 6,
    "nm": 705,
    "abs": 0.0057714285714285714
  },
  {
    "ph": 6.1,
    "nm": 705,
    "abs": 0.006571428571428571
  },
  {
    "ph": 6.2,
    "nm": 705,
    "abs": 0.0074285714285714285
  },
  {
    "ph": 6.3,
    "nm": 705,
    "abs": 0.008285714285714287
  },
  {
    "ph": 6.4,
    "nm": 705,
    "abs": 0.009085714285714286
  },
  {
    "ph": 6.5,
    "nm": 705,
    "abs": 0.009942857142857142
  },
  {
    "ph": 6.6,
    "nm": 705,
    "abs": 0.0108
  },
  {
    "ph": 6.7,
    "nm": 705,
    "abs": 0.0116
  },
  {
    "ph": 6.8,
    "nm": 705,
    "abs": 0.012457142857142858
  },
  {
    "ph": 6.9,
    "nm": 705,
    "abs": 0.013314285714285714
  },
  {
    "ph": 7,
    "nm": 705,
    "abs": 0.014114285714285715
  },
  {
    "ph": 7.1,
    "nm": 705,
    "abs": 0.014971428571428571
  },
  {
    "ph": 7.2,
    "nm": 705,
    "abs": 0.01577142857142857
  },
  {
    "ph": 7.3,
    "nm": 705,
    "abs": 0.01662857142857143
  },
  {
    "ph": 7.4,
    "nm": 705,
    "abs": 0.017485714285714285
  },
  {
    "ph": 7.5,
    "nm": 705,
    "abs": 0.018285714285714287
  },
  {
    "ph": 7.6,
    "nm": 705,
    "abs": 0.019142857142857145
  },
  {
    "ph": 7.7,
    "nm": 705,
    "abs": 0.02
  },
  {
    "ph": 7.8,
    "nm": 705,
    "abs": 0.020800000000000003
  },
  {
    "ph": 7.9,
    "nm": 705,
    "abs": 0.021657142857142857
  },
  {
    "ph": 8,
    "nm": 705,
    "abs": 0.022514285714285712
  },
  {
    "ph": 5,
    "nm": 710,
    "abs": 0.0014857142857142857
  },
  {
    "ph": 5.1,
    "nm": 710,
    "abs": 0.0016
  },
  {
    "ph": 5.2,
    "nm": 710,
    "abs": 0.0017142857142857144
  },
  {
    "ph": 5.3,
    "nm": 710,
    "abs": 0.0018285714285714288
  },
  {
    "ph": 5.4,
    "nm": 710,
    "abs": 0.0019428571428571427
  },
  {
    "ph": 5.5,
    "nm": 710,
    "abs": 0.002057142857142857
  },
  {
    "ph": 5.6,
    "nm": 710,
    "abs": 0.0021714285714285715
  },
  {
    "ph": 5.7,
    "nm": 710,
    "abs": 0.0024
  },
  {
    "ph": 5.8,
    "nm": 710,
    "abs": 0.0031428571428571426
  },
  {
    "ph": 5.9,
    "nm": 710,
    "abs": 0.0038857142857142853
  },
  {
    "ph": 6,
    "nm": 710,
    "abs": 0.004628571428571428
  },
  {
    "ph": 6.1,
    "nm": 710,
    "abs": 0.005371428571428571
  },
  {
    "ph": 6.2,
    "nm": 710,
    "abs": 0.006114285714285714
  },
  {
    "ph": 6.3,
    "nm": 710,
    "abs": 0.006857142857142858
  },
  {
    "ph": 6.4,
    "nm": 710,
    "abs": 0.007542857142857143
  },
  {
    "ph": 6.5,
    "nm": 710,
    "abs": 0.008285714285714287
  },
  {
    "ph": 6.6,
    "nm": 710,
    "abs": 0.00902857142857143
  },
  {
    "ph": 6.7,
    "nm": 710,
    "abs": 0.009771428571428572
  },
  {
    "ph": 6.8,
    "nm": 710,
    "abs": 0.010514285714285714
  },
  {
    "ph": 6.9,
    "nm": 710,
    "abs": 0.011257142857142856
  },
  {
    "ph": 7,
    "nm": 710,
    "abs": 0.012
  },
  {
    "ph": 7.1,
    "nm": 710,
    "abs": 0.012742857142857143
  },
  {
    "ph": 7.2,
    "nm": 710,
    "abs": 0.013485714285714285
  },
  {
    "ph": 7.3,
    "nm": 710,
    "abs": 0.014171428571428571
  },
  {
    "ph": 7.4,
    "nm": 710,
    "abs": 0.014914285714285715
  },
  {
    "ph": 7.5,
    "nm": 710,
    "abs": 0.01565714285714286
  },
  {
    "ph": 7.6,
    "nm": 710,
    "abs": 0.0164
  },
  {
    "ph": 7.7,
    "nm": 710,
    "abs": 0.017142857142857144
  },
  {
    "ph": 7.8,
    "nm": 710,
    "abs": 0.017885714285714286
  },
  {
    "ph": 7.9,
    "nm": 710,
    "abs": 0.01862857142857143
  },
  {
    "ph": 8,
    "nm": 710,
    "abs": 0.01937142857142857
  },
  {
    "ph": 5,
    "nm": 715,
    "abs": 0.0012
  },
  {
    "ph": 5.1,
    "nm": 715,
    "abs": 0.0013714285714285714
  },
  {
    "ph": 5.2,
    "nm": 715,
    "abs": 0.0014857142857142857
  },
  {
    "ph": 5.3,
    "nm": 715,
    "abs": 0.0016
  },
  {
    "ph": 5.4,
    "nm": 715,
    "abs": 0.0017714285714285714
  },
  {
    "ph": 5.5,
    "nm": 715,
    "abs": 0.0018857142857142857
  },
  {
    "ph": 5.6,
    "nm": 715,
    "abs": 0.002
  },
  {
    "ph": 5.7,
    "nm": 715,
    "abs": 0.0021714285714285715
  },
  {
    "ph": 5.8,
    "nm": 715,
    "abs": 0.002285714285714286
  },
  {
    "ph": 5.9,
    "nm": 715,
    "abs": 0.002857142857142857
  },
  {
    "ph": 6,
    "nm": 715,
    "abs": 0.003485714285714286
  },
  {
    "ph": 6.1,
    "nm": 715,
    "abs": 0.004114285714285714
  },
  {
    "ph": 6.2,
    "nm": 715,
    "abs": 0.004742857142857143
  },
  {
    "ph": 6.3,
    "nm": 715,
    "abs": 0.005371428571428571
  },
  {
    "ph": 6.4,
    "nm": 715,
    "abs": 0.006
  },
  {
    "ph": 6.5,
    "nm": 715,
    "abs": 0.006685714285714286
  },
  {
    "ph": 6.6,
    "nm": 715,
    "abs": 0.007314285714285715
  },
  {
    "ph": 6.7,
    "nm": 715,
    "abs": 0.007942857142857142
  },
  {
    "ph": 6.8,
    "nm": 715,
    "abs": 0.008571428571428572
  },
  {
    "ph": 6.9,
    "nm": 715,
    "abs": 0.0092
  },
  {
    "ph": 7,
    "nm": 715,
    "abs": 0.009828571428571428
  },
  {
    "ph": 7.1,
    "nm": 715,
    "abs": 0.010514285714285714
  },
  {
    "ph": 7.2,
    "nm": 715,
    "abs": 0.011142857142857144
  },
  {
    "ph": 7.3,
    "nm": 715,
    "abs": 0.011771428571428572
  },
  {
    "ph": 7.4,
    "nm": 715,
    "abs": 0.0124
  },
  {
    "ph": 7.5,
    "nm": 715,
    "abs": 0.01302857142857143
  },
  {
    "ph": 7.6,
    "nm": 715,
    "abs": 0.013657142857142857
  },
  {
    "ph": 7.7,
    "nm": 715,
    "abs": 0.014285714285714287
  },
  {
    "ph": 7.8,
    "nm": 715,
    "abs": 0.014971428571428571
  },
  {
    "ph": 7.9,
    "nm": 715,
    "abs": 0.015600000000000001
  },
  {
    "ph": 8,
    "nm": 715,
    "abs": 0.01622857142857143
  },
  {
    "ph": 5,
    "nm": 720,
    "abs": 0.0009142857142857144
  },
  {
    "ph": 5.1,
    "nm": 720,
    "abs": 0.0010857142857142858
  },
  {
    "ph": 5.2,
    "nm": 720,
    "abs": 0.0012
  },
  {
    "ph": 5.3,
    "nm": 720,
    "abs": 0.0013714285714285714
  },
  {
    "ph": 5.4,
    "nm": 720,
    "abs": 0.0014857142857142857
  },
  {
    "ph": 5.5,
    "nm": 720,
    "abs": 0.001657142857142857
  },
  {
    "ph": 5.6,
    "nm": 720,
    "abs": 0.0017714285714285714
  },
  {
    "ph": 5.7,
    "nm": 720,
    "abs": 0.0019428571428571427
  },
  {
    "ph": 5.8,
    "nm": 720,
    "abs": 0.002057142857142857
  },
  {
    "ph": 5.9,
    "nm": 720,
    "abs": 0.0022285714285714283
  },
  {
    "ph": 6,
    "nm": 720,
    "abs": 0.002342857142857143
  },
  {
    "ph": 6.1,
    "nm": 720,
    "abs": 0.0029142857142857143
  },
  {
    "ph": 6.2,
    "nm": 720,
    "abs": 0.003428571428571429
  },
  {
    "ph": 6.3,
    "nm": 720,
    "abs": 0.003942857142857143
  },
  {
    "ph": 6.4,
    "nm": 720,
    "abs": 0.004514285714285715
  },
  {
    "ph": 6.5,
    "nm": 720,
    "abs": 0.005028571428571429
  },
  {
    "ph": 6.6,
    "nm": 720,
    "abs": 0.0056
  },
  {
    "ph": 6.7,
    "nm": 720,
    "abs": 0.006114285714285714
  },
  {
    "ph": 6.8,
    "nm": 720,
    "abs": 0.006628571428571428
  },
  {
    "ph": 6.9,
    "nm": 720,
    "abs": 0.0072
  },
  {
    "ph": 7,
    "nm": 720,
    "abs": 0.007714285714285714
  },
  {
    "ph": 7.1,
    "nm": 720,
    "abs": 0.008228571428571429
  },
  {
    "ph": 7.2,
    "nm": 720,
    "abs": 0.0088
  },
  {
    "ph": 7.3,
    "nm": 720,
    "abs": 0.009314285714285714
  },
  {
    "ph": 7.4,
    "nm": 720,
    "abs": 0.009885714285714286
  },
  {
    "ph": 7.5,
    "nm": 720,
    "abs": 0.010400000000000001
  },
  {
    "ph": 7.6,
    "nm": 720,
    "abs": 0.010914285714285713
  },
  {
    "ph": 7.7,
    "nm": 720,
    "abs": 0.011485714285714285
  },
  {
    "ph": 7.8,
    "nm": 720,
    "abs": 0.012
  },
  {
    "ph": 7.9,
    "nm": 720,
    "abs": 0.01257142857142857
  },
  {
    "ph": 8,
    "nm": 720,
    "abs": 0.013085714285714286
  },
  {
    "ph": 5,
    "nm": 725,
    "abs": 0.0008571428571428572
  },
  {
    "ph": 5.1,
    "nm": 725,
    "abs": 0.0008571428571428572
  },
  {
    "ph": 5.2,
    "nm": 725,
    "abs": 0.0009142857142857144
  },
  {
    "ph": 5.3,
    "nm": 725,
    "abs": 0.0009714285714285713
  },
  {
    "ph": 5.4,
    "nm": 725,
    "abs": 0.0010285714285714286
  },
  {
    "ph": 5.5,
    "nm": 725,
    "abs": 0.0010857142857142858
  },
  {
    "ph": 5.6,
    "nm": 725,
    "abs": 0.0010857142857142858
  },
  {
    "ph": 5.7,
    "nm": 725,
    "abs": 0.001142857142857143
  },
  {
    "ph": 5.8,
    "nm": 725,
    "abs": 0.0012
  },
  {
    "ph": 5.9,
    "nm": 725,
    "abs": 0.0012571428571428573
  },
  {
    "ph": 6,
    "nm": 725,
    "abs": 0.0013142857142857142
  },
  {
    "ph": 6.1,
    "nm": 725,
    "abs": 0.0017714285714285714
  },
  {
    "ph": 6.2,
    "nm": 725,
    "abs": 0.0021714285714285715
  },
  {
    "ph": 6.3,
    "nm": 725,
    "abs": 0.0026285714285714285
  },
  {
    "ph": 6.4,
    "nm": 725,
    "abs": 0.0030285714285714286
  },
  {
    "ph": 6.5,
    "nm": 725,
    "abs": 0.003485714285714286
  },
  {
    "ph": 6.6,
    "nm": 725,
    "abs": 0.0038857142857142853
  },
  {
    "ph": 6.7,
    "nm": 725,
    "abs": 0.004342857142857143
  },
  {
    "ph": 6.8,
    "nm": 725,
    "abs": 0.004742857142857143
  },
  {
    "ph": 6.9,
    "nm": 725,
    "abs": 0.005200000000000001
  },
  {
    "ph": 7,
    "nm": 725,
    "abs": 0.0056
  },
  {
    "ph": 7.1,
    "nm": 725,
    "abs": 0.006057142857142857
  },
  {
    "ph": 7.2,
    "nm": 725,
    "abs": 0.006457142857142857
  },
  {
    "ph": 7.3,
    "nm": 725,
    "abs": 0.006914285714285714
  },
  {
    "ph": 7.4,
    "nm": 725,
    "abs": 0.007314285714285715
  },
  {
    "ph": 7.5,
    "nm": 725,
    "abs": 0.007771428571428571
  },
  {
    "ph": 7.6,
    "nm": 725,
    "abs": 0.00817142857142857
  },
  {
    "ph": 7.7,
    "nm": 725,
    "abs": 0.008628571428571428
  },
  {
    "ph": 7.8,
    "nm": 725,
    "abs": 0.00902857142857143
  },
  {
    "ph": 7.9,
    "nm": 725,
    "abs": 0.009485714285714287
  },
  {
    "ph": 8,
    "nm": 725,
    "abs": 0.009885714285714286
  },
  {
    "ph": 5,
    "nm": 730,
    "abs": 0.0007428571428571429
  },
  {
    "ph": 5.1,
    "nm": 730,
    "abs": 0.0006857142857142857
  },
  {
    "ph": 5.2,
    "nm": 730,
    "abs": 0.0006285714285714286
  },
  {
    "ph": 5.3,
    "nm": 730,
    "abs": 0.0005714285714285715
  },
  {
    "ph": 5.4,
    "nm": 730,
    "abs": 0.0005714285714285715
  },
  {
    "ph": 5.5,
    "nm": 730,
    "abs": 0.0005142857142857143
  },
  {
    "ph": 5.6,
    "nm": 730,
    "abs": 0.0004571428571428572
  },
  {
    "ph": 5.7,
    "nm": 730,
    "abs": 0.0004
  },
  {
    "ph": 5.8,
    "nm": 730,
    "abs": 0.0004
  },
  {
    "ph": 5.9,
    "nm": 730,
    "abs": 0.00034285714285714285
  },
  {
    "ph": 6,
    "nm": 730,
    "abs": 0.00028571428571428574
  },
  {
    "ph": 6.1,
    "nm": 730,
    "abs": 0.0006285714285714286
  },
  {
    "ph": 6.2,
    "nm": 730,
    "abs": 0.0009714285714285713
  },
  {
    "ph": 6.3,
    "nm": 730,
    "abs": 0.0012571428571428573
  },
  {
    "ph": 6.4,
    "nm": 730,
    "abs": 0.0016
  },
  {
    "ph": 6.5,
    "nm": 730,
    "abs": 0.0018857142857142857
  },
  {
    "ph": 6.6,
    "nm": 730,
    "abs": 0.0022285714285714283
  },
  {
    "ph": 6.7,
    "nm": 730,
    "abs": 0.0025714285714285713
  },
  {
    "ph": 6.8,
    "nm": 730,
    "abs": 0.002857142857142857
  },
  {
    "ph": 6.9,
    "nm": 730,
    "abs": 0.0032
  },
  {
    "ph": 7,
    "nm": 730,
    "abs": 0.0035428571428571427
  },
  {
    "ph": 7.1,
    "nm": 730,
    "abs": 0.0038285714285714286
  },
  {
    "ph": 7.2,
    "nm": 730,
    "abs": 0.004171428571428572
  },
  {
    "ph": 7.3,
    "nm": 730,
    "abs": 0.004514285714285715
  },
  {
    "ph": 7.4,
    "nm": 730,
    "abs": 0.0048
  },
  {
    "ph": 7.5,
    "nm": 730,
    "abs": 0.005142857142857143
  },
  {
    "ph": 7.6,
    "nm": 730,
    "abs": 0.0054285714285714284
  },
  {
    "ph": 7.7,
    "nm": 730,
    "abs": 0.0057714285714285714
  },
  {
    "ph": 7.8,
    "nm": 730,
    "abs": 0.006114285714285714
  },
  {
    "ph": 7.9,
    "nm": 730,
    "abs": 0.0064
  },
  {
    "ph": 8,
    "nm": 730,
    "abs": 0.0067428571428571425
  },
  {
    "ph": 5,
    "nm": 735,
    "abs": 0.0005714285714285715
  },
  {
    "ph": 5.1,
    "nm": 735,
    "abs": 0.0004571428571428572
  },
  {
    "ph": 5.2,
    "nm": 735,
    "abs": 0.00034285714285714285
  },
  {
    "ph": 5.3,
    "nm": 735,
    "abs": 0.0002285714285714286
  },
  {
    "ph": 5.4,
    "nm": 735,
    "abs": 0.0001142857142857143
  },
  {
    "ph": 5.5,
    "nm": 735,
    "abs": 0.000002532114285714286
  },
  {
    "ph": 5.6,
    "nm": 735,
    "abs": 0
  },
  {
    "ph": 5.7,
    "nm": 735,
    "abs": 0
  },
  {
    "ph": 5.8,
    "nm": 735,
    "abs": 0
  },
  {
    "ph": 5.9,
    "nm": 735,
    "abs": 0
  },
  {
    "ph": 6,
    "nm": 735,
    "abs": 0
  },
  {
    "ph": 6.1,
    "nm": 735,
    "abs": 0
  },
  {
    "ph": 6.2,
    "nm": 735,
    "abs": 0
  },
  {
    "ph": 6.3,
    "nm": 735,
    "abs": 0
  },
  {
    "ph": 6.4,
    "nm": 735,
    "abs": 0
  },
  {
    "ph": 6.5,
    "nm": 735,
    "abs": 0.00017142857142857143
  },
  {
    "ph": 6.6,
    "nm": 735,
    "abs": 0.0004
  },
  {
    "ph": 6.7,
    "nm": 735,
    "abs": 0.0006285714285714286
  },
  {
    "ph": 6.8,
    "nm": 735,
    "abs": 0.0008571428571428572
  },
  {
    "ph": 6.9,
    "nm": 735,
    "abs": 0.0010857142857142858
  },
  {
    "ph": 7,
    "nm": 735,
    "abs": 0.0013142857142857142
  },
  {
    "ph": 7.1,
    "nm": 735,
    "abs": 0.001542857142857143
  },
  {
    "ph": 7.2,
    "nm": 735,
    "abs": 0.0017714285714285714
  },
  {
    "ph": 7.3,
    "nm": 735,
    "abs": 0.002
  },
  {
    "ph": 7.4,
    "nm": 735,
    "abs": 0.002285714285714286
  },
  {
    "ph": 7.5,
    "nm": 735,
    "abs": 0.0025142857142857146
  },
  {
    "ph": 7.6,
    "nm": 735,
    "abs": 0.002742857142857143
  },
  {
    "ph": 7.7,
    "nm": 735,
    "abs": 0.0029714285714285715
  },
  {
    "ph": 7.8,
    "nm": 735,
    "abs": 0.0032
  },
  {
    "ph": 7.9,
    "nm": 735,
    "abs": 0.003428571428571429
  },
  {
    "ph": 8,
    "nm": 735,
    "abs": 0.0036571428571428575
  },
  {
    "ph": 5,
    "nm": 740,
    "abs": 0.0004
  },
  {
    "ph": 5.1,
    "nm": 740,
    "abs": 0.0002285714285714286
  },
  {
    "ph": 5.2,
    "nm": 740,
    "abs": 0.00005714285714285715
  },
  {
    "ph": 5.3,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 5.4,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 5.5,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 5.6,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 5.7,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 5.8,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 5.9,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 6,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 6.1,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 6.2,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 6.3,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 6.4,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 6.5,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 6.6,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 6.7,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 6.8,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 6.9,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 7,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 7.1,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 7.2,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 7.3,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 7.4,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 7.5,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 7.6,
    "nm": 740,
    "abs": 0
  },
  {
    "ph": 7.7,
    "nm": 740,
    "abs": 0.00017142857142857143
  },
  {
    "ph": 7.8,
    "nm": 740,
    "abs": 0.00034285714285714285
  },
  {
    "ph": 7.9,
    "nm": 740,
    "abs": 0.0004571428571428572
  },
  {
    "ph": 8,
    "nm": 740,
    "abs": 0.0006285714285714286
  },
  {
    "ph": 5,
    "nm": 745,
    "abs": 0.00028571428571428574
  },
  {
    "ph": 5.1,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 5.2,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 5.3,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 5.4,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 5.5,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 5.6,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 5.7,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 5.8,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 5.9,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 6,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 6.1,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 6.2,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 6.3,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 6.4,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 6.5,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 6.6,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 6.7,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 6.8,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 6.9,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 7,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 7.1,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 7.2,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 7.3,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 7.4,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 7.5,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 7.6,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 7.7,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 7.8,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 7.9,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 8,
    "nm": 745,
    "abs": 0
  },
  {
    "ph": 5,
    "nm": 750,
    "abs": 0.00028571428571428574
  },
  {
    "ph": 5.1,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 5.2,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 5.3,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 5.4,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 5.5,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 5.6,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 5.7,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 5.8,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 5.9,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 6,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 6.1,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 6.2,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 6.3,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 6.4,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 6.5,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 6.6,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 6.7,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 6.8,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 6.9,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 7,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 7.1,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 7.2,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 7.3,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 7.4,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 7.5,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 7.6,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 7.7,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 7.8,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 7.9,
    "nm": 750,
    "abs": 0
  },
  {
    "ph": 8,
    "nm": 750,
    "abs": 0
  }
]